/**
 * easy-equilibrium - Wrapper for cheminfo-js/equilibrium library to make it easier to use
 * @version v0.1.3
 * @link https://github.com/cheminfo-js/easy-equilibrium
 * @license MIT
 */
!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.easyEquilibrium=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var Equilibrium = require('chem-equilibrium');
var parser = require('./parser');
var cache = require('./cc-cache');

function EasyEq(desc) {
    this.desc = desc;
    this._init();
    this._components();
    this._species();
    this._charges();
    this._coefficients();
    this._concentrations();
    this._constants();
    this._precipitationCoefficients();
    this._precipitationConstants();

    //
    this.equilibrium = new Equilibrium({
        precipitationConstants: this.precipitationConstants || [],
        precipitationCoefficients: this.precipitationCoefficients || [[]],
        solutionConstants: this.constants,
        solutionSpeciesCharges: this.charges,
        solutionCoefficients: this.coefficients,
        totalConcentrations: this.totalConcentrations,
        fixedActivities: this.fixedConcentrations,
        randomGenerator: this.desc.randomGenerator,
        maxGuesses: this.desc.maxGuesses
    });
}

EasyEq.prototype._init = function() {
    // Check fixed parameter
    this.desc.fixed = this.desc.fixed || [];
    if(this.desc.fixed === 'none') this.desc.fixed = [];
    if(!Array.isArray(this.desc.fixed)) {
        this.desc.fixed = [this.desc.fixed];
    }

    this.Ka = {};
    this.equationsHash = {};
    var i, rname;
    this.equations = this.desc.eq.filter(function(v, i) {
        return i%2 === 0;
    });

    var constants = this.desc.eq.filter(function(v, i) {
        return i%2 === 1;
    });
    for(i=0; i<this.equations.length; i++) {
        rname = cache.norm(parser.parseReaction(this.equations[i]).reactives[0].c);
        this.Ka[rname] = constants[i];
        this.equationsHash[rname] = this.equations[i];
    }

    if(!this.desc.precipitations) return;

    this.precipitationConstants = this.desc.precipitations.filter(function(v, i) {
        return i%2 === 1;
    });
    this.precipitations = this.desc.precipitations.filter(function(v,i){
        return i%2 === 0;
    });


    for(i=0; i<this.precipitations.length; i++) {
        rname = cache.norm(parser.parseReaction(this.precipitations[i]).reactives[0].c);
    }
};

EasyEq.prototype._components = function() {
    this.components = [];
    for(var i=0; i<this.equations.length; i++) {

        var parsed = parser.parseReaction(this.equations[i]);
        if(parsed.reactives.length !== 1 || parsed.products.length !== 1) continue;
        var rname = cache.norm(parsed.reactives[0].c);
        var pname = cache.norm(parsed.products[0].c);
        if(rname !== pname) {
            console.log('continue');
            continue;
        }
        this.components.push(rname);
    }

    // Order components
    // Find fixed component
    var idx;
    if(this.desc.fixed) {
        for(var j=0; j<this.desc.fixed.length; j++) {
            var fixed = cache.norm(this.desc.fixed[j]);
            idx = this.components.indexOf(fixed);
            if(idx > -1) {
                this.components.splice(idx,1);
                this.components.push(fixed);
            }
        }

    }

    if(this.desc.solvent) {
        var solvent = cache.norm(this.desc.solvent);
        idx = this.components.indexOf(solvent);
        if(idx > -1) {
            this.components.splice(idx, 1);
            this.components.push(solvent);
        }
    }
    console.log('components', this.components);
};

EasyEq.prototype._species = function() {
    this.species = new Array(this.components.length);
    for(var i=0; i<this.components.length; i++) this.species[i] = this.components[i];

    for(i=0; i<this.equations.length; i++) {
        var parsed = parser.parseReaction(this.equations[i]);
        var rname = cache.norm(parsed.reactives[0].c);
        if(this.species.indexOf(rname) === -1) this.species.push(rname);
    }
    console.log('species', this.species);
};

EasyEq.prototype._charges = function() {
    this.charges = [];
    for(var i=0; i<this.species.length; i++) {
        var totalCharge = 0;
        var cc = cache.getCC(this.species[i]);
        for (var j = 0; j < cc.parts.length; j++) {
            totalCharge += (cc.parts[j].charge || 0);
        }
        this.charges.push(totalCharge);
    }
    console.log('charges', this.charges);
};

EasyEq.prototype._coefficients = function() {
    this.coefficients = new Array(this.species.length);
    for(var i=0; i<this.species.length; i++) {
        this.coefficients[i] = new Array(this.components.length);
        fillArray(this.coefficients[i], 0);
    }



    for(var key in this.equationsHash) {
        var idx = this.species.indexOf(key);
        if(idx === -1) throw new Error('Cannot find specie');
        var parsed = parser.parseReaction(this.equationsHash[key]);

        // Rewrite products as linear combinations of components
        var products = this._rebase(parsed.products);
        //var products = parsed.products;
        for(i=0; i<products.length; i++) {
            var product = products[i];
            var cidx = this.components.indexOf(cache.norm(product.c));
            if(cidx === -1) {
                console.log(this.components);
                throw new Error('Cannot find component ' + product.c);

            }
            this.coefficients[idx][cidx] += product.n;
        }
    }
    console.log('coefficients', this.coefficients);
};

EasyEq.prototype._rebase = function(elements) {
    var r = [];
    for(var i=0; i<elements.length; i++) {
        var replaced = false;
        var idx = this.components.indexOf(elements[i].c);
        var idxs = this.species.indexOf(elements[i].c);
        if(idx === -1 && idxs > -1) {
            var eq = this.equationsHash[this.species[idxs]];
            if(eq) {
                var parsed = parser.parseReaction(eq);
                for(var j=0; j<parsed.products.length; j++) {
                    parsed.products[j].n *= elements[i].n;
                    r.push(parsed.products[j]);
                }
                replaced = true;
            }
        }
        if(!replaced) {
            r.push(elements[i]);
        }
    }
    return r;
};

EasyEq.prototype._precipitationCoefficients = function() {
    if(!this.desc.precipitations) return;
    this.precipitationCoefficients = new Array(this.precipitations.length);
    for(var i=0; i<this.precipitations.length; i++) {
        this.precipitationCoefficients[i] = new Array(this.components.length);
        fillArray(this.precipitationCoefficients[i], 0);
    }



    for(var j=0; j<this.precipitations.length; j++) {
        var parsed = parser.parseReaction(this.precipitations[j]);
        var products = this._rebase(parsed.products);
        for(i=0; i<products.length; i++) {
            var product = products[i];
            var cidx = this.components.indexOf(cache.norm(product.c));
            if(cidx === -1) {
                console.log(this.components);
                throw new Error('Cannot find component ' + product.c);
            }
            this.precipitationCoefficients[j][cidx] += product.n;
        }
    }
    console.log('precipitation coefficients', this.precipitationCoefficients);
};

EasyEq.prototype._precipitationConstants = function() {
      if(!this.desc.precipitations) return;
    for(var i=0;i<this.precipitationConstants.length; i++) {
        // this.precipitationConstants[i] = 1/this.precipitationConstants[i];
    }
    console.log('precipitation constants', this.precipitationConstants);
 };

EasyEq.prototype._concentrations = function() {
    this.totalConcentrations = [];
    this.fixedConcentrations = [];

    for(var i=0; i<this.components.length; i++) {
        if(this.isFixed(this.components[i])) {
            this.fixedConcentrations.push(this.desc.concentrations[this.components[i]] || 0);
            continue;
        }
        if(this.isSolvent(this.components[i])) continue;
        this.totalConcentrations.push(this.desc.concentrations[this.components[i]]);
    }
    console.log('total concentrations', this.totalConcentrations);
    console.log('fixed concentrations', this.fixedConcentrations);
};

EasyEq.prototype._constants = function() {
    this.constants = new Array(this.species.length);
    for(var key in this.Ka) {
        var idx = this.species.indexOf(key);
        if(idx === -1) throw new Error('Cannot link ka to specie');
        this.constants[idx] = 1/this.Ka[key];
    }
    console.log('constants', this.constants);
};

EasyEq.prototype.isSolvent = function(c) {
    if(this.desc.solvent === undefined || this.desc.solvent === 'none'){
        return false;
    }
    var c1 = cache.norm(this.desc.solvent);
    var c2 = cache.norm(c);
    return c1 === c2;
};

EasyEq.prototype.isFixed = function(c) {
    var c1,c2;
    for(var i=0; i<this.desc.fixed.length; i++) {
        c1 = cache.norm(this.desc.fixed[i]);
        c2 = cache.norm(c);
        if(c1 === c2) return true;
    }
    return false;
};

EasyEq.prototype.hasFixed = function() {
    return this.desc.fixed !== undefined && this.desc.fixed !== 'none';
};

EasyEq.prototype.hasSolvent = function() {
    return this.desc.solvent !== undefined && this.desc.solvent !== 'none';
};

EasyEq.prototype.setEquilibriumActivity = function(c, concentration) {
    c = cache.norm(c);
    var idx = this.components.indexOf(c);
    if(idx === -1) throw new Error('Cannot set equilibrium activity of non-components');
    return this.equilibrium.setEquilibriumActivity(idx, concentration);
};

EasyEq.prototype.setTotalConcentration = function(c, concentration) {
    c = cache.norm(c);
    var idx = this.components.indexOf(c);
    if(idx === -1) throw new Error('Cannot set total concentration of non-components');
    return this.equilibrium.setTotalConcentration(idx, concentration);
};

EasyEq.prototype.calculate = function() {
    this.equilibrium.calculate.apply(this.equilibrium, arguments);
};

EasyEq.prototype.getSpeciesConcentrations = function() {
    var c = this.equilibrium.getSolutionSpeciesConcentrations();
    console.log(c.length);
    var r = {};
    for(var i=0; i< c.length; i++) {
        r[this.species[i]] = c[i];
    }
    return r;
};

EasyEq.prototype.saturationIndices = function() {
    return this.equilibrium.saturationIndices();
};

EasyEq.prototype.finalConcentrations = function() {
    return this.equilibrium.finalConcentrations();
}


function fillArray(arr, val) {
    for(var i=0; i<arr.length; i++) {
        arr[i] = val;
    }
}



module.exports = EasyEq;
},{"./cc-cache":10,"./parser":11,"chem-equilibrium":8}],2:[function(require,module,exports){
// shim for using process in browser

var process = module.exports = {};
var queue = [];
var draining = false;

function drainQueue() {
    if (draining) {
        return;
    }
    draining = true;
    var currentQueue;
    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        var i = -1;
        while (++i < len) {
            currentQueue[i]();
        }
        len = queue.length;
    }
    draining = false;
}
process.nextTick = function (fun) {
    queue.push(fun);
    if (!draining) {
        setTimeout(drainQueue, 0);
    }
};

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

// TODO(shtylman)
process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],3:[function(require,module,exports){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
},{"process/browser.js":2}],4:[function(require,module,exports){
/*
  https://github.com/banksean wrapped Makoto Matsumoto and Takuji Nishimura's code in a namespace
  so it's better encapsulated. Now you can have multiple random number generators
  and they won't stomp all over eachother's state.
  
  If you want to use this as a substitute for Math.random(), use the random()
  method like so:
  
  var m = new MersenneTwister();
  var randomNumber = m.random();
  
  You can also call the other genrand_{foo}() methods on the instance.
 
  If you want to use a specific seed in order to get a repeatable random
  sequence, pass an integer into the constructor:
 
  var m = new MersenneTwister(123);
 
  and that will always produce the same random sequence.
 
  Sean McCullough (banksean@gmail.com)
*/
 
/* 
   A C-program for MT19937, with initialization improved 2002/1/26.
   Coded by Takuji Nishimura and Makoto Matsumoto.
 
   Before using, initialize the state by using init_seed(seed)  
   or init_by_array(init_key, key_length).
 
   Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
   All rights reserved.                          
 
   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions
   are met:
 
     1. Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.
 
     2. Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.
 
     3. The names of its contributors may not be used to endorse or promote 
        products derived from this software without specific prior written 
        permission.
 
   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
   "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
   LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
   A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
   CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
   EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
   PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
   PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 
 
   Any feedback is very welcome.
   http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
   email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
*/
 
var MersenneTwister = function(seed) {
	if (seed == undefined) {
		seed = new Date().getTime();
	} 

	/* Period parameters */  
	this.N = 624;
	this.M = 397;
	this.MATRIX_A = 0x9908b0df;   /* constant vector a */
	this.UPPER_MASK = 0x80000000; /* most significant w-r bits */
	this.LOWER_MASK = 0x7fffffff; /* least significant r bits */

	this.mt = new Array(this.N); /* the array for the state vector */
	this.mti=this.N+1; /* mti==N+1 means mt[N] is not initialized */

	this.init_seed(seed);
}  

/* initializes mt[N] with a seed */
/* origin name init_genrand */
MersenneTwister.prototype.init_seed = function(s) {
	this.mt[0] = s >>> 0;
	for (this.mti=1; this.mti<this.N; this.mti++) {
		var s = this.mt[this.mti-1] ^ (this.mt[this.mti-1] >>> 30);
		this.mt[this.mti] = (((((s & 0xffff0000) >>> 16) * 1812433253) << 16) + (s & 0x0000ffff) * 1812433253)
		+ this.mti;
		/* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */
		/* In the previous versions, MSBs of the seed affect   */
		/* only MSBs of the array mt[].                        */
		/* 2002/01/09 modified by Makoto Matsumoto             */
		this.mt[this.mti] >>>= 0;
		/* for >32 bit machines */
	}
}

/* initialize by an array with array-length */
/* init_key is the array for initializing keys */
/* key_length is its length */
/* slight change for C++, 2004/2/26 */
MersenneTwister.prototype.init_by_array = function(init_key, key_length) {
	var i, j, k;
	this.init_seed(19650218);
	i=1; j=0;
	k = (this.N>key_length ? this.N : key_length);
	for (; k; k--) {
		var s = this.mt[i-1] ^ (this.mt[i-1] >>> 30)
		this.mt[i] = (this.mt[i] ^ (((((s & 0xffff0000) >>> 16) * 1664525) << 16) + ((s & 0x0000ffff) * 1664525)))
		+ init_key[j] + j; /* non linear */
		this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */
		i++; j++;
		if (i>=this.N) { this.mt[0] = this.mt[this.N-1]; i=1; }
		if (j>=key_length) j=0;
	}
	for (k=this.N-1; k; k--) {
		var s = this.mt[i-1] ^ (this.mt[i-1] >>> 30);
		this.mt[i] = (this.mt[i] ^ (((((s & 0xffff0000) >>> 16) * 1566083941) << 16) + (s & 0x0000ffff) * 1566083941))
		- i; /* non linear */
		this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */
		i++;
		if (i>=this.N) { this.mt[0] = this.mt[this.N-1]; i=1; }
	}

	this.mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */ 
}

/* generates a random number on [0,0xffffffff]-interval */
/* origin name genrand_int32 */
MersenneTwister.prototype.random_int = function() {
	var y;
	var mag01 = new Array(0x0, this.MATRIX_A);
	/* mag01[x] = x * MATRIX_A  for x=0,1 */

	if (this.mti >= this.N) { /* generate N words at one time */
		var kk;

		if (this.mti == this.N+1)  /* if init_seed() has not been called, */
			this.init_seed(5489);  /* a default initial seed is used */

		for (kk=0;kk<this.N-this.M;kk++) {
			y = (this.mt[kk]&this.UPPER_MASK)|(this.mt[kk+1]&this.LOWER_MASK);
			this.mt[kk] = this.mt[kk+this.M] ^ (y >>> 1) ^ mag01[y & 0x1];
		}
		for (;kk<this.N-1;kk++) {
			y = (this.mt[kk]&this.UPPER_MASK)|(this.mt[kk+1]&this.LOWER_MASK);
			this.mt[kk] = this.mt[kk+(this.M-this.N)] ^ (y >>> 1) ^ mag01[y & 0x1];
		}
		y = (this.mt[this.N-1]&this.UPPER_MASK)|(this.mt[0]&this.LOWER_MASK);
		this.mt[this.N-1] = this.mt[this.M-1] ^ (y >>> 1) ^ mag01[y & 0x1];

		this.mti = 0;
	}

	y = this.mt[this.mti++];

	/* Tempering */
	y ^= (y >>> 11);
	y ^= (y << 7) & 0x9d2c5680;
	y ^= (y << 15) & 0xefc60000;
	y ^= (y >>> 18);

	return y >>> 0;
}

/* generates a random number on [0,0x7fffffff]-interval */
/* origin name genrand_int31 */
MersenneTwister.prototype.random_int31 = function() {
	return (this.random_int()>>>1);
}

/* generates a random number on [0,1]-real-interval */
/* origin name genrand_real1 */
MersenneTwister.prototype.random_incl = function() {
	return this.random_int()*(1.0/4294967295.0); 
	/* divided by 2^32-1 */ 
}

/* generates a random number on [0,1)-real-interval */
MersenneTwister.prototype.random = function() {
	return this.random_int()*(1.0/4294967296.0); 
	/* divided by 2^32 */
}

/* generates a random number on (0,1)-real-interval */
/* origin name genrand_real3 */
MersenneTwister.prototype.random_excl = function() {
	return (this.random_int() + 0.5)*(1.0/4294967296.0); 
	/* divided by 2^32 */
}

/* generates a random number on [0,1) with 53-bit resolution*/
/* origin name genrand_res53 */
MersenneTwister.prototype.random_long = function() { 
	var a=this.random_int()>>>5, b=this.random_int()>>>6; 
	return(a*67108864.0+b)*(1.0/9007199254740992.0); 
} 

/* These real versions are due to Isaku Wada, 2002/01/09 added */

module.exports = MersenneTwister;

},{}],5:[function(require,module,exports){
'use strict';

var Matrix = require('./matrix');

// https://github.com/lutzroeder/Mapack/blob/master/Source/EigenvalueDecomposition.cs
function EigenvalueDecomposition(matrix) {
    matrix = Matrix.checkMatrix(matrix);
    if (!matrix.isSquare()) {
        throw new Error('Matrix is not a square matrix');
    }

    var n = matrix.columns,
        V = Matrix.zeros(n, n),
        d = new Array(n),
        e = new Array(n),
        value = matrix,
        i, j;

    if (matrix.isSymmetric()) {
        for (i = 0; i < n; i++) {
            for (j = 0; j < n; j++) {
                V[i][j] = value[i][j];
            }
        }
        tred2(n, e, d, V);
        tql2(n, e, d, V);
    }
    else {
        var H = Matrix.zeros(n, n),
            ort = new Array(n);
        for (j = 0; j < n; j++) {
            for (i = 0; i < n; i++) {
                H[i][j] = value[i][j];
            }
        }
        orthes(n, H, ort, V);
        hqr2(n, e, d, V, H);
    }

    return new EigenvalueDecompositionResult(n, e, d, V);
}

function tred2(n, e, d, V) {

    var f, g, h, i, j, k,
        hh, scale;

    for (j = 0; j < n; j++) {
        d[j] = V[n - 1][j];
    }

    for (i = n - 1; i > 0; i--) {
        scale = 0;
        h = 0;
        for (k = 0; k < i; k++) {
            scale = scale + Math.abs(d[k]);
        }

        if (scale === 0) {
            e[i] = d[i - 1];
            for (j = 0; j < i; j++) {
                d[j] = V[i - 1][j];
                V[i][j] = 0;
                V[j][i] = 0;
            }
        } else {
            for (k = 0; k < i; k++) {
                d[k] /= scale;
                h += d[k] * d[k];
            }

            f = d[i - 1];
            g = Math.sqrt(h);
            if (f > 0) {
                g = -g;
            }

            e[i] = scale * g;
            h = h - f * g;
            d[i - 1] = f - g;
            for (j = 0; j < i; j++) {
                e[j] = 0;
            }

            for (j = 0; j < i; j++) {
                f = d[j];
                V[j][i] = f;
                g = e[j] + V[j][j] * f;
                for (k = j + 1; k <= i - 1; k++) {
                    g += V[k][j] * d[k];
                    e[k] += V[k][j] * f;
                }
                e[j] = g;
            }

            f = 0;
            for (j = 0; j < i; j++) {
                e[j] /= h;
                f += e[j] * d[j];
            }

            hh = f / (h + h);
            for (j = 0; j < i; j++) {
                e[j] -= hh * d[j];
            }

            for (j = 0; j < i; j++) {
                f = d[j];
                g = e[j];
                for (k = j; k <= i - 1; k++) {
                    V[k][j] -= (f * e[k] + g * d[k]);
                }
                d[j] = V[i - 1][j];
                V[i][j] = 0;
            }
        }
        d[i] = h;
    }

    for (i = 0; i < n - 1; i++) {
        V[n - 1][i] = V[i][i];
        V[i][i] = 1;
        h = d[i + 1];
        if (h !== 0) {
            for (k = 0; k <= i; k++) {
                d[k] = V[k][i + 1] / h;
            }

            for (j = 0; j <= i; j++) {
                g = 0;
                for (k = 0; k <= i; k++) {
                    g += V[k][i + 1] * V[k][j];
                }
                for (k = 0; k <= i; k++) {
                    V[k][j] -= g * d[k];
                }
            }
        }

        for (k = 0; k <= i; k++) {
            V[k][i + 1] = 0;
        }
    }

    for (j = 0; j < n; j++) {
        d[j] = V[n - 1][j];
        V[n - 1][j] = 0;
    }

    V[n - 1][n - 1] = 1;
    e[0] = 0;
}

function tql2(n, e, d, V) {

    var g, h, i, j, k, l, m, p, r,
        dl1, c, c2, c3, el1, s, s2,
        iter;

    for (i = 1; i < n; i++) {
        e[i - 1] = e[i];
    }

    e[n - 1] = 0;

    var f = 0,
        tst1 = 0,
        eps = Math.pow(2, -52);

    for (l = 0; l < n; l++) {
        tst1 = Math.max(tst1, Math.abs(d[l]) + Math.abs(e[l]));
        m = l;
        while (m < n) {
            if (Math.abs(e[m]) <= eps * tst1) {
                break;
            }
            m++;
        }

        if (m > l) {
            iter = 0;
            do {
                iter = iter + 1;

                g = d[l];
                p = (d[l + 1] - g) / (2 * e[l]);
                r = hypotenuse(p, 1);
                if (p < 0) {
                    r = -r;
                }

                d[l] = e[l] / (p + r);
                d[l + 1] = e[l] * (p + r);
                dl1 = d[l + 1];
                h = g - d[l];
                for (i = l + 2; i < n; i++) {
                    d[i] -= h;
                }

                f = f + h;

                p = d[m];
                c = 1;
                c2 = c;
                c3 = c;
                el1 = e[l + 1];
                s = 0;
                s2 = 0;
                for (i = m - 1; i >= l; i--) {
                    c3 = c2;
                    c2 = c;
                    s2 = s;
                    g = c * e[i];
                    h = c * p;
                    r = hypotenuse(p, e[i]);
                    e[i + 1] = s * r;
                    s = e[i] / r;
                    c = p / r;
                    p = c * d[i] - s * g;
                    d[i + 1] = h + s * (c * g + s * d[i]);

                    for (k = 0; k < n; k++) {
                        h = V[k][i + 1];
                        V[k][i + 1] = s * V[k][i] + c * h;
                        V[k][i] = c * V[k][i] - s * h;
                    }
                }

                p = -s * s2 * c3 * el1 * e[l] / dl1;
                e[l] = s * p;
                d[l] = c * p;

            }
            while (Math.abs(e[l]) > eps * tst1);
        }
        d[l] = d[l] + f;
        e[l] = 0;
    }

    for (i = 0; i < n - 1; i++) {
        k = i;
        p = d[i];
        for (j = i + 1; j < n; j++) {
            if (d[j] < p) {
                k = j;
                p = d[j];
            }
        }

        if (k !== i) {
            d[k] = d[i];
            d[i] = p;
            for (j = 0; j < n; j++) {
                p = V[j][i];
                V[j][i] = V[j][k];
                V[j][k] = p;
            }
        }
    }
}

function orthes(n, H, ort, V) {

    var low = 0,
        high = n - 1,
        f, g, h, i, j, m,
        scale;

    for (m = low + 1; m <= high - 1; m++) {
        scale = 0;
        for (i = m; i <= high; i++) {
            scale = scale + Math.abs(H[i][m - 1]);
        }

        if (scale !== 0) {
            h = 0;
            for (i = high; i >= m; i--) {
                ort[i] = H[i][m - 1] / scale;
                h += ort[i] * ort[i];
            }

            g = Math.sqrt(h);
            if (ort[m] > 0) {
                g = -g;
            }

            h = h - ort[m] * g;
            ort[m] = ort[m] - g;

            for (j = m; j < n; j++) {
                f = 0;
                for (i = high; i >= m; i--) {
                    f += ort[i] * H[i][j];
                }

                f = f / h;
                for (i = m; i <= high; i++) {
                    H[i][j] -= f * ort[i];
                }
            }

            for (i = 0; i <= high; i++) {
                f = 0;
                for (j = high; j >= m; j--) {
                    f += ort[j] * H[i][j];
                }

                f = f / h;
                for (j = m; j <= high; j++) {
                    H[i][j] -= f * ort[j];
                }
            }

            ort[m] = scale * ort[m];
            H[m][m - 1] = scale * g;
        }
    }

    for (i = 0; i < n; i++) {
        for (j = 0; j < n; j++) {
            V[i][j] = (i === j ? 1 : 0);
        }
    }

    for (m = high - 1; m >= low + 1; m--) {
        if (H[m][m - 1] !== 0) {
            for (i = m + 1; i <= high; i++) {
                ort[i] = H[i][m - 1];
            }

            for (j = m; j <= high; j++) {
                g = 0;
                for (i = m; i <= high; i++) {
                    g += ort[i] * V[i][j];
                }

                g = (g / ort[m]) / H[m][m - 1];
                for (i = m; i <= high; i++) {
                    V[i][j] += g * ort[i];
                }
            }
        }
    }
}

function hqr2(nn, e, d, V, H) {
    var n = nn - 1,
        low = 0,
        high = nn - 1,
        eps = Math.pow(2, -52),
        exshift = 0,
        norm = 0,
        p = 0,
        q = 0,
        r = 0,
        s = 0,
        z = 0,
        iter = 0,
        i, j, k, l, m, t, w, x, y,
        ra, sa, vr, vi,
        notlast, cdivres;

    for (i = 0; i < nn; i++) {
        if (i < low || i > high) {
            d[i] = H[i][i];
            e[i] = 0;
        }

        for (j = Math.max(i - 1, 0); j < nn; j++) {
            norm = norm + Math.abs(H[i][j]);
        }
    }

    while (n >= low) {
        l = n;
        while (l > low) {
            s = Math.abs(H[l - 1][l - 1]) + Math.abs(H[l][l]);
            if (s === 0) {
                s = norm;
            }
            if (Math.abs(H[l][l - 1]) < eps * s) {
                break;
            }
            l--;
        }

        if (l === n) {
            H[n][n] = H[n][n] + exshift;
            d[n] = H[n][n];
            e[n] = 0;
            n--;
            iter = 0;
        } else if (l === n - 1) {
            w = H[n][n - 1] * H[n - 1][n];
            p = (H[n - 1][n - 1] - H[n][n]) / 2;
            q = p * p + w;
            z = Math.sqrt(Math.abs(q));
            H[n][n] = H[n][n] + exshift;
            H[n - 1][n - 1] = H[n - 1][n - 1] + exshift;
            x = H[n][n];

            if (q >= 0) {
                z = (p >= 0) ? (p + z) : (p - z);
                d[n - 1] = x + z;
                d[n] = d[n - 1];
                if (z !== 0) {
                    d[n] = x - w / z;
                }
                e[n - 1] = 0;
                e[n] = 0;
                x = H[n][n - 1];
                s = Math.abs(x) + Math.abs(z);
                p = x / s;
                q = z / s;
                r = Math.sqrt(p * p + q * q);
                p = p / r;
                q = q / r;

                for (j = n - 1; j < nn; j++) {
                    z = H[n - 1][j];
                    H[n - 1][j] = q * z + p * H[n][j];
                    H[n][j] = q * H[n][j] - p * z;
                }

                for (i = 0; i <= n; i++) {
                    z = H[i][n - 1];
                    H[i][n - 1] = q * z + p * H[i][n];
                    H[i][n] = q * H[i][n] - p * z;
                }

                for (i = low; i <= high; i++) {
                    z = V[i][n - 1];
                    V[i][n - 1] = q * z + p * V[i][n];
                    V[i][n] = q * V[i][n] - p * z;
                }
            } else {
                d[n - 1] = x + p;
                d[n] = x + p;
                e[n - 1] = z;
                e[n] = -z;
            }

            n = n - 2;
            iter = 0;
        } else {
            x = H[n][n];
            y = 0;
            w = 0;
            if (l < n) {
                y = H[n - 1][n - 1];
                w = H[n][n - 1] * H[n - 1][n];
            }

            if (iter === 10) {
                exshift += x;
                for (i = low; i <= n; i++) {
                    H[i][i] -= x;
                }
                s = Math.abs(H[n][n - 1]) + Math.abs(H[n - 1][n - 2]);
                x = y = 0.75 * s;
                w = -0.4375 * s * s;
            }

            if (iter === 30) {
                s = (y - x) / 2;
                s = s * s + w;
                if (s > 0) {
                    s = Math.sqrt(s);
                    if (y < x) {
                        s = -s;
                    }
                    s = x - w / ((y - x) / 2 + s);
                    for (i = low; i <= n; i++) {
                        H[i][i] -= s;
                    }
                    exshift += s;
                    x = y = w = 0.964;
                }
            }

            iter = iter + 1;

            m = n - 2;
            while (m >= l) {
                z = H[m][m];
                r = x - z;
                s = y - z;
                p = (r * s - w) / H[m + 1][m] + H[m][m + 1];
                q = H[m + 1][m + 1] - z - r - s;
                r = H[m + 2][m + 1];
                s = Math.abs(p) + Math.abs(q) + Math.abs(r);
                p = p / s;
                q = q / s;
                r = r / s;
                if (m === l) {
                    break;
                }
                if (Math.abs(H[m][m - 1]) * (Math.abs(q) + Math.abs(r)) < eps * (Math.abs(p) * (Math.abs(H[m - 1][m - 1]) + Math.abs(z) + Math.abs(H[m + 1][m + 1])))) {
                    break;
                }
                m--;
            }

            for (i = m + 2; i <= n; i++) {
                H[i][i - 2] = 0;
                if (i > m + 2) {
                    H[i][i - 3] = 0;
                }
            }

            for (k = m; k <= n - 1; k++) {
                notlast = (k !== n - 1);
                if (k !== m) {
                    p = H[k][k - 1];
                    q = H[k + 1][k - 1];
                    r = (notlast ? H[k + 2][k - 1] : 0);
                    x = Math.abs(p) + Math.abs(q) + Math.abs(r);
                    if (x !== 0) {
                        p = p / x;
                        q = q / x;
                        r = r / x;
                    }
                }

                if (x === 0) {
                    break;
                }

                s = Math.sqrt(p * p + q * q + r * r);
                if (p < 0) {
                    s = -s;
                }

                if (s !== 0) {
                    if (k !== m) {
                        H[k][k - 1] = -s * x;
                    } else if (l !== m) {
                        H[k][k - 1] = -H[k][k - 1];
                    }

                    p = p + s;
                    x = p / s;
                    y = q / s;
                    z = r / s;
                    q = q / p;
                    r = r / p;

                    for (j = k; j < nn; j++) {
                        p = H[k][j] + q * H[k + 1][j];
                        if (notlast) {
                            p = p + r * H[k + 2][j];
                            H[k + 2][j] = H[k + 2][j] - p * z;
                        }

                        H[k][j] = H[k][j] - p * x;
                        H[k + 1][j] = H[k + 1][j] - p * y;
                    }

                    for (i = 0; i <= Math.min(n, k + 3); i++) {
                        p = x * H[i][k] + y * H[i][k + 1];
                        if (notlast) {
                            p = p + z * H[i][k + 2];
                            H[i][k + 2] = H[i][k + 2] - p * r;
                        }

                        H[i][k] = H[i][k] - p;
                        H[i][k + 1] = H[i][k + 1] - p * q;
                    }

                    for (i = low; i <= high; i++) {
                        p = x * V[i][k] + y * V[i][k + 1];
                        if (notlast) {
                            p = p + z * V[i][k + 2];
                            V[i][k + 2] = V[i][k + 2] - p * r;
                        }

                        V[i][k] = V[i][k] - p;
                        V[i][k + 1] = V[i][k + 1] - p * q;
                    }
                }
            }
        }
    }

    if (norm === 0) {
        return;
    }

    for (n = nn - 1; n >= 0; n--) {
        p = d[n];
        q = e[n];

        if (q === 0) {
            l = n;
            H[n][n] = 1;
            for (i = n - 1; i >= 0; i--) {
                w = H[i][i] - p;
                r = 0;
                for (j = l; j <= n; j++) {
                    r = r + H[i][j] * H[j][n];
                }

                if (e[i] < 0) {
                    z = w;
                    s = r;
                } else {
                    l = i;
                    if (e[i] === 0) {
                        H[i][n] = (w !== 0) ? (-r / w) : (-r / (eps * norm));
                    } else {
                        x = H[i][i + 1];
                        y = H[i + 1][i];
                        q = (d[i] - p) * (d[i] - p) + e[i] * e[i];
                        t = (x * s - z * r) / q;
                        H[i][n] = t;
                        H[i + 1][n] = (Math.abs(x) > Math.abs(z)) ? ((-r - w * t) / x) : ((-s - y * t) / z);
                    }

                    t = Math.abs(H[i][n]);
                    if ((eps * t) * t > 1) {
                        for (j = i; j <= n; j++) {
                            H[j][n] = H[j][n] / t;
                        }
                    }
                }
            }
        } else if (q < 0) {
            l = n - 1;

            if (Math.abs(H[n][n - 1]) > Math.abs(H[n - 1][n])) {
                H[n - 1][n - 1] = q / H[n][n - 1];
                H[n - 1][n] = -(H[n][n] - p) / H[n][n - 1];
            } else {
                cdivres = cdiv(0, -H[n - 1][n], H[n - 1][n - 1] - p, q);
                H[n - 1][n - 1] = cdivres[0];
                H[n - 1][n] = cdivres[1];
            }

            H[n][n - 1] = 0;
            H[n][n] = 1;
            for (i = n - 2; i >= 0; i--) {
                ra = 0;
                sa = 0;
                for (j = l; j <= n; j++) {
                    ra = ra + H[i][j] * H[j][n - 1];
                    sa = sa + H[i][j] * H[j][n];
                }

                w = H[i][i] - p;

                if (e[i] < 0) {
                    z = w;
                    r = ra;
                    s = sa;
                } else {
                    l = i;
                    if (e[i] === 0) {
                        cdivres = cdiv(-ra, -sa, w, q);
                        H[i][n - 1] = cdivres[0];
                        H[i][n] = cdivres[1];
                    } else {
                        x = H[i][i + 1];
                        y = H[i + 1][i];
                        vr = (d[i] - p) * (d[i] - p) + e[i] * e[i] - q * q;
                        vi = (d[i] - p) * 2 * q;
                        if (vr === 0 && vi === 0) {
                            vr = eps * norm * (Math.abs(w) + Math.abs(q) + Math.abs(x) + Math.abs(y) + Math.abs(z));
                        }
                        cdivres = cdiv(x * r - z * ra + q * sa, x * s - z * sa - q * ra, vr, vi);
                        H[i][n - 1] = cdivres[0];
                        H[i][n] = cdivres[1];
                        if (Math.abs(x) > (Math.abs(z) + Math.abs(q))) {
                            H[i + 1][n - 1] = (-ra - w * H[i][n - 1] + q * H[i][n]) / x;
                            H[i + 1][n] = (-sa - w * H[i][n] - q * H[i][n - 1]) / x;
                        } else {
                            cdivres = cdiv(-r - y * H[i][n - 1], -s - y * H[i][n], z, q);
                            H[i + 1][n - 1] = cdivres[0];
                            H[i + 1][n] = cdivres[1];
                        }
                    }

                    t = Math.max(Math.abs(H[i][n - 1]), Math.abs(H[i][n]));
                    if ((eps * t) * t > 1) {
                        for (j = i; j <= n; j++) {
                            H[j][n - 1] = H[j][n - 1] / t;
                            H[j][n] = H[j][n] / t;
                        }
                    }
                }
            }
        }
    }

    for (i = 0; i < nn; i++) {
        if (i < low || i > high) {
            for (j = i; j < nn; j++) {
                V[i][j] = H[i][j];
            }
        }
    }

    for (j = nn - 1; j >= low; j--) {
        for (i = low; i <= high; i++) {
            z = 0;
            for (k = low; k <= Math.min(j, high); k++) {
                z = z + V[i][k] * H[k][j];
            }
            V[i][j] = z;
        }
    }
}

function cdiv(xr, xi, yr, yi) {
    var r, d;
    if (Math.abs(yr) > Math.abs(yi)) {
        r = yi / yr;
        d = yr + r * yi;
        return [(xr + r * xi) / d, (xi - r * xr) / d];
    }
    else {
        r = yr / yi;
        d = yi + r * yr;
        return [(r * xr + xi) / d, (r * xi - xr) / d];
    }
}

function EigenvalueDecompositionResult(n, e, d, V) {
    this.n = n;
    this.e = e;
    this.d = d;
    this.V = V;
}

EigenvalueDecompositionResult.prototype = {
    get realEigenvalues() {
        return this.d;
    },
    get imaginaryEigenvalues() {
        return this.e;
    },
    get eigenvectorMatrix() {
        return this.V;
    },
    get diagonalMatrix() {
        var n = this.n,
            e = this.e,
            d = this.d,
            X = new Matrix(n, n),
            i, j;
        for (i = 0; i < n; i++) {
            for (j = 0; j < n; j++) {
                X[i][j] = 0;
            }
            X[i][i] = d[i];
            if (e[i] > 0) {
                X[i][i + 1] = e[i];
            }
            else if (e[i] < 0) {
                X[i][i - 1] = e[i];
            }
        }
        return X;
    }
};

// https://github.com/lutzroeder/Mapack/blob/master/Source/LuDecomposition.cs
function LuDecomposition(matrix) {
    matrix = Matrix.checkMatrix(matrix);

    var lu = matrix.clone(),
        rows = lu.rows,
        columns = lu.columns,
        pivotVector = new Array(rows),
        pivotSign = 1,
        i, j, k, p, s, t, v,
        LUrowi, LUcolj, kmax;

    for (i = 0; i < rows; i++) {
        pivotVector[i] = i;
    }

    LUcolj = new Array(rows);

    for (j = 0; j < columns; j++) {

        for (i = 0; i < rows; i++) {
            LUcolj[i] = lu[i][j];
        }

        for (i = 0; i < rows; i++) {
            LUrowi = lu[i];
            kmax = Math.min(i, j);
            s = 0;
            for (k = 0; k < kmax; k++) {
                s += LUrowi[k] * LUcolj[k];
            }
            LUrowi[j] = LUcolj[i] -= s;
        }

        p = j;
        for (i = j + 1; i < rows; i++) {
            if (Math.abs(LUcolj[i]) > Math.abs(LUcolj[p])) {
                p = i;
            }
        }

        if (p !== j) {
            for (k = 0; k < columns; k++) {
                t = lu[p][k];
                lu[p][k] = lu[j][k];
                lu[j][k] = t;
            }

            v = pivotVector[p];
            pivotVector[p] = pivotVector[j];
            pivotVector[j] = v;

            pivotSign = -pivotSign;
        }

        if (j < rows && lu[j][j] !== 0) {
            for (i = j + 1; i < rows; i++) {
                lu[i][j] /= lu[j][j];
            }
        }
    }

    return new LuDecompositionResult(lu, pivotVector, pivotSign);

}

function LuDecompositionResult(lu, vector, sign) {
    this.LU = lu;
    this.pivotVector = vector;
    this.pivotSign = sign;
}

LuDecompositionResult.prototype = {
    isSingular: function () {
        var data = this.LU,
            col = data.columns;
        for (var j = 0; j < col; j++) {
            if (data[j][j] === 0) {
                return true;
            }
        }
        return false;
    },
    get determinant() {
        var data = this.LU;
        if (!data.isSquare())
            throw new Error('Matrix must be square');
        var determinant = this.pivotSign, col = data.columns;
        for (var j = 0; j < col; j++)
            determinant *= data[j][j];
        return determinant;
    },
    get lowerTriangularFactor() {
        var data = this.LU,
            rows = data.rows,
            columns = data.columns,
            X = new Matrix(rows, columns);
        for (var i = 0; i < rows; i++) {
            for (var j = 0; j < columns; j++) {
                if (i > j) {
                    X[i][j] = data[i][j];
                } else if (i === j) {
                    X[i][j] = 1;
                } else {
                    X[i][j] = 0;
                }
            }
        }
        return X;
    },
    get upperTriangularFactor() {
        var data = this.LU,
            rows = data.rows,
            columns = data.columns,
            X = new Matrix(rows, columns);
        for (var i = 0; i < rows; i++) {
            for (var j = 0; j < columns; j++) {
                if (i <= j) {
                    X[i][j] = data[i][j];
                } else {
                    X[i][j] = 0;
                }
            }
        }
        return X;
    },
    get pivotPermutationVector() {
        return this.pivotVector.slice();
    },
    solve: function (value) {
        value = Matrix.checkMatrix(value);

        var lu = this.LU,
            rows = lu.rows;

        if (rows !== value.rows)
            throw new Error('Invalid matrix dimensions');
        if (this.isSingular())
            throw new Error('LU matrix is singular');

        var count = value.columns,
            X = value.subMatrixRow(this.pivotVector, 0, count - 1),
            columns = lu.columns,
            i, j, k;

        for (k = 0; k < columns; k++) {
            for (i = k + 1; i < columns; i++) {
                for (j = 0; j < count; j++) {
                    X[i][j] -= X[k][j] * lu[i][k];
                }
            }
        }
        for (k = columns - 1; k >= 0; k--) {
            for (j = 0; j < count; j++) {
                X[k][j] /= lu[k][k];
            }
            for (i = 0; i < k; i++) {
                for (j = 0; j < count; j++) {
                    X[i][j] -= X[k][j] * lu[i][k];
                }
            }
        }
        return X;
    }
};

//https://github.com/lutzroeder/Mapack/blob/master/Source/QrDecomposition.cs
function QrDecomposition(value) {
    value = Matrix.checkMatrix(value)

    var qr = value.clone(),
        m = value.rows,
        n = value.columns,
        rdiag = new Array(n),
        i, j, k, s;

    for (k = 0; k < n; k++) {
        var nrm = 0;
        for (i = k; i < m; i++) {
            nrm = hypotenuse(nrm, qr[i][k]);
        }
        if (nrm !== 0) {
            if (qr[k][k] < 0) {
                nrm = -nrm;
            }
            for (i = k; i < m; i++) {
                qr[i][k] /= nrm;
            }
            qr[k][k] += 1;
            for (j = k + 1; j < n; j++) {
                s = 0;
                for (i = k; i < m; i++) {
                    s += qr[i][k] * qr[i][j];
                }
                s = -s / qr[k][k];
                for (i = k; i < m; i++) {
                    qr[i][j] += s * qr[i][k];
                }
            }
        }
        rdiag[k] = -nrm;
    }

    return new QrDecompositionResult(qr, rdiag);
}

function QrDecompositionResult(qr, rdiag) {
    this.QR = qr;
    this.Rdiag = rdiag;
}

QrDecompositionResult.prototype = {
    solve: function (value) {
        value = Matrix.checkMatrix(value);

        var qr = this.QR,
            m = qr.rows;

        if (value.rows !== m)
            throw new Error('Matrix row dimensions must agree');
        if (!this.isFullRank())
            throw new Error('Matrix is rank deficient');

        var count = value.columns,
            X = value.clone(),
            n = qr.columns,
            i, j, k, s;

        for (k = 0; k < n; k++) {
            for (j = 0; j < count; j++) {
                s = 0;
                for (i = k; i < m; i++) {
                    s += qr[i][k] * X[i][j];
                }
                s = -s / qr[k][k];
                for (i = k; i < m; i++) {
                    X[i][j] += s * qr[i][k];
                }
            }
        }
        for (k = n - 1; k >= 0; k--) {
            for (j = 0; j < count; j++) {
                X[k][j] /= this.Rdiag[k];
            }
            for (i = 0; i < k; i++) {
                for (j = 0; j < count; j++) {
                    X[i][j] -= X[k][j] * qr[i][k];
                }
            }
        }

        return X.subMatrix(0, n - 1, 0, count - 1);
    },
    isFullRank: function () {
        var columns = this.QR.columns;
        for (var i = 0; i < columns; i++) {
            if (this.Rdiag[i] === 0) {
                return false;
            }
        }
        return true;
    },
    get upperTriangularFactor() {
        var qr = this.QR,
            n = qr.columns,
            X = new Matrix(n, n),
            i, j;
        for (i = 0; i < n; i++) {
            for (j = 0; j < n; j++) {
                if (i < j) {
                    X[i][j] = qr[i][j];
                } else if (i === j) {
                    X[i][j] = this.Rdiag[i];
                } else {
                    X[i][j] = 0;
                }
            }
        }
        return X;
    },
    get orthogonalFactor() {
        var qr = this.QR,
            rows = qr.rows,
            columns = qr.columns,
            X = new Matrix(rows, columns),
            i, j, k, s;

        for (k = columns - 1; k >= 0; k--) {
            for (i = 0; i < rows; i++) {
                X[i][k] = 0;
            }
            X[k][k] = 1;
            for (j = k; j < columns; j++) {
                if (qr[k][k] !== 0) {
                    s = 0;
                    for (i = k; i < rows; i++) {
                        s += qr[i][k] * X[i][j];
                    }

                    s = -s / qr[k][k];

                    for (i = k; i < rows; i++) {
                        X[i][j] += s * qr[i][k];
                    }
                }
            }
        }
        return X;
    }
};

// https://github.com/lutzroeder/Mapack/blob/master/Source/SingularValueDecomposition.cs
function SingularValueDecomposition(value, options) {
    value = Matrix.checkMatrix(value);

    options = options || {};

    var a = value.clone(),
        m = value.rows,
        n = value.columns,
        nu = Math.min(m, n);

    var wantu = true, wantv = true;
    if (options.computeLeftSingularVectors === false)
        wantu = false;
    if (options.computeRightSingularVectors === false)
        wantv = false;
    var autoTranspose = options.autoTranspose === true;

    var swapped = false;
    if (m < n) {
        if (!autoTranspose) {
            console.warn('WARNING: Computing SVD on a matrix with more columns than rows.');
        } else {
            a = a.transpose();
            m = a.rows;
            n = a.columns;
            swapped = true;
            var aux = wantu;
            wantu = wantv;
            wantv = aux;
        }
    }

    var s = new Array(Math.min(m + 1, n)),
        U = Matrix.zeros(m, nu),
        V = Matrix.zeros(n, n),
        e = new Array(n),
        work = new Array(m);

    var nct = Math.min(m - 1, n);
    var nrt = Math.max(0, Math.min(n - 2, m));

    var i, j, k, p, t, ks, f, cs, sn, max, kase,
        scale, sp, spm1, epm1, sk, ek, b, c, shift, g;

    for (k = 0, max = Math.max(nct, nrt); k < max; k++) {
        if (k < nct) {
            s[k] = 0;
            for (i = k; i < m; i++) {
                s[k] = hypotenuse(s[k], a[i][k]);
            }
            if (s[k] !== 0) {
                if (a[k][k] < 0) {
                    s[k] = -s[k];
                }
                for (i = k; i < m; i++) {
                    a[i][k] /= s[k];
                }
                a[k][k] += 1;
            }
            s[k] = -s[k];
        }

        for (j = k + 1; j < n; j++) {
            if ((k < nct) && (s[k] !== 0)) {
                t = 0;
                for (i = k; i < m; i++) {
                    t += a[i][k] * a[i][j];
                }
                t = -t / a[k][k];
                for (i = k; i < m; i++) {
                    a[i][j] += t * a[i][k];
                }
            }
            e[j] = a[k][j];
        }

        if (wantu && (k < nct)) {
            for (i = k; i < m; i++) {
                U[i][k] = a[i][k];
            }
        }

        if (k < nrt) {
            e[k] = 0;
            for (i = k + 1; i < n; i++) {
                e[k] = hypotenuse(e[k], e[i]);
            }
            if (e[k] !== 0) {
                if (e[k + 1] < 0)
                    e[k] = -e[k];
                for (i = k + 1; i < n; i++) {
                    e[i] /= e[k];
                }
                e[k + 1] += 1;
            }
            e[k] = -e[k];
            if ((k + 1 < m) && (e[k] !== 0)) {
                for (i = k + 1; i < m; i++) {
                    work[i] = 0;
                }
                for (j = k + 1; j < n; j++) {
                    for (i = k + 1; i < m; i++) {
                        work[i] += e[j] * a[i][j];
                    }
                }
                for (j = k + 1; j < n; j++) {
                    t = -e[j] / e[k + 1];
                    for (i = k + 1; i < m; i++) {
                        a[i][j] += t * work[i];
                    }
                }
            }
            if (wantv) {
                for (i = k + 1; i < n; i++) {
                    V[i][k] = e[i];
                }
            }
        }
    }

    p = Math.min(n, m + 1);
    if (nct < n) {
        s[nct] = a[nct][nct];
    }
    if (m < p) {
        s[p - 1] = 0;
    }
    if (nrt + 1 < p) {
        e[nrt] = a[nrt][p - 1];
    }
    e[p - 1] = 0;

    if (wantu) {
        for (j = nct; j < nu; j++) {
            for (i = 0; i < m; i++) {
                U[i][j] = 0;
            }
            U[j][j] = 1;
        }
        for (k = nct - 1; k >= 0; k--) {
            if (s[k] !== 0) {
                for (j = k + 1; j < nu; j++) {
                    t = 0;
                    for (i = k; i < m; i++) {
                        t += U[i][k] * U[i][j];
                    }
                    t = -t / U[k][k];
                    for (i = k; i < m; i++) {
                        U[i][j] += t * U[i][k];
                    }
                }
                for (i = k; i < m; i++) {
                    U[i][k] = -U[i][k];
                }
                U[k][k] = 1 + U[k][k];
                for (i = 0; i < k - 1; i++) {
                    U[i][k] = 0;
                }
            } else {
                for (i = 0; i < m; i++) {
                    U[i][k] = 0;
                }
                U[k][k] = 1;
            }
        }
    }

    if (wantv) {
        for (k = n - 1; k >= 0; k--) {
            if ((k < nrt) && (e[k] !== 0)) {
                for (j = k + 1; j < n; j++) {
                    t = 0;
                    for (i = k + 1; i < n; i++) {
                        t += V[i][k] * V[i][j];
                    }
                    t = -t / V[k + 1][k];
                    for (i = k + 1; i < n; i++) {
                        V[i][j] += t * V[i][k];
                    }
                }
            }
            for (i = 0; i < n; i++) {
                V[i][k] = 0;
            }
            V[k][k] = 1;
        }
    }

    var pp = p - 1,
        iter = 0,
        eps = Math.pow(2, -52);
    while (p > 0) {
        for (k = p - 2; k >= -1; k--) {
            if (k === -1) {
                break;
            }
            if (Math.abs(e[k]) <= eps * (Math.abs(s[k]) + Math.abs(s[k + 1]))) {
                e[k] = 0;
                break;
            }
        }
        if (k === p - 2) {
            kase = 4;
        } else {
            for (ks = p - 1; ks >= k; ks--) {
                if (ks === k) {
                    break;
                }
                t = (ks !== p ? Math.abs(e[ks]) : 0) + (ks !== k + 1 ? Math.abs(e[ks - 1]) : 0);
                if (Math.abs(s[ks]) <= eps * t) {
                    s[ks] = 0;
                    break;
                }
            }
            if (ks === k) {
                kase = 3;
            } else if (ks === p - 1) {
                kase = 1;
            } else {
                kase = 2;
                k = ks;
            }
        }

        k++;

        switch (kase) {
            case 1: {
                f = e[p - 2];
                e[p - 2] = 0;
                for (j = p - 2; j >= k; j--) {
                    t = hypotenuse(s[j], f);
                    cs = s[j] / t;
                    sn = f / t;
                    s[j] = t;
                    if (j !== k) {
                        f = -sn * e[j - 1];
                        e[j - 1] = cs * e[j - 1];
                    }
                    if (wantv) {
                        for (i = 0; i < n; i++) {
                            t = cs * V[i][j] + sn * V[i][p - 1];
                            V[i][p - 1] = -sn * V[i][j] + cs * V[i][p - 1];
                            V[i][j] = t;
                        }
                    }
                }
                break;
            }
            case 2 : {
                f = e[k - 1];
                e[k - 1] = 0;
                for (j = k; j < p; j++) {
                    t = hypotenuse(s[j], f);
                    cs = s[j] / t;
                    sn = f / t;
                    s[j] = t;
                    f = -sn * e[j];
                    e[j] = cs * e[j];
                    if (wantu) {
                        for (i = 0; i < m; i++) {
                            t = cs * U[i][j] + sn * U[i][k - 1];
                            U[i][k - 1] = -sn * U[i][j] + cs * U[i][k - 1];
                            U[i][j] = t;
                        }
                    }
                }
                break;
            }
            case 3 : {
                scale = Math.max(Math.max(Math.max(Math.max(Math.abs(s[p - 1]), Math.abs(s[p - 2])), Math.abs(e[p - 2])), Math.abs(s[k])), Math.abs(e[k]));
                sp = s[p - 1] / scale;
                spm1 = s[p - 2] / scale;
                epm1 = e[p - 2] / scale;
                sk = s[k] / scale;
                ek = e[k] / scale;
                b = ((spm1 + sp) * (spm1 - sp) + epm1 * epm1) / 2;
                c = (sp * epm1) * (sp * epm1);
                shift = 0;
                if ((b !== 0) || (c !== 0)) {
                    shift = Math.sqrt(b * b + c);
                    if (b < 0) {
                        shift = -shift;
                    }
                    shift = c / (b + shift);
                }
                f = (sk + sp) * (sk - sp) + shift;
                g = sk * ek;
                for (j = k; j < p - 1; j++) {
                    t = hypotenuse(f, g);
                    cs = f / t;
                    sn = g / t;
                    if (j !== k) {
                        e[j - 1] = t;
                    }
                    f = cs * s[j] + sn * e[j];
                    e[j] = cs * e[j] - sn * s[j];
                    g = sn * s[j + 1];
                    s[j + 1] = cs * s[j + 1];
                    if (wantv) {
                        for (i = 0; i < n; i++) {
                            t = cs * V[i][j] + sn * V[i][j + 1];
                            V[i][j + 1] = -sn * V[i][j] + cs * V[i][j + 1];
                            V[i][j] = t;
                        }
                    }
                    t = hypotenuse(f, g);
                    cs = f / t;
                    sn = g / t;
                    s[j] = t;
                    f = cs * e[j] + sn * s[j + 1];
                    s[j + 1] = -sn * e[j] + cs * s[j + 1];
                    g = sn * e[j + 1];
                    e[j + 1] = cs * e[j + 1];
                    if (wantu && (j < m - 1)) {
                        for (i = 0; i < m; i++) {
                            t = cs * U[i][j] + sn * U[i][j + 1];
                            U[i][j + 1] = -sn * U[i][j] + cs * U[i][j + 1];
                            U[i][j] = t;
                        }
                    }
                }
                e[p - 2] = f;
                iter = iter + 1;
                break;
            }
            case 4: {
                if (s[k] <= 0) {
                    s[k] = (s[k] < 0 ? -s[k] : 0);
                    if (wantv) {
                        for (i = 0; i <= pp; i++) {
                            V[i][k] = -V[i][k];
                        }
                    }
                }
                while (k < pp) {
                    if (s[k] >= s[k + 1]) {
                        break;
                    }
                    t = s[k];
                    s[k] = s[k + 1];
                    s[k + 1] = t;
                    if (wantv && (k < n - 1)) {
                        for (i = 0; i < n; i++) {
                            t = V[i][k + 1];
                            V[i][k + 1] = V[i][k];
                            V[i][k] = t;
                        }
                    }
                    if (wantu && (k < m - 1)) {
                        for (i = 0; i < m; i++) {
                            t = U[i][k + 1];
                            U[i][k + 1] = U[i][k];
                            U[i][k] = t;
                        }
                    }
                    k++;
                }
                iter = 0;
                p--;
                break;
            }
        }
    }

    if (swapped) {
        var tmp = V;
        V = U;
        U = tmp;
    }

    return new SingularValueDecompositionResult(m, n, s, U, V);
}

function SingularValueDecompositionResult(m, n, s, U, V) {
    this.m = m;
    this.n = n;
    this.s = s;
    this.U = U;
    this.V = V;
}

SingularValueDecompositionResult.prototype = {
    get condition() {
        return this.s[0] / this.s[Math.min(this.m, this.n) - 1];
    },
    get norm2() {
        return this.s[0];
    },
    get rank() {
        var eps = Math.pow(2, -52),
            tol = Math.max(this.m, this.n) * this.s[0] * eps,
            r = 0,
            s = this.s;
        for (var i = 0, ii = s.length; i < ii; i++) {
            if (s[i] > tol) {
                r++;
            }
        }
        return r;
    },
    get diagonal() {
        return this.s;
    },
    // https://github.com/accord-net/framework/blob/development/Sources/Accord.Math/Decompositions/SingularValueDecomposition.cs
    get threshold() {
        return (Math.pow(2, -52) / 2) * Math.max(this.m, this.n) * this.s[0];
    },
    get leftSingularVectors() {
        return this.U;
    },
    get rightSingularVectors() {
        return this.V;
    },
    get diagonalMatrix() {
        return Matrix.diag(this.s);
    },
    solve: function (value) {

        var Y = value,
            e = this.threshold,
            scols = this.s.length,
            Ls = Matrix.zeros(scols, scols),
            i;

        for (i = 0; i < scols; i++) {
            if (Math.abs(this.s[i]) <= e) {
                Ls[i][i] = 0;
            }
            else Ls[i][i] = 1 / this.s[i];
        }


        var VL = this.V.mmul(Ls),
            vrows = this.V.rows,
            urows = this.U.rows,
            VLU = Matrix.zeros(vrows, urows),
            j, k, sum;

        for (i = 0; i < vrows; i++) {
            for (j = 0; j < urows; j++) {
                sum = 0;
                for (k = 0; k < scols; k++) {
                    sum += VL[i][k] * this.U[j][k];
                }
                VLU[i][j] = sum;
            }
        }

        return VLU.mmul(Y);
    },
    solveForDiagonal: function (value) {
        return this.solve(Matrix.diag(value));
    },
    inverse: function () {
        var e = this.threshold,
            vrows = this.V.rows,
            vcols = this.V.columns,
            X = new Matrix(vrows, this.s.length),
            i, j;

        for (i = 0; i < vrows; i++) {
            for (j = 0; j < vcols; j++) {
                if (Math.abs(this.s[j]) > e) {
                    X[i][j] = this.V[i][j] / this.s[j];
                }
            }
        }

        var urows = this.U.rows,
            ucols = this.U.columns,
            Y = new Matrix(vrows, urows),
            k, sum;

        for (i = 0; i < vrows; i++) {
            for (j = 0; j < urows; j++) {
                sum = 0;
                for (k = 0; k < ucols; k++) {
                    sum += X[i][k] * this.U[j][k];
                }
                Y[i][j] = sum;
            }
        }

        return Y;
    }
};

// https://github.com/lutzroeder/Mapack/blob/master/Source/CholeskyDecomposition.cs
function CholeskyDecomposition(value) {
    value = Matrix.checkMatrix(value);
    if (!value.isSymmetric())
        throw new Error('Matrix is not symmetric');

    var a = value,
        dimension = a.rows,
        l = new Matrix(dimension, dimension),
        positiveDefinite = true,
        i, j, k;

    for (j = 0; j < dimension; j++) {
        var Lrowj = l[j];
        var d = 0;
        for (k = 0; k < j; k++) {
            var Lrowk = l[k];
            var s = 0;
            for (i = 0; i < k; i++) {
                s += Lrowk[i] * Lrowj[i];
            }
            Lrowj[k] = s = (a[j][k] - s) / l[k][k];
            d = d + s * s;
        }

        d = a[j][j] - d;

        positiveDefinite &= (d > 0);
        l[j][j] = Math.sqrt(Math.max(d, 0));
        for (k = j + 1; k < dimension; k++) {
            l[j][k] = 0;
        }
    }

    if (!positiveDefinite) {
        throw new Error('Matrix is not positive definite');
    }

    return new CholeskyDecompositionResult(l);
}

function CholeskyDecompositionResult(l) {
    this.L = l;
}

CholeskyDecompositionResult.prototype = {
    get leftTriangularFactor() {
        return this.L;
    },
    solve: function (value) {
        value = Matrix.checkMatrix(value);

        var l = this.L,
            dimension = l.rows;

        if (value.rows !== dimension) {
            throw new Error('Matrix dimensions do not match');
        }

        var count = value.columns,
            B = value.clone(),
            i, j, k;

        for (k = 0; k < dimension; k++) {
            for (j = 0; j < count; j++) {
                for (i = 0; i < k; i++) {
                    B[k][j] -= B[i][j] * l[k][i];
                }
                B[k][j] /= l[k][k];
            }
        }

        for (k = dimension - 1; k >= 0; k--) {
            for (j = 0; j < count; j++) {
                for (i = k + 1; i < dimension; i++) {
                    B[k][j] -= B[i][j] * l[i][k];
                }
                B[k][j] /= l[k][k];
            }
        }

        return B;
    }
};

function hypotenuse(a, b) {
    var r;
    if (Math.abs(a) > Math.abs(b)) {
        r = b / a;
        return Math.abs(a) * Math.sqrt(1 + r * r);
    }
    if (b !== 0) {
        r = a / b;
        return Math.abs(b) * Math.sqrt(1 + r * r);
    }
    return 0;
}

function inverse(matrix) {
    return solve(matrix, Matrix.eye(matrix.rows));
}

Matrix.prototype.inverse = function () {
    return inverse(this);
};

function solve(leftHandSide, rightHandSide) {
    return leftHandSide.isSquare() ? new LuDecomposition(leftHandSide).solve(rightHandSide) : new QrDecomposition(leftHandSide).solve(rightHandSide);
}

Matrix.prototype.solve = function (other) {
    return solve(this, other);
};

module.exports = {
    LuDecomposition: LuDecomposition,
    LU: LuDecomposition,
    QrDecomposition: QrDecomposition,
    QR: QrDecomposition,
    SingularValueDecomposition: SingularValueDecomposition,
    SVD: SingularValueDecomposition,
    EigenvalueDecomposition: EigenvalueDecomposition,
    EVD: EigenvalueDecomposition,
    CholeskyDecomposition: CholeskyDecomposition,
    CHO: CholeskyDecomposition,
    inverse: inverse,
    solve: solve
};

},{"./matrix":7}],6:[function(require,module,exports){
'use strict';

module.exports = require('./matrix');
module.exports.Decompositions = module.exports.DC = require('./decompositions');
},{"./decompositions":5,"./matrix":7}],7:[function(require,module,exports){
'use strict';

var Asplice = Array.prototype.splice,
    Aconcat = Array.prototype.concat;

// For performance : http://jsperf.com/clone-array-slice-vs-while-vs-for
function slice(arr) {
    var i = 0,
        ii = arr.length,
        result = new Array(ii);
    for (; i < ii; i++) {
        result[i] = arr[i];
    }
    return result;
}

function MatrixError(message) {
    this.message = message || 'Unknown matrix error';
}
MatrixError.prototype = Object.create(Error.prototype);
MatrixError.prototype.name = 'MatrixError';
MatrixError.prototype.constructor = MatrixError;

/**
 * Real matrix.
 * @constructor
 * @param {number|Array} nRows - Number of rows of the new matrix or a 2D array containing the data.
 * @param {number|boolean} [nColumns] - Number of columns of the new matrix or a boolean specifying if the input array should be cloned
 */
function Matrix(nRows, nColumns) {
    var i = 0, rows, columns, matrix, newInstance;
    if (nRows instanceof Array) {
        newInstance = nColumns;
        matrix = newInstance ? slice(nRows) : nRows;
        nRows = matrix.length;
        nColumns = matrix[0].length;
        if (typeof nColumns === 'undefined') {
            throw new MatrixError('Data must be a 2D array');
        }
        if (nRows > 0 && nColumns > 0) {
            for (; i < nRows; i++) {
                if (matrix[i].length !== nColumns) {
                    throw new MatrixError('Inconsistent array dimensions');
                } else if (newInstance) {
                    matrix[i] = slice(matrix[i]);
                }
            }
        } else {
            throw new MatrixError('Invalid dimensions: ' + nRows + 'x' + nColumns);
        }
    } else if (typeof nRows === 'number') { // Create empty matrix
        if (nRows > 0 && nColumns > 0) {
            matrix = new Array(nRows);
            for (; i < nRows; i++) {
                matrix[i] = new Array(nColumns);
            }
        } else {
            throw new MatrixError('Invalid dimensions: ' + nRows + 'x' + nColumns);
        }
    } else {
        throw new MatrixError('Invalid arguments')
    }

    Object.defineProperty(matrix, 'rows', {writable: true, value: nRows});
    Object.defineProperty(matrix, 'columns', {writable: true, value: nColumns});

    matrix.__proto__ = Matrix.prototype;

    return matrix;
}

/**
 * Constructs a Matrix with the chosen dimensions from a 1D array.
 * @param {number} newRows - Number of rows
 * @param {number} newColumns - Number of columns
 * @param {Array} newData - A 1D array containing data for the matrix
 * @returns {Matrix} - The new matrix
 */
Matrix.from1DArray = function from1DArray(newRows, newColumns, newData) {
    var length, data, i = 0;

    length = newRows * newColumns;
    if (length !== newData.length)
        throw new MatrixError('Data length does not match given dimensions');

    data = new Array(newRows);
    for (; i < newRows; i++) {
        data[i] = newData.slice(i * newColumns, (i + 1) * newColumns);
    }
    return new Matrix(data);
};

/**
 * Creates a row vector, a matrix with only one row.
 * @param {Array} newData - A 1D array containing data for the vector
 * @returns {Matrix} - The new matrix
 */
Matrix.rowVector = function rowVector(newData) {
    return new Matrix([newData]);
};

/**
 * Creates a column vector, a matrix with only one column.
 * @param {Array} newData - A 1D array containing data for the vector
 * @returns {Matrix} - The new matrix
 */
Matrix.columnVector = function columnVector(newData) {
    var l = newData.length, vector = new Array(l);
    for (var i = 0; i < l; i++)
        vector[i] = [newData[i]];
    return new Matrix(vector);
};

/**
 * Creates an empty matrix with the given dimensions. Values will be undefined. Same as using new Matrix(rows, columns).
 * @param {number} rows - Number of rows
 * @param {number} columns - Number of columns
 * @returns {Matrix} - The new matrix
 */
Matrix.empty = function empty(rows, columns) {
    return new Matrix(rows, columns);
};

/**
 * Creates a matrix with the given dimensions. Values will be set to zero.
 * @param {number} rows - Number of rows
 * @param {number} columns - Number of columns
 * @returns {Matrix} - The new matrix
 */
Matrix.zeros = function zeros(rows, columns) {
    return Matrix.empty(rows, columns).fill(0);
};

/**
 * Creates a matrix with the given dimensions. Values will be set to one.
 * @param {number} rows - Number of rows
 * @param {number} columns - Number of columns
 * @returns {Matrix} - The new matrix
 */
Matrix.ones = function ones(rows, columns) {
    return Matrix.empty(rows, columns).fill(1);
};

/**
 * Creates a matrix with the given dimensions. Values will be randomly set using Math.random().
 * @param {number} rows - Number of rows
 * @param {number} columns - Number of columns
 * @returns {Matrix} The new matrix
 */
Matrix.rand = function rand(rows, columns) {
    var matrix = Matrix.empty(rows, columns);
    for (var i = 0, ii = matrix.rows; i < ii; i++) {
        for (var j = 0, jj = matrix.columns; j < jj; j++) {
            matrix[i][j] = Math.random();
        }
    }
    return matrix;
};

/**
 * Creates an identity matrix with the given dimension. Values of the diagonal will be 1 and other will be 0.
 * @param {number} n - Number of rows and columns
 * @returns {Matrix} - The new matrix
 */
Matrix.eye = function eye(n) {
    var matrix = Matrix.zeros(n, n), l = matrix.rows;
    for (var i = 0; i < l; i++) {
        matrix[i][i] = 1;
    }
    return matrix;
};

/**
 * Creates a diagonal matrix based on the given array.
 * @param {Array} data - Array containing the data for the diagonal
 * @returns {Matrix} - The new matrix
 */
Matrix.diag = function diag(data) {
    var l = data.length, matrix = Matrix.zeros(l, l);
    for (var i = 0; i < l; i++) {
        matrix[i][i] = data[i];
    }
    return matrix;
};

/**
 * Creates an array of indices between two values
 * @param {number} from
 * @param {number} to
 * @returns {Array}
 */
Matrix.indices = function indices(from, to) {
    var vector = new Array(to - from);
    for (var i = 0; i < vector.length; i++)
        vector[i] = from++;
    return vector;
};

// TODO DOC
Matrix.stack = function stack(arg1) {
    var i, j, k;
    if (Matrix.isMatrix(arg1)) {
        var rows = 0,
            cols = 0;
        for (i = 0; i < arguments.length; i++) {
            rows += arguments[i].rows;
            if (arguments[i].columns > cols)
                cols = arguments[i].columns;
        }

        var r = Matrix.zeros(rows, cols);
        var c = 0;
        for (i = 0; i < arguments.length; i++) {
            var current = arguments[i];
            for (j = 0; j < current.rows; j++) {
                for (k = 0; k < current.columns; k++)
                    r[c][k] = current[j][k];
                c++;
            }
        }
        return r;
    }
    else if (arg1 instanceof Array) {
        var matrix = Matrix.empty(arguments.length, arg1.length);
        for (i = 0; i < arguments.length; i++)
            matrix.setRow(i, arguments[i]);
        return matrix;
    }
};

// TODO DOC
Matrix.expand = function expand(base, count) {
    var expansion = [];
    for (var i = 0; i < count.length; i++)
        for (var j = 0; j < count[i]; j++)
            expansion.push(base[i]);
    return new Matrix(expansion);
};

/**
 * Check that the provided value is a Matrix and tries to instantiate one if not
 * @param value - The value to check
 * @returns {Matrix}
 * @throws {MatrixError}
 */
Matrix.checkMatrix = function checkMatrix(value) {
    if (!value) {
        throw new MatrixError('Argument has to be a matrix');
    }
    if (value.klass !== 'Matrix') {
        value = new Matrix(value);
    }
    return value;
};

/**
 * Returns true if the argument is a Matrix, false otherwise
 * @param value - The value to check
 * @returns {boolean}
 */
Matrix.isMatrix = function isMatrix(value) {
    return value ? value.klass === 'Matrix' : false;
};

/**
 * @property {string} - The name of this class.
 */
Object.defineProperty(Matrix.prototype, 'klass', {
    get: function klass() {
        return 'Matrix';
    }
});

/**
 * @property {number} - The number of elements in the matrix.
 */
Object.defineProperty(Matrix.prototype, 'size', {
    get: function size() {
        return this.rows * this.columns;
    }
});

/**
 * @private
 * Internal check that a row index is not out of bounds
 * @param {number} index
 */
Matrix.prototype.checkRowIndex = function checkRowIndex(index) {
    if (index < 0 || index > this.rows - 1)
        throw new MatrixError('Row index out of range.');
};

/**
 * @private
 * Internal check that a column index is not out of bounds
 * @param {number} index
 */
Matrix.prototype.checkColumnIndex = function checkColumnIndex(index) {
    if (index < 0 || index > this.columns - 1)
        throw new MatrixError('Column index out of range.');
};

/**
 * @private
 * Internal check that two matrices have the same dimensions
 * @param {Matrix} otherMatrix
 */
Matrix.prototype.checkDimensions = function checkDimensions(otherMatrix) {
    if ((this.rows !== otherMatrix.rows) || (this.columns !== otherMatrix.columns))
        throw new MatrixError('Matrices dimensions must be equal.');
};

/**
 * Applies a callback for each element of the matrix. The function is called in the matrix (this) context.
 * @param {function} callback - Function that will be called with two parameters : i (row) and j (column)
 * @returns {Matrix} this
 */
Matrix.prototype.apply = function apply(callback) {
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            callback.call(this, i, j);
        }
    }
    return this;
};

/**
 * Creates an exact and independent copy of the matrix
 * @returns {Matrix}
 */
Matrix.prototype.clone = function clone() {
    return new Matrix(this.to2DArray());
};

/**
 * Returns a new 1D array filled row by row with the matrix values
 * @returns {Array}
 */
Matrix.prototype.to1DArray = function to1DArray() {
    return Aconcat.apply([], this);
};

/**
 * Returns a 2D array containing a copy of the data
 * @returns {Array}
 */
Matrix.prototype.to2DArray = function to2DArray() {
    var l = this.rows, copy = new Array(l);
    for (var i = 0; i < l; i++) {
        copy[i] = slice(this[i]);
    }
    return copy;
};

/**
 * @returns {boolean} true if the matrix has one row
 */
Matrix.prototype.isRowVector = function isRowVector() {
    return this.rows === 1;
};

/**
 * @returns {boolean} true if the matrix has one column
 */
Matrix.prototype.isColumnVector = function isColumnVector() {
    return this.columns === 1;
};

/**
 * @returns {boolean} true if the matrix has one row or one column
 */
Matrix.prototype.isVector = function isVector() {
    return (this.rows === 1) || (this.columns === 1);
};

/**
 * @returns {boolean} true if the matrix has the same number of rows and columns
 */
Matrix.prototype.isSquare = function isSquare() {
    return this.rows === this.columns;
};

/**
 * @returns {boolean} true if the matrix is square and has the same values on both sides of the diagonal
 */
Matrix.prototype.isSymmetric = function isSymmetric() {
    if (this.isSquare()) {
        var l = this.rows;
        for (var i = 0; i < l; i++) {
            for (var j = 0; j <= i; j++) {
                if (this[i][j] !== this[j][i]) {
                    return false;
                }
            }
        }
        return true;
    }
    return false;
};

/**
 * Sets a given element of the matrix. mat.set(3,4,1) is equivalent to mat[3][4]=1
 * @param {number} rowIndex - Index of the row
 * @param {number} columnIndex - Index of the column
 * @param {number} value - The new value for the element
 * @returns {Matrix} this
 */
Matrix.prototype.set = function set(rowIndex, columnIndex, value) {
    this[rowIndex][columnIndex] = value;
    return this;
};

/**
 * Returns the given element of the matrix. mat.get(3,4) is equivalent to matrix[3][4]
 * @param {number} rowIndex - Index of the row
 * @param {number} columnIndex - Index of the column
 * @returns {number}
 */
Matrix.prototype.get = function get(rowIndex, columnIndex) {
    return this[rowIndex][columnIndex];
};

/**
 * Fills the matrix with a given value. All elements will be set to this value.
 * @param {number} value - New value
 * @returns {Matrix} this
 */
Matrix.prototype.fill = function fill(value) {
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] = value;
        }
    }
    return this;
};

/**
 * Negates the matrix. All elements will be multiplied by (-1)
 * @returns {Matrix} this
 */
Matrix.prototype.neg = function neg() {
    return this.mulS(-1);
};

/**
 * Adds a scalar or values from another matrix (in place)
 * @param {number|Matrix} value
 * @returns {Matrix} this
 */
Matrix.prototype.add = function add(value) {
    if (typeof value === 'number')
        return this.addS(value);
    value = Matrix.checkMatrix(value);
        return this.addM(value);
};

/**
 * Adds a scalar to each element of the matrix
 * @param {number} value
 * @returns {Matrix} this
 */
Matrix.prototype.addS = function addS(value) {
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] += value;
        }
    }
    return this;
};

/**
 * Adds the value of each element of matrix to the corresponding element of this
 * @param {Matrix} matrix
 * @returns {Matrix} this
 */
Matrix.prototype.addM = function addM(matrix) {
    this.checkDimensions(matrix);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] += matrix[i][j];
        }
    }
    return this;
};

/**
 * Subtracts a scalar or values from another matrix (in place)
 * @param {number|Matrix} value
 * @returns {Matrix} this
 */
Matrix.prototype.sub = function sub(value) {
    if (typeof value === 'number')
        return this.subS(value);
    value = Matrix.checkMatrix(value);
        return this.subM(value);
};

/**
 * Subtracts a scalar from each element of the matrix
 * @param {number} value
 * @returns {Matrix} this
 */
Matrix.prototype.subS = function subS(value) {
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] -= value;
        }
    }
    return this;
};

/**
 * Subtracts the value of each element of matrix from the corresponding element of this
 * @param {Matrix} matrix
 * @returns {Matrix} this
 */
Matrix.prototype.subM = function subM(matrix) {
    this.checkDimensions(matrix);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] -= matrix[i][j];
        }
    }
    return this;
};

/**
 * Multiplies a scalar or values from another matrix (in place)
 * @param {number|Matrix} value
 * @returns {Matrix} this
 */
Matrix.prototype.mul = function mul(value) {
    if (typeof value === 'number')
        return this.mulS(value);
    value = Matrix.checkMatrix(value);
        return this.mulM(value);
};

/**
 * Multiplies a scalar with each element of the matrix
 * @param {number} value
 * @returns {Matrix} this
 */
Matrix.prototype.mulS = function mulS(value) {
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] *= value;
        }
    }
    return this;
};

/**
 * Multiplies the value of each element of matrix with the corresponding element of this
 * @param {Matrix} matrix
 * @returns {Matrix} this
 */
Matrix.prototype.mulM = function mulM(matrix) {
    this.checkDimensions(matrix);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] *= matrix[i][j];
        }
    }
    return this;
};

/**
 * Divides by a scalar or values from another matrix (in place)
 * @param {number|Matrix} value
 * @returns {Matrix} this
 */
Matrix.prototype.div = function div(value) {
    if (typeof value === 'number')
        return this.divS(value);
    value = Matrix.checkMatrix(value);
        return this.divM(value);
};

/**
 * Divides each element of the matrix by a scalar
 * @param {number} value
 * @returns {Matrix} this
 */
Matrix.prototype.divS = function divS(value) {
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] /= value;
        }
    }
    return this;
};

/**
 * Divides each element of this by the corresponding element of matrix
 * @param {Matrix} matrix
 * @returns {Matrix} this
 */
Matrix.prototype.divM = function divM(matrix) {
    this.checkDimensions(matrix);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] /= matrix[i][j];
        }
    }
    return this;
};

/**
 * Returns a new array from the given row index
 * @param {number} index - Row index
 * @returns {Array}
 */
Matrix.prototype.getRow = function getRow(index) {
    this.checkRowIndex(index);
    return slice(this[index]);
};

/**
 * Sets a row at the given index
 * @param {number} index - Row index
 * @param {Array|Matrix} array - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.setRow = function setRow(index, array) {
    this.checkRowIndex(index);
    if (Matrix.isMatrix(array)) array = array.to1DArray();
    if (array.length !== this.columns)
        throw new MatrixError('Invalid row size');
    this[index] = slice(array);
    return this;
};

/**
 * Removes a row from the given index
 * @param {number} index - Row index
 * @returns {Matrix} this
 */
Matrix.prototype.removeRow = function removeRow(index) {
    this.checkRowIndex(index);
    if (this.rows === 1)
        throw new MatrixError('A matrix cannot have less than one row');
    Asplice.call(this, index, 1);
    this.rows -= 1;
    return this;
};

/**
 * Adds a row at the given index
 * @param {number} [index = this.rows] - Row index
 * @param {Array|Matrix} array - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.addRow = function addRow(index, array) {
    if (typeof array === 'undefined') {
        array = index;
        index = this.rows;
    }
    if (index < 0 || index > this.rows)
        throw new MatrixError('Row index out of range.');
    if (Matrix.isMatrix(array)) array = array.to1DArray();
    if (array.length !== this.columns)
        throw new MatrixError('Invalid row size');
    Asplice.call(this, index, 0, slice(array));
    this.rows += 1;
    return this;
};

/**
 * Swaps two rows
 * @param {number} row1 - First row index
 * @param {number} row2 - Second row index
 * @returns {Matrix} this
 */
Matrix.prototype.swapRows = function swapRows(row1, row2) {
    this.checkRowIndex(row1);
    this.checkRowIndex(row2);
    var temp = this[row1];
    this[row1] = this[row2];
    this[row2] = temp;
    return this;
};

/**
 * Returns a new array from the given column index
 * @param {number} index - Column index
 * @returns {Array}
 */
Matrix.prototype.getColumn = function getColumn(index) {
    this.checkColumnIndex(index);
    var l = this.rows, column = new Array(l);
    for (var i = 0; i < l; i++) {
        column[i] = this[i][index];
    }
    return column;
};

/**
 * Sets a column at the given index
 * @param {number} index - Column index
 * @param {Array|Matrix} array - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.setColumn = function setColumn(index, array) {
    this.checkColumnIndex(index);
    if (Matrix.isMatrix(array)) array = array.to1DArray();
    var l = this.rows;
    if (array.length !== l)
        throw new MatrixError('Invalid column size');
    for (var i = 0; i < l; i++) {
        this[i][index] = array[i];
    }
    return this;
};

/**
 * Removes a column from the given index
 * @param {number} index - Column index
 * @returns {Matrix} this
 */
Matrix.prototype.removeColumn = function removeColumn(index) {
    this.checkColumnIndex(index);
    if (this.columns === 1)
        throw new MatrixError('A matrix cannot have less than one column');
    for (var i = 0, ii = this.rows; i < ii; i++) {
        this[i].splice(index, 1);
    }
    this.columns -= 1;
    return this;
};

/**
 * Adds a column at the given index
 * @param {number} [index = this.columns] - Column index
 * @param {Array|Matrix} array - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.addColumn = function addColumn(index, array) {
    if (typeof array === 'undefined') {
        array = index;
        index = this.columns;
    }
    if (index < 0 || index > this.columns)
        throw new MatrixError('Column index out of range.');
    if (Matrix.isMatrix(array)) array = array.to1DArray();
    var l = this.rows;
    if (array.length !== l)
        throw new MatrixError('Invalid column size');
    for (var i = 0; i < l; i++) {
        this[i].splice(index, 0, array[i]);
    }
    this.columns += 1;
    return this;
};

/**
 * Swaps two columns
 * @param {number} column1 - First column index
 * @param {number} column2 - Second column index
 * @returns {Matrix} this
 */
Matrix.prototype.swapColumns = function swapColumns(column1, column2) {
    this.checkRowIndex(column1);
    this.checkRowIndex(column2);
    var l = this.rows, temp, row;
    for (var i = 0; i < l; i++) {
        row = this[i];
        temp = row[column1];
        row[column1] = row[column2];
        row[column2] = temp;
    }
    return this;
};

/**
 * @private
 * Internal check that the provided vector is an array with the right length
 * @param {Array|Matrix} vector
 * @returns {Array}
 * @throws {MatrixError}
 */
Matrix.prototype.checkRowVector = function checkRowVector(vector) {
    if (Matrix.isMatrix(vector))
        vector = vector.to1DArray();
    if (vector.length !== this.columns)
        throw new MatrixError('vector size must be the same as the number of columns');
    return vector;
};

/**
 * @private
 * Internal check that the provided vector is an array with the right length
 * @param {Array|Matrix} vector
 * @returns {Array}
 * @throws {MatrixError}
 */
Matrix.prototype.checkColumnVector = function checkColumnVector(vector) {
    if (Matrix.isMatrix(vector))
        vector = vector.to1DArray();
    if (vector.length !== this.rows)
        throw new MatrixError('vector size must be the same as the number of rows');
    return vector;
};

/**
 * Adds the values of a vector to each row
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.addRowVector = function addRowVector(vector) {
    vector = this.checkRowVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] += vector[j];
        }
    }
    return this;
};

/**
 * Subtracts the values of a vector from each row
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.subRowVector = function subRowVector(vector) {
    vector = this.checkRowVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] -= vector[j];
        }
    }
    return this;
};

/**
 * Multiplies the values of a vector with each row
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.mulRowVector = function mulRowVector(vector) {
    vector = this.checkRowVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] *= vector[j];
        }
    }
    return this;
};

/**
 * Divides the values of each row by those of a vector
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.divRowVector = function divRowVector(vector) {
    vector = this.checkRowVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] /= vector[j];
        }
    }
    return this;
};

/**
 * Adds the values of a vector to each column
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.addColumnVector = function addColumnVector(vector) {
    vector = this.checkColumnVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] += vector[i];
        }
    }
    return this;
};

/**
 * Subtracts the values of a vector from each column
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.subColumnVector = function subColumnVector(vector) {
    vector = this.checkColumnVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] -= vector[i];
        }
    }
    return this;
};

/**
 * Multiplies the values of a vector with each column
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.mulColumnVector = function mulColumnVector(vector) {
    vector = this.checkColumnVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] *= vector[i];
        }
    }
    return this;
};

/**
 * Divides the values of each column by those of a vector
 * @param {Array|Matrix} vector - Array or vector
 * @returns {Matrix} this
 */
Matrix.prototype.divColumnVector = function divColumnVector(vector) {
    vector = this.checkColumnVector(vector);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] /= vector[i];
        }
    }
    return this;
};

/**
 * Multiplies the values of a row with a scalar
 * @param {number} index - Row index
 * @param {number} value
 * @returns {Matrix} this
 */
Matrix.prototype.mulRow = function mulRow(index, value) {
    this.checkRowIndex(index);
    var i = 0, l = this.columns;
    for (; i < l; i++) {
        this[index][i] *= value;
    }
    return this;
};

/**
 * Multiplies the values of a column with a scalar
 * @param {number} index - Column index
 * @param {number} value
 * @returns {Matrix} this
 */
Matrix.prototype.mulColumn = function mulColumn(index, value) {
    this.checkColumnIndex(index);
    var i = 0, l = this.rows;
    for (; i < l; i++) {
        this[i][index] *= value;
    }
};

/**
 * A matrix index
 * @typedef {Object} MatrixIndex
 * @property {number} row
 * @property {number} column
 */

/**
 * Returns the maximum value of the matrix
 * @returns {number}
 */
Matrix.prototype.max = function max() {
    var v = -Infinity;
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            if (this[i][j] > v) {
                v = this[i][j];
            }
        }
    }
    return v;
};

/**
 * Returns the index of the maximum value
 * @returns {MatrixIndex}
 */
Matrix.prototype.maxIndex = function maxIndex() {
    var v = -Infinity;
    var idx = {};
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            if (this[i][j] > v) {
                v = this[i][j];
                idx.row = i;
                idx.column = j;
            }
        }
    }
    return idx;
};

/**
 * Returns the minimum value of the matrix
 * @returns {number}
 */
Matrix.prototype.min = function min() {
    var v = Infinity;
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            if (this[i][j] < v) {
                v = this[i][j];
            }
        }
    }
    return v;
};

/**
 * Returns the index of the minimum value
 * @returns {MatrixIndex}
 */
Matrix.prototype.minIndex = function minIndex() {
    var v = Infinity;
    var idx = {};
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            if (this[i][j] < v) {
                v = this[i][j];
                idx.row = i;
                idx.column = j;
            }
        }
    }
    return idx;
};

/**
 * Returns the maximum value of one row
 * @param {number} index - Row index
 * @returns {number}
 */
Matrix.prototype.maxRow = function maxRow(index) {
    this.checkRowIndex(index);
    var v = -Infinity;
    for (var i = 0, ii = this.columns; i < ii; i++) {
        if (this[index][i] > v) {
            v = this[index][i];
        }
    }
    return v;
};

/**
 * Returns the index of the maximum value of one row
 * @param {number} index - Row index
 * @returns {MatrixIndex}
 */
Matrix.prototype.maxRowIndex = function maxRowIndex(index) {
    this.checkRowIndex(index);
    var v = -Infinity;
    var idx = {
            row: index
        };
    for (var i = 0, ii = this.columns; i < ii; i++) {
        if (this[index][i] > v) {
            v = this[index][i];
            idx.column = i;
        }
    }
    return idx;
};

/**
 * Returns the minimum value of one row
 * @param {number} index - Row index
 * @returns {number}
 */
Matrix.prototype.minRow = function minRow(index) {
    this.checkRowIndex(index);
    var v = Infinity;
    for (var i = 0, ii = this.columns; i < ii; i++) {
        if (this[index][i] < v) {
            v = this[index][i];
        }
    }
    return v;
};

/**
 * Returns the index of the maximum value of one row
 * @param {number} index - Row index
 * @returns {MatrixIndex}
 */
Matrix.prototype.minRowIndex = function minRowIndex(index) {
    this.checkRowIndex(index);
    var v = Infinity;
    var idx = {
        row: index,
        column: 0
    };
    for (var i = 0, ii = this.columns; i < ii; i++) {
        if (this[index][i] < v) {
            v = this[index][i];
            idx.column = i;
        }
    }
    return idx;
};

/**
 * Returns the maximum value of one column
 * @param {number} index - Column index
 * @returns {number}
 */
Matrix.prototype.maxColumn = function maxColumn(index) {
    this.checkColumnIndex(index);
    var v = -Infinity;
    for (var i = 0, ii = this.rows; i < ii; i++) {
        if (this[i][index] > v) {
            v = this[i][index];
        }
    }
    return v;
};

/**
 * Returns the index of the maximum value of one column
 * @param {number} index - Column index
 * @returns {MatrixIndex}
 */
Matrix.prototype.maxColumnIndex = function maxColumnIndex(index) {
    this.checkColumnIndex(index);
    var v = -Infinity;
    var idx = {
        row: 0,
        column: index
    };
    for (var i = 0, ii = this.rows; i < ii; i++) {
        if (this[i][index] > v) {
            v = this[i][index];
            idx.row = i;
        }
    }
    return idx;
};

/**
 * Returns the minimum value of one column
 * @param {number} index - Column index
 * @returns {number}
 */
Matrix.prototype.minColumn = function minColumn(index) {
    this.checkColumnIndex(index);
    var v = Infinity;
    for (var i = 0, ii = this.rows; i < ii; i++) {
        if (this[i][index] < v) {
            v = this[i][index];
        }
    }
    return v;
};

/**
 * Returns the index of the minimum value of one column
 * @param {number} index - Column index
 * @returns {MatrixIndex}
 */
Matrix.prototype.minColumnIndex = function minColumnIndex(index) {
    this.checkColumnIndex(index);
    var v = Infinity;
    var idx = {
        row: 0,
        column: index
    };
    for (var i = 0, ii = this.rows; i < ii; i++) {
        if (this[i][index] < v) {
            v = this[i][index];
            idx.row = i;
        }
    }
    return idx;
};

/**
 * Returns an array containing the diagonal values of the matrix
 * @returns {Array}
 */
Matrix.prototype.diag = function diag() {
    if (!this.isSquare())
        throw new MatrixError('Only square matrices have a diagonal.');
    var diag = new Array(this.rows);
    for (var i = 0, ii = this.rows; i < ii; i++) {
        diag[i] = this[i][i];
    }
    return diag;
};

/**
 * Returns the sum of all elements of the matrix
 * @returns {number}
 */
Matrix.prototype.sum = function sum() {
    var v = 0;
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            v += this[i][j];
        }
    }
    return v;
};

/**
 * Returns the mean of all elements of the matrix
 * @returns {number}
 */
Matrix.prototype.mean = function mean() {
    return this.sum() / this.size;
};

/**
 * Returns the product of all elements of the matrix
 * @returns {number}
 */
Matrix.prototype.prod = function prod() {
    var prod = 1;
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            prod *= this[i][j];
        }
    }
    return prod;
};

/**
 * Computes the cumulative sum of the matrix elements (in place, row by row)
 * @returns {Matrix} this
 */
Matrix.prototype.cumulativeSum = function cumulativeSum() {
    var sum = 0;
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            sum += this[i][j];
            this[i][j] = sum;
        }
    }
    return this;
};

/**
 * Computes the dot (scalar) product between the matrix and another
 * @param {Matrix} other vector
 * @returns {number}
 */
Matrix.prototype.dot = function dot(other) {
    if (this.size !== other.size)
        throw new MatrixError('vectors do not have the same size');
    var vector1 = this.to1DArray();
    var vector2 = other.to1DArray();
    var dot = 0, l = vector1.length;
    for (var i = 0; i < l; i++) {
        dot += vector1[i] * vector2[i];
    }
    return dot;
};

/**
 * Returns the matrix product between this and other
 * @returns {Matrix}
 */
Matrix.prototype.mmul = function mmul(other) {
    if (this.columns !== other.rows)
        console.warn('Number of columns of left matrix are not equal to number of rows of right matrix.');

    var m = this.rows, n = this.columns, p = other.columns;
    var result = new Matrix(m, p);

    var Bcolj = new Array(n);
    var i, j, k;
    for (j = 0; j < p; j++) {
        for (k = 0; k < n; k++)
            Bcolj[k] = other[k][j];

        for (i = 0; i < m; i++) {
            var Arowi = this[i];

            var s = 0;
            for (k = 0; k < n; k++)
                s += Arowi[k] * Bcolj[k];

            result[i][j] = s;
        }
    }
    return result;
};

/**
 * Sorts the rows (in place)
 * @param {function} compareFunction - usual Array.prototype.sort comparison function
 * @returns {Matrix} this
 */
Matrix.prototype.sortRows = function sortRows(compareFunction) {
    for (var i = 0, ii = this.rows; i < ii; i++) {
        this[i].sort(compareFunction);
    }
    return this;
};

/**
 * Sorts the columns (in place)
 * @param {function} compareFunction - usual Array.prototype.sort comparison function
 * @returns {Matrix} this
 */
Matrix.prototype.sortColumns = function sortColumns(compareFunction) {
    for (var i = 0, ii = this.columns; i < ii; i++) {
        this.setColumn(i, this.getColumn(i).sort(compareFunction));
    }
    return this;
};

/**
 * Transposes the matrix and returns a new one containing the result
 * @returns {Matrix}
 */
Matrix.prototype.transpose = function transpose() {
    var result = new Matrix(this.columns, this.rows);
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            result[j][i] = this[i][j];
        }
    }
    return result;
};

/**
 * Returns a subset of the matrix
 * @param {number} startRow - First row index
 * @param {number} endRow - Last row index
 * @param {number} startColumn - First column index
 * @param {number} endColumn - Last column index
 * @returns {Matrix}
 */
Matrix.prototype.subMatrix = function subMatrix(startRow, endRow, startColumn, endColumn) {
    if ((startRow > endRow) || (startColumn > endColumn) || (startRow < 0) || (startRow >= this.rows) || (endRow < 0) || (endRow >= this.rows) || (startColumn < 0) || (startColumn >= this.columns) || (endColumn < 0) || (endColumn >= this.columns))
        throw new MatrixError('Argument out of range');
    var newMatrix = new Matrix(endRow - startRow + 1, endColumn - startColumn + 1);
    for (var i = startRow; i <= endRow; i++) {
        for (var j = startColumn; j <= endColumn; j++) {
            newMatrix[i - startRow][j - startColumn] = this[i][j];
        }
    }
    return newMatrix;
};

/**
 * Returns a subset of the matrix based on an array of row indices
 * @param {Array} indices - Array containing the row indices
 * @param {number} [startColumn = 0] - First column index
 * @param {number} [endColumn = this.columns-1] - Last column index
 * @returns {Matrix}
 */
Matrix.prototype.subMatrixRow = function subMatrixRow(indices, startColumn, endColumn) {
    if (typeof startColumn === 'undefined') {
        startColumn = 0;
        endColumn = this.columns - 1;
    } else if (typeof endColumn === 'undefined') {
        endColumn = this.columns - 1;
    }
    if ((startColumn > endColumn) || (startColumn < 0) || (startColumn >= this.columns) || (endColumn < 0) || (endColumn >= this.columns))
        throw new MatrixError('Argument out of range.');
    var l = indices.length, rows = this.rows,
        X = new Matrix(l, endColumn - startColumn + 1);
    for (var i = 0; i < l; i++) {
        for (var j = startColumn; j <= endColumn; j++) {
            if ((indices[i] < 0) || (indices[i] >= rows))
                throw new MatrixError('Argument out of range.');
            X[i][j - startColumn] = this[indices[i]][j];
        }
    }
    return X;
};

/**
 * Returns a subset of the matrix based on an array of column indices
 * @param {Array} indices - Array containing the column indices
 * @param {number} [startRow = 0] - First row index
 * @param {number} [endRow = this.rows-1] - Last row index
 * @returns {Matrix}
 */
Matrix.prototype.subMatrixColumn = function subMatrixColumn(indices, startRow, endRow) {
    if (typeof startRow === 'undefined') {
        startRow = 0;
        endRow = this.rows - 1;
    } else if (typeof endRow === 'undefined') {
        endRow = this.rows - 1;
    }
    if ((startRow > endRow) || (startRow < 0) || (startRow >= this.rows) || (endRow < 0) || (endRow >= this.rows))
        throw new MatrixError('Argument out of range.');
    var l = indices.length, columns = this.columns,
        X = new Matrix(endRow - startRow + 1, l);
    for (var i = 0; i < l; i++) {
        for (var j = startRow; j <= endRow; j++) {
            if ((indices[i] < 0) || (indices[i] >= columns))
                throw new MatrixError('Argument out of range.');
            X[j - startRow][i] = this[j][indices[i]];
        }
    }
    return X;
};

/**
 * Returns the trace of the matrix (sum of the diagonal elements)
 * @returns {number}
 */
Matrix.prototype.trace = function trace() {
    if (!this.isSquare())
        throw new MatrixError('The matrix is not square');
    var trace = 0, i = 0, l = this.rows;
    for (; i < l; i++) {
        trace += this[i][i];
    }
    return trace;
};

/**
 * Sets each element of the matrix to its absolute value
 * @returns {Matrix} this
 */
Matrix.prototype.abs = function abs() {
    var ii = this.rows, jj = this.columns;
    for (var i = 0; i < ii; i++) {
        for (var j = 0; j < jj; j++) {
            this[i][j] = Math.abs(this[i][j]);
        }
    }
};

Matrix.MatrixError = MatrixError;

module.exports = Matrix;
},{}],8:[function(require,module,exports){
'use strict';
var Matrix = require('ml-matrix');
var mersenneTwister = require('mersenne-twister');

//species are all dissolved substances in the equilibrium
//components are substances whose concentrations are independent variables determining all species concentrations
//as many formation reactions as species must be provided
//for each component, either total concentration or equilibrium concentration (to be kept fixed) must be provided. Solvent is an exception (see below)
//canonical ordering of input is key: precipitation reactions must be given last, coefficients of substances with fixed equilibrium concentrations come last
//columns of the coefficients matrix must match the elements of the equilibriumComponentConcentartions vector
//rows of the coefficients matrix must match elements of the constants vector
//first elements of constants vector must match elements of equilibriumComponentConcentrations vector
//first elements of equilibriumComponentConcentrations vector must match elements of totalComponentConcentrations vector
// the last component is a special component: the solvent. It does not have an associated mass balance equation and its activity is either set to 1
// (in which case it is a fixed activity component) or computed using Raoult's law


function EquilibriumCalculator(options) {
    // Model parameters:
    // solutionSpeciesConstants
    // solutionSpeciesCoefficients
    // solutionSpeciesCharges
    // solidSpeciesConstants
    // solidSpeciesCoefficients

    // Independent variables
    // fixedTotalComponentConcentrations
    // componentActivities
    // ionicStrength

    // Input constraints
    // totalConcentrations.length + fixedConcentrations.length must equal the number of columns in coefficients

    var concScaling, i, j;
    if(options instanceof EquilibriumCalculator) {
        var eq = options;
        this.rnd = eq.rnd;
        this.maxGuesses = eq.maxGuesses;
        this.solutionSpeciesConstants = eq.getSolutionEquilibriumConstants();
        this.solutionSpeciesCoefficients = eq.getSolutionSpeciesCoefficients();
        this.solutionSpeciesCharges = eq.getSolutionSpeciesCharges();
        this.solidSpeciesConstants = eq.getSolidEquilibriumConstants();
        this.solidSpeciesCoefficients = eq.getSolidSpeciesCoefficients();
        this.fixedTotalComponentConcentrations = eq.getFixedTotalConcentrations();
        this.componentActivities = eq.getComponentActivities();
        this.ionicStrength = eq.getIonicStrength();

        this.solidSpeciesConcentrations = eq.getSolidsConcentrations();

        this.solutionSpeciesConcentrations = eq.getSolutionSpeciesConcentrations();

        this.nSolids = eq.getNumberOfSolids();
        this.nSolutionSpecies = eq.getNumberOfSolutionSpecies();
        this.nComponents = eq.getNumberOfComponents();
        this.nFixedTotalConcentrations = eq.getNumberOfUnfixedComponents();

        this.concentrationScaling = initialize1DArray(this.nFixedTotalConcentrations);

        for (i = 0; i < this.nFixedTotalConcentrations; i++) {
            this.concentrationScaling[i] = 1.0;
            for (j = 0; j < this.nSolutionSpecies; j++) {
                if (this.solutionSpeciesCoefficients[j][i] != 0.0) {
                    concScaling = 1.0 / Math.pow(this.solutionSpeciesConstants[j], 1.0 / this.solutionSpeciesCoefficients[j][i]);
                    if (concScaling < this.concentrationScaling[i]) {
                        this.concentrationScaling[i] = concScaling;
                    }
                }
            }
            for (j = 0; j < this.nSolids; j++)
            if (this.solidSpeciesCoefficients[j][i] != 0.0) {
                concScaling = Math.pow(this.solidSpeciesConstants[j], 1.0 / this.solidSpeciesCoefficients[j][i]);
                if (concScaling < this.concentrationScaling[i])
                    this.concentrationScaling[i] = concScaling;
            }
        }
    }
    else {
        //initiate equilibrium constants, coefficients, total concentrations, and number of solids/precipitation rxns from input
        optionsAsProperties(this, options);
        if(!this.maxGuesses) this.maxGuesses = 1000;
        if(typeof options.randomGenerator === 'function') {
            this.rnd = options.randomGenerator
        }
        else if(Array.isArray(options.randomGenerator)) {
            if(options.randomGenerator[0] === 'default') {
                this.rnd = Math.random;
            }
            else if(options.randomGenerator[0] === 'seed') {
                this.rnd = rndWithSeed(options.randomGenerator[1] || 0);
            }
            else if(options.randomGenerator[0] === 'constant')
                this.rnd = constantRandom(options.randomGenerator[1] || 0.5)
        }
        else {
            if(options.randomGenerator === 'default')
                this.rnd = Math.random;
            else if(options.randomGenerator === 'seed')
                this.rnd = rndWithSeed(0);
            else if(options.randomGenerator === 'constant') {
                this.rnd = constantRandom(0.5);
            }
        }

        if(this.rnd === undefined && options.randomGenerator !== undefined) {
            console.warn('Unknown randomGenerator option, falling back to default random generator');
            this.rnd = Math.random;
        }
        else if(this.rnd === undefined) {
            this.rnd = Math.random;
        }


        this.nSolutionSpecies = this.solutionCoefficients.length;
        this.nComponents = this.solutionCoefficients[0].length;
        this.nSolids = this.precipitationConstants.length;
        this.nFixedTotalConcentrations = this.totalConcentrations.length;

        this.componentActivities = initialize1DArray(this.nComponents);
        this.solutionSpeciesConstants = this.solutionConstants;
        this.solutionSpeciesCharges = this.solutionSpeciesCharges;
        this.solutionSpeciesCoefficients = this.solutionCoefficients;
        this.solidSpeciesConstants = this.precipitationConstants;
        this.solidSpeciesCoefficients = this.precipitationCoefficients;
        this.fixedTotalComponentConcentrations = this.totalConcentrations;
        this.solidSpeciesConcentrations = initialize1DArray(this.nSolids);
        this.solutionSpeciesConcentrations = initialize1DArray(this.nSolutionSpecies);
        this.ionicStrength = 0;

        // Initiate all solids to zero
        for (i = 0; i < this.nSolids; i++) {
            this.solidSpeciesConcentrations[i] = 0.0;
        }

        this.concentrationScaling = initialize1DArray(this.nFixedTotalConcentrations);

        // compute the concentration scaling factors
        for (i = 0; i < this.nFixedTotalConcentrations; i++) {
            this.concentrationScaling[i] = 1.0;
            for (j = 0; j < this.nSolutionSpecies; j++) {
                if (this.solutionSpeciesCoefficients[j][i] != 0.0) {
                    concScaling = 1.0 / Math.pow(this.solutionSpeciesConstants[j], 1.0 / this.solutionSpeciesCoefficients[j][i]);
                    if (concScaling < this.concentrationScaling[i]) {
                        this.concentrationScaling[i] = concScaling;
                    }
                }
            }
            for (j = 0; j < this.nSolids; j++) {
                if (this.solidSpeciesCoefficients[j][i] != 0.0) {
                    concScaling = Math.pow(this.solidSpeciesConstants[j], 1.0 / this.solidSpeciesCoefficients[j][i]);
                    if (concScaling < this.concentrationScaling[i]) {
                        this.concentrationScaling[i] = concScaling;
                    }
                }
            }
        }

        //store fixed component activities at the end of the array of component activities (leave last for solvent)
        for (i = this.nFixedTotalConcentrations; i < this.nComponents - 1; i++) {
            this.componentActivities[i] = this.fixedActivities[(i - this.nFixedTotalConcentrations)];
        }
        //initial guess of variable component activities, solvent activity and ionic strength
        guess(this, true, false);
    }
}

// equilibrium concentrations of all soluble species and amount of each solid precipitated per litter of solution.
// solvent is an exception: it's activity is returned instead
EquilibriumCalculator.prototype.getComponentActivities = function() {
    return this.componentActivities.slice(0, this.nComponents);
};

EquilibriumCalculator.prototype.finalConcentrations = function() {
    var result = this.solutionSpeciesConcentrations.slice(0, this.nSolutionSpecies + this.nSolids);
    for (var i = 0; i < this.nSolids; i++) {
        result[(this.nSolutionSpecies + i)] = this.solidSpeciesConcentrations[i];
    }
    result[this.nComponents - 1] = this.componentActivities[this.nComponents - 1];
    return result;
};

EquilibriumCalculator.prototype.getSolutionSpeciesCoefficients = function() {
    return deepCopy(this.solutionSpeciesCoefficients, this.nSolutionSpecies, this.nComponents);
};



EquilibriumCalculator.prototype.getIonicStrength = function() {
    return this.ionicStrength;
};

//Return fixed total component concentrations
EquilibriumCalculator.prototype.getFixedTotalConcentrations = function() {
    return this.fixedTotalComponentConcentrations.slice(0, this.nFixedTotalConcentrations);
};

EquilibriumCalculator.prototype.getSolutionEquilibriumConstants = function() {
    return this.solutionSpeciesConstants.slice(0, this.nSolutionSpecies);
};

EquilibriumCalculator.prototype.getSolidEquilibriumConstants = function() {
    return this.solidSpeciesConstants.slice(0 , this.nSolids);
};

EquilibriumCalculator.prototype.getSolutionSpeciesCharges = function() {
    return this.solutionSpeciesCharges.slice(0, this.nSolutionSpecies);
};

EquilibriumCalculator.prototype.getSolidSpeciesCoefficients = function() {
    return deepCopy(this.solidSpeciesCoefficients, this.nSolids, this.nComponents);
};

EquilibriumCalculator.prototype.getSolidsConcentrations = function() {
    return this.solidSpeciesConcentrations.slice(0, this.nSolids);
};

EquilibriumCalculator.prototype.getSolutionSpeciesConcentrations = function() {
    return this.solutionSpeciesConcentrations.slice(0, this.nSolutionSpecies);
};

EquilibriumCalculator.prototype.getNumberOfSolutionSpecies = function() {
    return this.nSolutionSpecies;
};

EquilibriumCalculator.prototype.getNumberOfSolids = function() {
    return this.nSolids;
};

EquilibriumCalculator.prototype.getNumberOfSpecies = function() {
    return this.nSolids + this.nSolutionSpecies;
};

EquilibriumCalculator.prototype.getNumberOfComponents = function() {
    return this.nComponents;
};

EquilibriumCalculator.prototype.getNumberOfUnfixedComponents = function() {
    return this.nFixedTotalConcentrations;
};

EquilibriumCalculator.prototype.solutionSpeciesActivities = function()
{
    var result = initialize1DArray(this.nSolutionSpecies);
    //initialize non-component species activities to their formation constant
    var i, j;
    for (i = this.nComponents; i < this.nSolutionSpecies; i++) {
        result[i] = this.solutionSpeciesConstants[i];
    }
    for (i = 0; i < this.nComponents; i++) { //component activities are read directly from componentActivities array
        result[i] = this.componentActivities[i];
        for (j = this.nComponents; j < this.nSolutionSpecies; j++) { //non-component species activities are calculated from equilibrium constant expressions
            result[j] *= Math.pow(this.componentActivities[i], this.solutionSpeciesCoefficients[j][i]);
        }
    }
    return result;
};
//activity coefficients are computed using Davies' equation with A=0.5085 M^-1/2 (valid for water at 25°C)
//note that activity coefficient of solvent has no meaning
EquilibriumCalculator.prototype.solutionSpeciesActivityCoefficients = function()
{
    var result = initialize1DArray(this.nSolutionSpecies);
    var exponentialCoefficient = Math.sqrt(this.ionicStrength);
    exponentialCoefficient = (exponentialCoefficient / (1.0 + exponentialCoefficient) - 0.3 * this.ionicStrength) * -0.5085;
    for (var i = 0; i < this.nSolutionSpecies; i++) {
        result[i] = Math.exp(exponentialCoefficient * Math.pow(this.solutionSpeciesCharges[i], 2.0));
    }
    return result;
};

// note that species concentration value of solvent cannot be computed by this method, but we don't really care about it pretty much by definition.
// It is set to 0 to make sure that it is not mistakenly used in any balance
EquilibriumCalculator.prototype.calculateSolutionSpeciesConcentrations = function(correctActivities) {
    this.solutionSpeciesConcentrations = this.solutionSpeciesActivities();
    if (correctActivities) {
        var activityCoefficients = this.solutionSpeciesActivityCoefficients();
        for (var i = 0; i < this.nSolutionSpecies; i++) {
            this.solutionSpeciesConcentrations[i] /= activityCoefficients[i];
        }
        this.solutionSpeciesConcentrations[(this.nComponents - 1)] = 0.0;
    }
};

//computes the solubility products of all solid species
EquilibriumCalculator.prototype.solubilityProducts = function() {
    var result = initialize1DArray(this.nSolids);
    for (var i = 0; i < this.nSolids; i++) {
        result[i] = 1.0;
        for (var j = 0; j < this.nComponents; j++) {
            result[i] *= Math.pow(this.componentActivities[j], this.solidSpeciesCoefficients[i][j]);
        }
    }
    return result;
};

//computes the ratios between each solid's solubility product and the corresponding solubility constant
EquilibriumCalculator.prototype.saturationIndices = function()
{
    var  result = this.solubilityProducts();
    for (var i = 0; i < this.nSolids; i++) {
        result[i] /= this.solidSpeciesConstants[i];
    }
    return result;
};

//Total concentrations of ALL components but the solvent
//Computed from current activities, not read from fixedTotalComponentConcentrations
EquilibriumCalculator.prototype.totalConcentrations = function()
{
    return product(this.solutionSpeciesConcentrations, this.solutionSpeciesCoefficients, this.nSolutionSpecies, this.nComponents - 1);
};

//sets equilibrium concentration of a component
// WARNING: does not fix the given equilibrium concentration, after assignment the system iterates to equilibrium and will change the
// assigned component concentration unless it was already fixed at construction
EquilibriumCalculator.prototype.setEquilibriumActivity = function(component, value) {
    this.componentActivities[component] = value;
};

//sets the amount of a solid precipitated per litter of solution
EquilibriumCalculator.prototype.setPrecipitateConcentration = function(solid, value) {
    this.solidSpeciesConcentrations[solid] = value;
};

//set the total concentration of a component. Only allowed on components with total concentration fixed at construction
EquilibriumCalculator.prototype.setTotalConcentration = function(component, value)
{
    this.fixedTotalComponentConcentrations[component] = value;
    if (value == 0.0)
    this.componentActivities[component] = 0.0;
};

//sets the value of an equilibrium constant. Concentration scaling factors for equilibrium concentration guesses are updated after assignment.
EquilibriumCalculator.prototype.setSolutionEquilibriumConstant = function(constant, value) {
    this.solutionSpeciesConstants[constant] = value;
    var concScaling;
    for (var i = 0; i < this.nFixedTotalConcentrations; i++) {
        if (this.solutionSpeciesCoefficients[constant][i] != 0.0) {
            concScaling = 1.0 / Math.pow(value, 1.0 / this.solutionSpeciesCoefficients[constant][i]);
            if (concScaling < this.concentrationScaling[i])
                this.concentrationScaling[i] = concScaling;
        }
    }
};

//sets the value of an equilibrium constant. Concentration scaling factors for equilibrium concentration guesses are updated after assignment.
EquilibriumCalculator.prototype.setSolidEquilibriumConstant = function(constant, value)
{
    this.solidSpeciesConstants[constant] = value;
    var concScaling;
    for (var i = 0; i < this.nFixedTotalConcentrations; i++) {
        if (this.solidSpeciesCoefficients[constant][i] != 0.0) {
            concScaling = 1.0 / Math.pow(value, 1.0 / this.solidSpeciesCoefficients[constant][i]);
            if (concScaling < this.concentrationScaling[i])
                this.concentrationScaling[i] = concScaling;
        }
    }
};

EquilibriumCalculator.prototype.setIonicStrength = function(ionicStrength) {
    this.ionicStrength = ionicStrength;
};


EquilibriumCalculator.prototype.calculatedIonicStrength = function() {
    var result = 0.0;
    for (var i = 0; i < this.nSolutionSpecies; i++) {
        result += Math.pow(this.solutionSpeciesCharges[i], 2.0) * this.solutionSpeciesConcentrations[i];
    }
    return result / 2.0;
};

//shifts all solid species towards solution
//NOTE: what am i using this for?
EquilibriumCalculator.prototype.disolveAll = function(correctActivities) {
    for (var j = 0; j < this.nSolids; j++)
    disolve(this, j, correctActivities);
};

//remove the species itself
EquilibriumCalculator.prototype.removeSolutionSpecies = function(species) {
    this.nSolutionSpecies -= 1;
    var i,j;
    //if species is a component, remove all its derived species and remove it from components and coefficients arrays
    for (i = species; i < this.nSolutionSpecies; i++) {
        this.solutionSpeciesCharges[i] = this.solutionSpeciesCharges[(i + 1)];
        this.solutionSpeciesConcentrations[i] = this.solutionSpeciesConcentrations[(i + 1)];
        this.solutionSpeciesConstants[i] = this.solutionSpeciesConstants[(i + 1)];
        this.solutionSpeciesCoefficients[i] = this.solutionSpeciesCoefficients[(i + 1)];
    }

    if (species < this.nComponents) {
        //remove derived solution species
        for (i = 0; i < this.nSolutionSpecies; i++) {
            if (this.solutionSpeciesCoefficients[i][species] != 0.0) {
                this.removeSolutionSpecies(i);
                i--;
            }
            else {
                //remove from coefficients of solution reactions
                for (j = species; j < this.nComponents - 1; j++) {
                    this.solutionSpeciesCoefficients[i][j] = this.solutionSpeciesCoefficients[i][j + 1];
                }
            }
        }
        //remove derived solid species
        for (i = 0; i < this.nSolids; i++) {
            if (this.solidSpeciesCoefficients[i][species] != 0.0) {
                this.removeSolid(i);
                i--;
            }
            else { //remove from coefficients of solid reactions
                for (j = species; j < this.nComponents - 1; j++) {
                    this.solidSpeciesCoefficients[i][j] = this.solidSpeciesCoefficients[i][(j + 1)];
                }
            }
        }

        //remove the component itself
        this.nComponents -= 1;
        if (species < this.nFixedTotalConcentrations) {
            //if species is an unfixed component (unfixed activity) remove it from total concentration array as well
            this.nFixedTotalConcentrations -= 1;
            for (i = species; i < this.nFixedTotalConcentrations; i++) {
                this.fixedTotalComponentConcentrations[i] = this.fixedTotalComponentConcentrations[i + 1];
                this.componentActivities[i] = this.componentActivities[i + 1];
            }
            for (i = this.nFixedTotalConcentrations; i < this.nComponents; i++)
                this.componentActivities[i] = this.componentActivities[(i + 1)];
        }
        else
        {
            for (i = species; i < this.nComponents; i++)
                this.componentActivities[i] = this.componentActivities[(i + 1)];
        }
    }
};

EquilibriumCalculator.prototype.removeSolid = function(solid) {
    this.nSolids -= 1;
    if (this.nSolids > 0) {
        for (var i = solid; i < this.nSolids; i++) {
            this.solidSpeciesConcentrations[i] = this.solidSpeciesConcentrations[(i + 1)];
            this.solidSpeciesConstants[i] = this.solidSpeciesConstants[(i + 1)];
            this.solidSpeciesCoefficients[i] = this.solidSpeciesCoefficients[(i + 1)];
        }
    }
    else {
        this.solidSpeciesCoefficients = [[]];
        this.solidSpeciesConcentrations = [];
        this.solidSpeciesConstants = [];
    }
};

EquilibriumCalculator.prototype.addSolutionSpecies = function(){
};

EquilibriumCalculator.prototype.addSolid = function() {
};

EquilibriumCalculator.prototype.addComponent = function() {
};

//returns the equilibriumCalculator object comprising only components with non-zero total concentrations and their derived species
EquilibriumCalculator.prototype.removeZeroConcentrations = function()
{
    var result = new EquilibriumCalculator(this);
    for (var i = 0; i < result.nFixedTotalConcentrations; i++) {
        if (result.fixedTotalComponentConcentrations[i] == 0.0) {
            result.removeSolutionSpecies(i);
            i--;
        }
    }
    return result;
};

EquilibriumCalculator.prototype.calculate = function(correctActivities, fixedIonicStrength, maxIterations, precision, maxGuesses) {
    if(arguments.length === 2) {
        return this.calculate(correctActivities, fixedIonicStrength, 99999, this.maxGuesses, 0.0001);
    }
    else if(arguments.length === 4) {
        return this.calculate(correctActivities, fixedIonicStrength, maxIterations, this.maxGuesses, precision);
    }
    else if(arguments.length === 5) {
        var tmp; tmp = maxGuesses;
        maxGuesses = precision;
        precision = tmp;

        var nGuesses = 0, i, result;
        if (!correctActivities) {
            this.componentActivities[(this.nComponents - 1)] = 1.0;
        }
        while (nGuesses < maxGuesses) {
            try {
                nGuesses++;
                result = calculateOnePoint(this, correctActivities, fixedIonicStrength, maxIterations, precision);
                if (result == maxIterations) {
                    //console.log("maximum number of iterations reached, result is not trustworthy");
                }
                //console.log("Solution found will now be checked");
                while ((hasNegative(this.finalConcentrations(), this.nSolutionSpecies + this.nSolids)) && (nGuesses < maxGuesses)) {
                    nGuesses++;
                    //console.log("Inadequate solution (negative, infinite, or not a number), computing with the " + nGuesses + "th  guess");

                    guess(this, correctActivities, fixedIonicStrength);
                    result = calculateOnePoint(this, correctActivities, fixedIonicStrength, maxIterations, precision);
                    if (result == maxIterations) {
                        //console.log("maximum number of iterations reached, result is not trustworthy");
                    }
                    //console.log("Solution found will now be checked");
                }
                if (hasNegative(this.finalConcentrations(), this.nSolutionSpecies + this.nSolids)) {
                    return "No successful guess";
                }
                if (result < maxIterations) {
                    return "Adequate solution";
                }
                return "Last guess failed to converge, results might not be valid!";
            } catch (e) {
                if (nGuesses < maxGuesses) {
                    console.log(e.stack);
                    console.log("Error occurred during calculation (" + e + "), retrying with the " + (nGuesses + 1) + "th guess");
                    for (i = 0; i < this.nSolids; i++) {
                        this.solidSpeciesConcentrations[i] = 0.0;
                    }
                    guess(this, correctActivities, fixedIonicStrength);
                }

            }

        }

        console.log("Error");
        return "Error";
    }
};



// Private =======================================================

//shifts the whole precipitated mass of a solid species towards solution
//all dissolved solid is put in the form of its components. Naturally, leaves solution unbalanced
//the corresponding activities are corrected using the current ionic strength, ionic strength is not corrected for the increased solution species concentrations.
//WARNING: consequences of using on an unbalanced solution are unknown. Privatized just in case.
function disolve(ctx, solid, correctActivities) {
    for (var i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        ctx.solutionSpeciesConcentrations[i] +=
            ctx.solidSpeciesConcentrations[solid] * ctx.solidSpeciesCoefficients[solid][i];
        ctx.componentActivities[i] = ctx.solutionSpeciesConcentrations[i];
    }
    ctx.solidSpeciesConcentrations[solid] = 0.0;
    if (correctActivities) {
        var activityCoefficients = ctx.solutionSpeciesActivityCoefficients();
        for (i = 0; i < ctx.nFixedTotalConcentrations; i++)
            ctx.componentActivities[i] /= activityCoefficients[i];
    }
}

//computes solvent activity using an approximation based on raoult's law (same used by phreeqc)
function calculatedSolventActivity(ctx) {
    var result = 0.0;
    for(var i=0; i<ctx.solutionSpeciesConcentrations.length ; i++) {
        result += ctx.solutionSpeciesConcentrations[i];
    }
    return 1.0 - 0.017 * result;
}

//randomly guess equilibrium activities for the system's components and updates species concentrations, ionic strength, and solvent activity
function guess(ctx, correctActivities, fixedIonicStrength)
{
    var factor = ctx.rnd();
    //console.log('factor', factor);
    var i;
    //guess variable component activities
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
    ctx.componentActivities[i] = (ctx.fixedTotalComponentConcentrations[i] * Math.pow(ctx.concentrationScaling[i], factor));
}
    //guess ionic strength as that computed from species concentrations computed assuming ionic strength = zero and solvent activity = 1
    //guess solvent activity as that computed from species concentrations computed assuming ionic strength = zero and solvent activity = 1
    ctx.componentActivities[(ctx.nComponents - 1)] = 1.0;
    if (correctActivities) {
        if (!fixedIonicStrength) {
            ctx.ionicStrength = 0.0;
        }
        ctx.calculateSolutionSpeciesConcentrations(correctActivities);
        if (!fixedIonicStrength) {
            ctx.ionicStrength = ctx.calculatedIonicStrength();
        }
        ctx.componentActivities[(ctx.nComponents - 1)] = calculatedSolventActivity(ctx);
    }

    for (i = 0; i < ctx.nSolids; i++)
    ctx.solidSpeciesConcentrations[i] = 0.0;
}

// balance for solution components, given solid species, and ionic strength if desired
// balance equations for solution components with unfixed activities but fixed total concentrations is the difference between
// the fixed total concentration and the total concentration computed from the current equilibrium concentrations
// balance equation for ionic strength is the difference between the current ionic strength and that computed from current species concentrations
// balance equation for solids is the difference between the solubility constant and the current solubility product
function balance(ctx, correctActivities, fixedIonicStrength, solids) {
    //sub-optimal code for the sake of readability
    var solidsLength = solids.length;
    var balanceError = [];
    // initialization and activity correction-contingent balances
    if (correctActivities)
    {
        if (fixedIonicStrength) {
            balanceError = initialize1DArray(ctx.nFixedTotalConcentrations + solidsLength + 1);
        }
        else {
            balanceError = initialize1DArray(ctx.nFixedTotalConcentrations + solidsLength + 2);
            //balance of ionic strength
            balanceError[(ctx.nFixedTotalConcentrations + solidsLength + 1)] = (ctx.ionicStrength - ctx.calculatedIonicStrength());
        }
        //balance of solvent activity
        balanceError[(ctx.nFixedTotalConcentrations + solidsLength)] = (ctx.componentActivities[(ctx.nComponents - 1)] - calculatedSolventActivity(ctx));
    }
    else {
        balanceError = initialize1DArray(ctx.nFixedTotalConcentrations + solidsLength);
    }
    //balance of solution components
    //substract solution species
    balanceError = sum(balanceError, minus(ctx.fixedTotalComponentConcentrations,
        product(ctx.solutionSpeciesConcentrations, ctx.solutionSpeciesCoefficients, ctx.nSolutionSpecies, ctx.nFixedTotalConcentrations),
        ctx.nFixedTotalConcentrations), ctx.nFixedTotalConcentrations, true);

    //substract solid species
    if (ctx.nSolids > 0) {
        balanceError = minus(balanceError,
            product(ctx.solidSpeciesConcentrations, ctx.solidSpeciesCoefficients, ctx.nSolids, ctx.nFixedTotalConcentrations),
            ctx.nFixedTotalConcentrations, true);
    }

    //balance of solids
    var solubilityProducts = ctx.solubilityProducts();
    var solidIndex = ctx.nFixedTotalConcentrations;
    for (var i=0; i<solids.length; i++) {
        balanceError[solidIndex] = (ctx.solidSpeciesConstants[solids[i]] - solubilityProducts[solids[i]]);
        solidIndex++;
    }

    return balanceError;
}

function componentComponentDerivatives(ctx) {
    var i, j,k;
    var result = initialize2DArray(ctx.nFixedTotalConcentrations, ctx.nFixedTotalConcentrations);
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        for (j = 0; j < ctx.nFixedTotalConcentrations; j++) {
            result[i][j] = 0.0;
            for (k = 0; k < ctx.nSolutionSpecies; k++) {
                result[i][j] += ctx.solutionSpeciesCoefficients[k][j] * ctx.solutionSpeciesCoefficients[k][i] * ctx.solutionSpeciesConcentrations[k];
            }
            result[i][j] /= ctx.componentActivities[i];
        }
    }
    return result;
}

function componentIonicStrengthDerivatives(ctx) {
    var result = initialize1DArray(ctx.nFixedTotalConcentrations);
    var i, j;
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        result[i] = 0.0;
        for (j = 0; j < ctx.nSolutionSpecies; j++) {
            result[i] +=
                ctx.solutionSpeciesCharges[j] * ctx.solutionSpeciesCharges[j] * ctx.solutionSpeciesCoefficients[j][i] *
                ctx.solutionSpeciesConcentrations[j];
        }
        result[i] = (result[i] * 0.5085 * (1.0 / (2.0 * Math.sqrt(ctx.ionicStrength) * Math.pow(1.0 + Math.sqrt(ctx.ionicStrength), 2.0)) - 0.3));
    }
    return result;
}

function componentSolidDerivatives(ctx, solids) {
    var result = initialize2DArray(solids.length, ctx.nFixedTotalConcentrations);
    var solidIndex = 0;
    for (var j=0; j<solids.length; j++) {
        for (var i = 0; i < ctx.nFixedTotalConcentrations; i++) {
            result[solidIndex][i] = ctx.solidSpeciesCoefficients[solids[j]][i];
        }
        solidIndex++;
    }
    return result;
}

function componentSolventDerivatives(ctx) {
    var result = initialize1DArray(ctx.nFixedTotalConcentrations);
    var solventActivity = ctx.componentActivities[(ctx.nComponents - 1)];
    for (var i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        for (var j = 0; j < ctx.nSolutionSpecies; j++) {
            result[i] +=
                ctx.solutionSpeciesCoefficients[j][i] * ctx.solutionSpeciesCoefficients[j][(ctx.nComponents - 1)] * ctx.solutionSpeciesConcentrations[j];
        }
        result[i] /= solventActivity;
    }
    return result;
}

function solidComponentDerivatives(ctx, solids) {
    var result = initialize2DArray(ctx.nFixedTotalConcentrations, solids.length);
    var solubilityProducts = ctx.solubilityProducts();
    var solidIndex = 0;
    for (var j=0; j<solids.length; j++) {
        for (var i = 0; i < ctx.nFixedTotalConcentrations; i++) {
            result[i][solidIndex] = (solubilityProducts[solids[j]] * ctx.solidSpeciesCoefficients[solids[j]][i] / ctx.componentActivities[i]);
        }
        solidIndex++;
    }
    return result;
}

function solidSolventDerivatives(ctx, solids) {
    var result = initialize1DArray(solids.length);
    var solubilityProducts = ctx.solubilityProducts();
    var solventActivity = ctx.componentActivities[(ctx.nComponents - 1)];
    var solidIndex = 0;
    for (var j=0; j<solids.length; j++) {
        result[solidIndex] = (ctx.solidSpeciesCoefficients[solids[j]][(ctx.nComponents - 1)] * solubilityProducts[solids[j]] / solventActivity);
        solidIndex++;
    }
    return result;
}

function ionicStrengthComponentDerivatives(ctx) {
    var result = initialize1DArray(ctx.nFixedTotalConcentrations);
    var i,j;
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        result[i] = 0.0;
        for (j = 0; j < ctx.nSolutionSpecies; j++) {
            result[i] +=
                ctx.solutionSpeciesCharges[j] * ctx.solutionSpeciesCharges[j] * ctx.solutionSpeciesCoefficients[j][i] *
                ctx.solutionSpeciesConcentrations[j];
        }
        result[i] /= 2.0 * ctx.componentActivities[i];
    }
    return result;
}

function ionicStrengthIonicStrengthDerivative(ctx) {
    var result = 0.0;
    var i;
    for (i = 0; i < ctx.nSolutionSpecies; i++) {
        result += Math.pow(ctx.solutionSpeciesCharges[i], 4.0) * ctx.solutionSpeciesConcentrations[i];
    }
    result = result * 0.25425 * (1.0 / (2.0 * Math.sqrt(ctx.ionicStrength) * Math.pow(1.0 + Math.sqrt(ctx.ionicStrength), 2.0)) - 0.3) - 1.0;
    return result;
}

function ionicStrengthSolventDerivative(ctx) {
    var result = 0.0;
    var i;
    for (i = 0; i < ctx.nSolutionSpecies; i++) {
        result += Math.pow(ctx.solutionSpeciesCharges[i], 2.0) * ctx.solutionSpeciesCoefficients[i][(ctx.nComponents - 1)] * ctx.solutionSpeciesConcentrations[i];
    }
    return result / (ctx.componentActivities[(ctx.nComponents - 1)] * 2.0);
}

function solventComponentsDerivatives(ctx) {
    var result = initialize1DArray(ctx.nFixedTotalConcentrations);
    var i,j;
    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        for (j = 0; j < ctx.nSolutionSpecies; j++) {
            result[i] += ctx.solutionSpeciesCoefficients[j][i] * ctx.solutionSpeciesConcentrations[j];
        }
        result[i] = (result[i] * 0.017 / ctx.componentActivities[i]);
    }
    return result;
}

function solventIonicStrengthDerivative(ctx) {
    var result = 0.0;
    var i;
    for (i = 0; i < ctx.nSolutionSpecies; i++) {
        result += Math.pow(ctx.solutionSpeciesCharges[i], 2.0) * ctx.solutionSpeciesConcentrations[i];
    }
    return result * -0.017 * 0.5085 * (1.0 / (2.0 * Math.sqrt(ctx.ionicStrength) * Math.pow(1.0 + Math.sqrt(ctx.ionicStrength), 2.0)) - 0.3);
}

function solventSolventDerivative(ctx) {
    var result = 0.0;
    for (var i = 0; i < ctx.nSolutionSpecies; i++) {
        result += ctx.solutionSpeciesConcentrations[i];
    }
    return -1.0 - result * 0.017;
}

// Jacobian of balance
// actually it returns jacobian * -1
function balanceJacobian(ctx, correctActivities, fixedIonicStrength, solids) {
    //derivatives are calculated using the adequate methods (or trivially if that is the case) and then copied in the adequate blocks of the jacobian
    var componentComponent = componentComponentDerivatives(ctx);
    var componentSolid = componentSolidDerivatives(ctx, solids);
    var solidComponent = solidComponentDerivatives(ctx, solids);
    var solidsLength = solids.length;
    var jacobian = [[]];
    var i, j;

    //reserve the correct amount of space for the jacobian and compute activity correction-contingent elements
    if (correctActivities)
    {
        if (fixedIonicStrength) {
            jacobian = initialize2DArray(ctx.nFixedTotalConcentrations + solidsLength + 1,ctx.nFixedTotalConcentrations + solidsLength + 1);
        }
        else {
            jacobian = initialize2DArray(ctx.nFixedTotalConcentrations + solidsLength + 2,ctx.nFixedTotalConcentrations + solidsLength + 2);
            var ionicComponent = ionicStrengthComponentDerivatives(ctx);
            var componentIonic = componentIonicStrengthDerivatives(ctx);

            //copy ionic strength - component and component -ionic strength derivatives
            for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
                jacobian[i][(ctx.nFixedTotalConcentrations + solidsLength + 1)] = ionicComponent[i];
                jacobian[(ctx.nFixedTotalConcentrations + solidsLength + 1)][i] = componentIonic[i];
            }

            //copy ionic strength - solid and solid - ionic strength derivatives
            for (i = 0; i < solidsLength; i++) {
                jacobian[i][(ctx.nFixedTotalConcentrations + solidsLength + 1)] = 0.0;
                jacobian[(ctx.nFixedTotalConcentrations + solidsLength + 1)][i] = 0.0;
            }

            //ionic strength - ionic strength derivative
            jacobian[(ctx.nFixedTotalConcentrations + solidsLength + 1)][(ctx.nFixedTotalConcentrations + solidsLength + 1)] = ionicStrengthIonicStrengthDerivative(ctx);

            //ionic strength - solvent and solvent - ionic strength derivatives
            jacobian[(ctx.nFixedTotalConcentrations + solidsLength + 1)][(ctx.nFixedTotalConcentrations + solidsLength)] = solventIonicStrengthDerivative(ctx);
            jacobian[(ctx.nFixedTotalConcentrations + solidsLength)][(ctx.nFixedTotalConcentrations + solidsLength + 1)] = ionicStrengthSolventDerivative(ctx);
        }
        var solventComponent = solventComponentsDerivatives(ctx);
        var componentSolvent = componentSolventDerivatives(ctx);
        var solidSolvent = solidSolventDerivatives(ctx, solids);

        //copy solvent-component and component-solvent derivatives
        for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        jacobian[i][(ctx.nFixedTotalConcentrations + solidsLength)] = solventComponent[i];
        jacobian[(ctx.nFixedTotalConcentrations + solidsLength)][i] = componentSolvent[i];
    }

        //copy solid-solvent derivatives and set solvent-solid derivatives to zero
        for (i = 0; i < solidsLength; i++) {
        jacobian[(ctx.nFixedTotalConcentrations + solidsLength)][(i + ctx.nFixedTotalConcentrations)] = solidSolvent[i];
        jacobian[(i + ctx.nFixedTotalConcentrations)][(ctx.nFixedTotalConcentrations + solidsLength)] = 0.0;
    }
        //solvent - solvent derivative
        jacobian[(ctx.nFixedTotalConcentrations + solidsLength)][(ctx.nFixedTotalConcentrations + solidsLength)] = solventSolventDerivative(ctx);
    }
    else {
        jacobian = initialize2DArray(ctx.nFixedTotalConcentrations + solidsLength, ctx.nFixedTotalConcentrations + solidsLength);
    }

    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        //copy component - component derivatives
        for (j = i; j < ctx.nFixedTotalConcentrations; j++) {
        jacobian[i][j] = componentComponent[i][j];
        jacobian[j][i] = componentComponent[j][i];
    }

        //copy component - solid and solid - component derivatives
        for (j = 0; j < solidsLength; j++) {
        jacobian[i][(ctx.nFixedTotalConcentrations + j)] = solidComponent[i][j];
        jacobian[(ctx.nFixedTotalConcentrations + j)][i] = componentSolid[j][i];
    }
    }

    //copy solid - solid derivatives (zero-valued)
    for (i = 0; i < solidsLength; i++) {
        for (j = i; j < solidsLength; j++) {
            jacobian[(ctx.nFixedTotalConcentrations + i)][(ctx.nFixedTotalConcentrations + j)] = 0.0;
            jacobian[(ctx.nFixedTotalConcentrations + j)][(ctx.nFixedTotalConcentrations + i)] = 0.0;
        }
    }
    return jacobian;
}

function equilibrateNoSolids(ctx, correctActivities, fixedIonicStrength, maxIterations, precision) {
    var noSolids = [];
    return equilibrate(ctx, correctActivities, fixedIonicStrength, noSolids, maxIterations, precision);
}

//WARNING unwarranted behavior if correctActivities=false and fixedIonicStrength=true. Prevent such ocurrence in the public method
//Returns the number of iterations run
function equilibrate(ctx, correctActivities, fixedIonicStrength, solids, maxIterations, precision) {
    if(arguments.length <= 5) return equilibrateNoSolids.apply(null, arguments);
    if (hasZero(ctx.fixedTotalComponentConcentrations, ctx.nFixedTotalConcentrations)) {
        var reducedSystem = ctx.removeZeroConcentrations();
        var result = equilibrate(reducedSystem, correctActivities, fixedIonicStrength, solids, maxIterations, precision);

        //copy solution species concentrations
        var i, j,k = 0, present;

        var solutionConcentrations = reducedSystem.getSolutionSpeciesConcentrations();
        for (i = 0; i < ctx.nSolutionSpecies; i++) {
            present = true;
            for (j = 0; j < ctx.nComponents; j++) { //nFixedTotalConcentrations?
                if ((ctx.solutionSpeciesCoefficients[i][j] != 0.0) && (ctx.componentActivities[j] == 0.0)) {
                    present = false;
                    ctx.solutionSpeciesConcentrations[i] = 0.0;
                    break;
                }
            }
            if (present) {
                ctx.solutionSpeciesConcentrations[i] = solutionConcentrations[k];
                k++;
            }
        }

        //copy solid species concentrations
        k = 0;
        var solidConcentrations = reducedSystem.getSolidsConcentrations();
        for (i = 0; i < ctx.nSolids; i++) {
            present = true;
            for (j = 0; j < ctx.nComponents; j++) {
                if ((ctx.solidSpeciesCoefficients[i][j] != 0.0) && (ctx.componentActivities[j] == 0.0)) {
                    present = false;
                    ctx.solidSpeciesConcentrations[i] = 0.0;
                    break;
                }
            }
            if (present) {
                ctx.solidSpeciesConcentrations[i] = solidConcentrations[k];
                k++;
            }
        }

        //copy component activities
        var nonZeroEquilibriumActivities = reducedSystem.getComponentActivities();
        k = 0;
        for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
            if (ctx.fixedTotalComponentConcentrations[i] != 0.0) {
                ctx.componentActivities[i] = nonZeroEquilibriumActivities[k];
                k++;
            }
        }

        //copy ionic strength
        if (correctActivities) {
            ctx.ionicStrength = reducedSystem.getIonicStrength();
        }
        return result;
    }

    var iterations = 1;
    var solidsLength = solids.length;

    //species concentrations must be updated before balancing
    ctx.calculateSolutionSpeciesConcentrations(correctActivities);
    var totalError = balance(ctx, correctActivities, fixedIonicStrength, solids);

    //last condition in the while statement (second term of the or) may be unnecessary... or, on the contrary, a similar condition on solution species may be necessary
    while ((iterations <= maxIterations) && (maximumRelativeError(ctx, totalError, solids, correctActivities, fixedIonicStrength) > precision))
    {
        var jacobian = new Matrix(balanceJacobian(ctx, correctActivities, fixedIonicStrength, solids));
        var inverseJacobian = jacobian.inverse().to2DArray();
        var shifts;
        //computation of shift vector with an adequately sized product and activity correction-contingent shifts
        if (correctActivities)
        {
            if (fixedIonicStrength) {
                shifts = product(totalError, inverseJacobian, ctx.nFixedTotalConcentrations + solidsLength + 1, ctx.nFixedTotalConcentrations + solidsLength + 1);
            }
            else {
                shifts = product(totalError, inverseJacobian, ctx.nFixedTotalConcentrations + solidsLength + 2, ctx.nFixedTotalConcentrations + solidsLength + 2);
                //shift ionic strength
                ctx.ionicStrength += shifts[(ctx.nFixedTotalConcentrations + solidsLength + 1)];
            }

            //shift solvent activity
            ctx.componentActivities[(ctx.nComponents - 1)] += shifts[(ctx.nFixedTotalConcentrations + solidsLength)];
        }
        else {
            shifts = product(totalError, inverseJacobian, ctx.nFixedTotalConcentrations + solidsLength, ctx.nFixedTotalConcentrations + solidsLength);
        }

        //shift component activities
        ctx.componentActivities = sum(ctx.componentActivities, shifts, ctx.nFixedTotalConcentrations, true);

        var solidIndex = ctx.nFixedTotalConcentrations;
        for (i=0; i<solids.length; i++) {
        ctx.solidSpeciesConcentrations[solids[i]] += shifts[solidIndex];
        solidIndex++;
    }

        //update species concentrations
        ctx.calculateSolutionSpeciesConcentrations(correctActivities);
        totalError = balance(ctx, correctActivities, fixedIonicStrength, solids);
        iterations++;
    }
    if (iterations === 1) {
        //console.log("Equilibrium reached after " + iterations + " iterations");
        return iterations;
    }
    if (iterations > maxIterations) {
        //console.log("maximum number of iterations reached without convergence");
    }
    else {
        //console.log("Equilibrium reached after " + (iterations - 1) + " iterations");
    }
    return iterations - 1;
}

//relative error on total concentrations
function maximumRelativeError(ctx, errors, solids, correctActivities, fixedIonicStrength) {
    var  maxError = 0.0, i;

    for (i = 0; i < ctx.nFixedTotalConcentrations; i++) {
        maxError = Math.max(maxError, Math.abs(errors[i] / ctx.fixedTotalComponentConcentrations[i]));
    }
    var solidIndex = ctx.nFixedTotalConcentrations;

    //relative error on solid solubility products
    for (i=0; i<solids.length; i++) {
        maxError = Math.max(maxError, Math.abs(errors[solidIndex] / ctx.solidSpeciesConstants[solids[i]]));
        solidIndex++;
    }
    if (correctActivities) {
        //relative error on solvent activity
        maxError = Math.max(maxError, Math.abs(errors[solidIndex] / ctx.componentActivities[(ctx.nComponents - 1)]));
        if (!fixedIonicStrength) {
            //relative error on ionic strength
            maxError = Math.max(maxError, Math.abs(errors[(solidIndex + 1)] / ctx.ionicStrength));
        }
    }
    return maxError;
}

function mostInsoluble(ctx) {
    var saturationIndices = ctx.saturationIndices();
    var result = 0, i;
    for (i = 0; i < ctx.nSolids; i++) {
        if (saturationIndices[i] > saturationIndices[result]) {
            result = i;
        }
    }
    return result;
}

//returns the number of iterations in the last run of equilibrate (the one that ends with no oversaturated/insaturated solid) or
//maxIterations if maximum number of precipitation cycles was exausted
function calculateOnePoint(ctx, correctActivities, fixedIonicStrength, maxIterations, precision)
{
    var currentSolid = 0;
    var solidsToPrecipitate = [];
    var precipitationCycles = 0;
    var i;
    //console.log("Iterating solution towards equilibrium...");
    var result = equilibrate(ctx, correctActivities, fixedIonicStrength, solidsToPrecipitate, maxIterations, precision);

    if (ctx.nSolids > 0) {
        var saturationIndices = ctx.saturationIndices();

        //disolve all insaturated
        for (i = 0; i < ctx.nSolids; i++) {
            if ((ctx.solidSpeciesConcentrations[i] > 0.0) && (1.0 - saturationIndices[i] > precision)) {
                disolve(ctx, i, correctActivities);
            }
        }
        result = equilibrate(ctx,correctActivities, fixedIonicStrength, maxIterations, precision);

        saturationIndices = ctx.saturationIndices();
        currentSolid = mostInsoluble(ctx);

        while ((saturationIndices[currentSolid] - 1.0 > precision) && (precipitationCycles <= ctx.nSolids))
        {
            precipitationCycles++;
            //console.log("Solid " + currentSolid + " is over-saturated and will be included in the global balance");
            //console.log("Iterating the extended system towards equilibrium...");
            solidsToPrecipitate = solidsToPrecipitate.slice(0, solidsToPrecipitate.length + 1);
            solidsToPrecipitate[(solidsToPrecipitate.length - 1)] = currentSolid;
            equilibrate(ctx, correctActivities, fixedIonicStrength, solidsToPrecipitate, maxIterations, precision);
            saturationIndices = ctx.saturationIndices();
            for (i = 0; i < ctx.nSolids; i++) {
                if ((ctx.solidSpeciesConcentrations[i] > 0.0) && (1.0 - saturationIndices[i] > precision)) {
                    disolve(ctx, i, correctActivities);
                }
            }
            result = equilibrate(ctx, correctActivities, fixedIonicStrength, maxIterations, precision);
            saturationIndices = ctx.saturationIndices();

            currentSolid = mostInsoluble(ctx);
        }
    }

    if (precipitationCycles > ctx.nSolids) {
        //console.log("Solid phases could not be equilibrated with the solution");
        return maxIterations;
    }
    //console.log("All solid phases are now in equilibrium with the solution");
    return result;
}

function hasZero(arr, nElements) {
    var i;
    for (i = 0; i < nElements; i++) {
        if (arr[i] == 0.0) {
            return true;
        }
    }
    return false;
}

function hasNegative(arr, nElements) {
    for (var i = 0; i < nElements; i++) {
        if (arr[i] < 0.0 || arr[i] === Infinity || arr[i] === -Infinity || isNaN(arr[i]))
            return true;
    }
    return false;
}

function hasError(ctx, val, nElements) {
    if(argements.length === 1) {
        return (hasError(ctx.componentActivities, ctx.nComponents)) ||
            (hasError(getSolutionSpeciesConcentrations(), ctx.nSolutionSpecies)) ||
            (hasError(getSolidsConcentrations(), ctx.nSolids)) ||
            (hasError(getIonicStrength()));
    }
    if(arguments.length === 2) {
        return val === Infinity || val === -Infinity;
    }
    if(arguments.length === 3) {
        if(typeof val !== Array) return true;
        for (var i = 0; i < nElements; i++) {
            if (val[i] === Infinity || val[i] === -Infinity)
                return true;
        }
        return false;
    }

}

function product(a1,  a2, nRows, nColumns) {
    var result, i, j;
    if(Array.isArray(a1) && Array.isArray(a1[0])) {
        result = initialize1DArray(a1.length);
        for (i = 0; i < nRows; i++) {
            result[i] = 0.0;
            for (j = 0; j < nColumns; j++) {
                result[i] += a1[i][j] * a2[j];
            }
        }
    }
    else if(Array.isArray(a2) && Array.isArray(a2[0])) {
        result = initialize1DArray(a2[0].length);
        for (i = 0; i < nColumns; i++) {
            result[i] = 0.0;
            for (j = 0; j < nRows; j++) {
                result[i] += a2[j][i] * a1[j];
            }
        }
        return result;
    }

    return result;
}

function sum(v1, v2, nElements, inPlace) {
    var result;
    if(inPlace) {
        result = v1.slice();
    }
    else {
        result = initialize1DArray(v1.length);
    }
    for (var i = 0; i < nElements; i++) {
        result[i] = v1[i] + v2[i];
    }
    return result;
}

function minus(v1, v2, nElements, inPlace) {
    var result;
    if(inPlace) {
        result = v1.slice();
    }
    else {
        result = initialize1DArray(v1.length);
    }
    for (var i = 0; i < nElements; i++) {
        result[i] = v1[i] - v2[i];
    }
    return result;
}

function deepCopy(doubleArray, nRows, nCols) {
    var result = initialize1DArray(nRows);
    for(var i=0; i<doubleArray.length; i++) {
        result[i] = doubleArray[i].slice();
    }
    return result;
}

function optionsAsProperties(ctx, options) {
    for(var key in options) {
        ctx[key] = options[key];
    }
}

function initialize2DArray(nRow, nCol) {
    var result = new Array(nRow);
    for(var i=0; i<nRow; i++) {
        result[i] = initialize1DArray(nCol);
    }
    return result;
}

function initialize1DArray(n) {
    return Array.apply(null, new Array(n)).map(Number.prototype.valueOf,0);
}

function rndWithSeed(seed) {
    var mt = new mersenneTwister(seed);
    return mt.random.bind(mt);
}

function constantRandom(constant) {
    return function() {
        return constant;
    };
}

module.exports = EquilibriumCalculator;
},{"mersenne-twister":4,"ml-matrix":6}],9:[function(require,module,exports){
/**
 * chemcalc - Analyse molecular formula
 * @version v2.1.4
 * @date 2015-04-02T09:27:58.588Z
 * @link http://www.chemcalc.org
 * @license BSD
*/
(function () {
    'use strict';

    function getExports($wnd) {

        var $doc = $wnd.document;
        var $gwt = {};
        var navigator = {
            userAgent: 'webkit'
        };

        function noop(){}

        var __gwtModuleFunction = noop;
        __gwtModuleFunction.__moduleStartupDone = noop;
        var $sendStats = noop;
        var $moduleName, $moduleBase;

        // Start GWT code 
function Rg(){}
function Mg(){}
function eb(){}
function ed(){}
function ic(){}
function rc(){}
function rp(){}
function Yp(){}
function dq(){}
function fq(){}
function Ir(){}
function Is(){}
function jl(a){}
function zc(){uc()}
function tb(){nb(this)}
function Yo(){Po(this)}
function Yh(a){this.d=a}
function Qc(a){this.d=a}
function Zc(a){this.d=a}
function jd(a){this.d=a}
function vd(a){this.d=a}
function gi(a){this.d=a}
function Si(a){this.d=a}
function gj(a){this.d=a}
function rn(a){this.d=a}
function On(a){this.d=a}
function Tn(a){this.d=a}
function Xn(a){this.d=a}
function Jn(a){this.f=a}
function ao(a){this.d=a}
function Co(a){this.d=a}
function Ho(a){this.d=a}
function Mo(a){this.d=a}
function cu(a){this.d=a}
function Pc(){this.d=[]}
function qu(){this.rb()}
function Ph(){return Lb}
function Pd(a){return a.d}
function ad(a){return a.d}
function od(a){return a.d}
function Ad(a){return a.d}
function Vc(a){return a.d}
function hd(){return null}
function Hd(){return null}
function cn(a){++a.e;vp(a)}
function dn(a){--a.e;vp(a)}
function dh(a,b){a.h=b}
function eh(a,b){a.l=b}
function fh(a,b){a.m=b}
function _h(){tb.call(this)}
function ej(){tb.call(this)}
function Cj(){tb.call(this)}
function yk(){tb.call(this)}
function wp(){tb.call(this)}
function xp(){tb.call(this)}
function Pq(){tb.call(this)}
function Dq(){nq.call(this)}
function Mq(){nq.call(this)}
function er(){Tq.call(this)}
function bi(){_h.call(this)}
function Qp(){Ip.call(this)}
function Gs(){ur.call(this)}
function Yb(){Ub();Vb(this)}
function wb(){wb=Mg;vb=new eb}
function dd(){dd=Mg;cd=new ed}
function fc(){fc=Mg;ec=new ic}
function qp(){qp=Mg;pp=new rp}
function lu(){lu=Mg;ku=new Ap}
function Mu(){this.d=new Pc}
function Su(){this.d=new ud}
function Tq(){this.d=new Yo}
function _r(){this.n=new ur}
function aq(){aq=Mg;_p=cq()}
function mq(c,a,b){c.d[a]=b}
function Kj(a,b){return a===b}
function tj(a){return a<0?-a:a}
function Yi(a){return isNaN(a)}
function ai(a){ub.call(this,a)}
function ci(a){ub.call(this,a)}
function bd(a){ub.call(this,a)}
function $h(a){ub.call(this,a)}
function dj(a){ub.call(this,a)}
function Dj(a){ub.call(this,a)}
function zk(a){ub.call(this,a)}
function ub(a){sb.call(this,a)}
function Ej(a){dj.call(this,a)}
function ok(a){Yh.call(this,a)}
function vk(a){Yh.call(this,a)}
function nk(){Yh.call(this,'')}
function tk(){Yh.call(this,'')}
function uk(){Yh.call(this,'')}
function ud(){vd.call(this,{})}
function Gr(a){Co.call(this,a)}
function xt(a){as.call(this,a)}
function Jt(a){sb.call(this,a)}
function Ip(){this.d=this.cb()}
function nq(){this.d=this.ib()}
function Nh(){Lh==null&&(Lh=[])}
function Rh(a){return a.tM===Rg}
function ge(a){return a<<24>>24}
function mr(a){return !!a&&a.e}
function Cp(b,a){return b.d[a]}
function xj(a,b){return a>b?a:b}
function yj(a,b){return a<b?a:b}
function Sd(a,b){return Ei(a,b)}
function rh(a,b){return !qh(a,b)}
function sh(a,b){return !ph(a,b)}
function nc(a,b){mc();lc.s(a,b)}
function vi(a){ui(a);return a.q}
function mk(a,b){a.d+=b;return a}
function qk(a,b){a.d+=b;return a}
function rk(a,b){a.d+=b;return a}
function to(a,b){return !!a._(b)}
function Ed(a){return new jd(a)}
function Gd(a){return new Jd(a)}
function as(a){this.n=new vr(a)}
function sb(a){this.k=a;nb(this)}
function sj(a){return a<=0?0-a:a}
function wj(a){return Math.log(a)}
function wo(a){return vo(a,gr(a))}
function Sq(a,b){return Ro(a.d,b)}
function Gn(a){return a.d<a.f.K()}
function Dh(a){return a.l|a.m<<22}
function Ar(a){return a.e=Hn(a.d)}
function Vs(a){return a.d.j*a.d.f}
function Ws(a){return a.d.j*a.d.g}
function Xm(a){return !a?null:a.f}
function uj(a){return Math.ceil(a)}
function Bj(a){return Math.sqrt(a)}
function de(a){return ce(a)&&Rh(a)}
function Dd(a){return Yc(),a?Xc:Wc}
function uo(a,b){return Ym(a._(b))}
function Dp(b,a){return b.d[a]||[]}
function up(a,b){a._gwt_modCount=b}
function $i(a,b){this.d=a;this.e=b}
function zq(a,b){this.d=a;this.e=b}
function wq(a,b){this.e=a;this.f=b}
function fo(a,b){this.f=a;this.g=b}
function Hm(a,b){$i.call(this,a,b)}
function Pr(a,b){$i.call(this,a,b)}
function mo(a,b){fo.call(this,a,b)}
function ur(){vr.call(this,null)}
function Qb(a){$wnd.clearTimeout(a)}
function vj(a){return Math.floor(a)}
function Aj(a){return Math.round(a)}
function _d(a){return !ce(a)&&Rh(a)}
function Ym(a){return !a?null:a.Y()}
function fe(a){return a==null?null:a}
function fj(a,b){return hj(a.d,b.d)}
function Mj(b,a){return b.indexOf(a)}
function ep(a,b,c){a.splice(b,c)}
function Dl(a){il();El.call(this,a)}
function no(a){fo.call(this,a.f,a.g)}
function Tr(){Pr.call(this,'Head',1)}
function Yr(){Pr.call(this,'Tail',3)}
function Po(a){a.e=Td(_e,Xu,1,0,3,1)}
function St(a){a.e=a.g.e;a.f=new Gs}
function Ec(a){if(!a){throw new Pq}}
function Jc(a){if(!a){throw new ej}}
function ik(){ik=Mg;fk={};hk={}}
function Rb(){Fb!=0&&(Fb=0);Ib=-1}
function hi(a,b){return a==b?0:a?1:-1}
function lh(a,b){return Wg(a,b,false)}
function Ug(a){return Vg(a.l,a.m,a.h)}
function Rq(a){return a!=null?kb(a):0}
function hj(a,b){return a<b?-1:a>b?1:0}
function zj(a,b){return Math.pow(a,b)}
function ce(a){return Array.isArray(a)}
function Ob(a){return a.$H||(a.$H=++Gb)}
function Vg(a,b,c){return {l:a,m:b,h:c}}
function gh(a){return a.l+a.m*_u+a.h*av}
function Wp(a){this.d=a;Yo.call(this)}
function Kq(a){this.d=a;Yo.call(this)}
function Sk(a){this.j=5;Mk(this,Gc(a))}
function Sh(){$wnd.setTimeout(Tu(Th))}
function Vr(){Pr.call(this,'Range',2)}
function fp(a,b,c,d){a.splice(b,c,d)}
function Xj(a,b,c){return a.substr(b,c)}
function Jj(b,a){return b.charCodeAt(a)}
function Nj(b,a){return b.lastIndexOf(a)}
function Wj(a){return Td(ff,Xu,2,a,4,1)}
function Wo(a){return Qd(a.e,a.e.length)}
function qi(a){return a>=56320&&a<=57343}
function Ri(a,b){return ae(b,6)&&b.d==a.d}
function Tj(a,b,c){return a.substr(b,c-b)}
function dr(a,b){Ro(a.d,b);return b}
function Pu(a,b,c){sd(a.d,b,c);return a}
function pk(a,b){a.d+=$d(b);return a}
function th(a,b){Wg(a,b,true);return Sg}
function zp(a){var b;b=kb(a);return ~~b}
function Kg(a){var b=Jg;return Pg(b[a])}
function ui(a){if(a.q!=null){return}Ii(a)}
function nb(a){a.n=null;nc(a,a.k);return a}
function Sn(a){var b;b=wn(a.d);return b.X()}
function _n(a){var b;b=wn(a.d);return b.Y()}
function eo(a,b){var c;c=a.g;a.g=b;return c}
function Lo(a){var b;b=Ar(a.d);return b.X()}
function Br(a){In(a.d);pr(a.f,a.e);a.e=null}
function Cr(a){Dr.call(this,a,(Or(),Kr))}
function ht(a,b,c){it.call(this,a,b,c,true)}
function Uh(a,b){this.j=b;this.k=a;nb(this)}
function $t(a,b){this.g=a;St(this);this.f=b}
function Bc(a,b){if(!a){throw new ci(''+b)}}
function Cc(a,b){if(!a){throw new dj(''+b)}}
function qc(a){mc();return parseInt(a)||-1}
function Jb(a,b,c){return a.apply(b,c);var d}
function _j(a,b){return ee(a)?$j(a,b):a.A(b)}
function Sj(a,b){return Xj(a,b,a.length-b)}
function oj(a,b){return (a>>>0).toString(b)}
function bn(a,b){return a.f.bb(b)||a.d.bb(b)}
function Oj(c,a,b){return c.lastIndexOf(a,b)}
function ee(a){return typeof a==='string'}
function $d(a){return String.fromCharCode(a)}
function dk(a){return String.fromCharCode(a)}
function Xi(a){return !isFinite(a)&&!isNaN(a)}
function be(a){return a!=null&&!ee(a)&&!Rh(a)}
function Qk(a){this.k=a;this.j=5;this.d=Tk(a)}
function Qs(a,b,c,d){Ps.call(this,a,0,b,c,d)}
function vt(a,b,c){wt.call(this,a,b,c,1,true)}
function Ro(a,b){a.e[a.e.length]=b;return true}
function So(a,b){Fc(b,a.e.length);return a.e[b]}
function Bo(a){if(!a){throw new Pq}return a.f}
function Gc(a){if(a==null){throw new Cj}return a}
function Hc(a,b){if(a==null){throw new Dj(''+b)}}
function Jd(a){if(a==null){throw new Cj}this.d=a}
function Wq(a,b){if(a<0||a>=b){throw new bi}}
function Lu(a,b){Nc(a.d,a.d.d.length,b);return a}
function zi(a){var b;b=yi(a);Mi(a,b);return b}
function Ci(a){var b;b=yi(a);b.p=a;b.j=1;return b}
function Bi(){var a;a=yi(null);a.j=2;return a}
function rj(){rj=Mg;qj=Td(Xe,Xu,19,256,0,1)}
function uc(){uc=Mg;Error.stackTraceLimit=64}
function Zt(a,b){b<1.0E-10&&(b=1.0E-10);a.e=b}
function Sm(a,b){return b===a?'(this Map)':''+b}
function hs(a){return a.d!=0?'['+a.d+a.o+']':a.o}
function db(a){return vi(ib(a))+'@'+oj(kb(a),16)}
function an(a,b){return ee(b)?gn(a,b):!!Ep(a.d,b)}
function wn(a){return tp(a.f,a),Ec(vn(a)),a.d.S()}
function $r(a,b){return nr(a.n,b,(fi(),di))==null}
function Ng(a){return a instanceof Array?a[0]:null}
function en(a,b){return ee(b)?fn(a,b):Ym(Ep(a.d,b))}
function mh(a,b){return a.l==b.l&&a.m==b.m&&a.h==b.h}
function wh(a,b){return a.l!=b.l||a.m!=b.m||a.h!=b.h}
function Yt(a,b,c,d){vs(a.f,d);us(a.f,c);zs(a.f,b)}
function Qo(a,b,c){Ic(b,a.e.length);fp(a.e,b,0,c)}
function Ud(a,b,c,d,e,f){return Vd(a,b,c,d,e,0,f)}
function $j(a,b){if(a==b){return 0}return a<b?-1:1}
function Bp(c,a){var b=c.d;return b[a]||(b[a]=[])}
function vp(a){var b;b=a._gwt_modCount|0;up(a,b+1)}
function or(a,b){var c;c=new Ir;qr(a,b,c);return c.g}
function Nc(a,b,c){var d;d=Mc(a,b);Oc(a,b,c);return d}
function sd(a,b,c){var d;d=qd(a,b);td(a,b,c);return d}
function jc(a,b){!a&&(a=[]);a[a.length]=b;return a}
function In(a){Jc(a.e!=-1);a.f.W(a.e);a.d=a.e;a.e=-1}
function Hn(a){Ec(a.d<a.f.K());return a.f.V(a.e=a.d++)}
function vo(a,b){!!b&&pr(a,b);return !b?null:new no(b)}
function hn(a,b,c){return ee(b)?jn(a,b,c):Gp(a.d,b,c)}
function ib(a){return ee(a)?ff:_d(a)?a.cZ:de(a)?a.cZ:ne}
function kh(a,b){return {l:a.l&b.l,m:a.m&b.m,h:a.h&b.h}}
function xh(a,b){return {l:a.l|b.l,m:a.m|b.m,h:a.h|b.h}}
function Fh(a,b){return {l:a.l^b.l,m:a.m^b.m,h:a.h^b.h}}
function yp(a,b){return fe(a)===fe(b)||a!=null&&gb(a,b)}
function Qq(a,b){return fe(a)===fe(b)||a!=null&&gb(a,b)}
function jq(a){return Object.getOwnPropertyNames(a.d)}
function Fp(a){return Object.getOwnPropertyNames(a.d)}
function fi(){fi=Mg;di=new gi(false);ei=new gi(true)}
function Yc(){Yc=Mg;Wc=new Zc(false);Xc=new Zc(true)}
function lk(){if(gk==256){fk=hk;hk={};gk=0}++gk}
function gu(a){if(gn(eu,a)){return fn(eu,a)}return null}
function qd(a,b){if(b==null){throw new Cj}return rd(a,b)}
function Dc(a,b){if(!a){throw new dj(Kc('%s > %s',b))}}
function Mk(a,b){a.f=b;a.d=Nl(b);a.d<54&&(a.k=Ch(rl(b)))}
function sk(a,b,c){a.d=Tj(a.d,0,b)+c+Sj(a.d,b);return a}
function Ai(a,b){var c;c=yi(a);Mi(a,c);c.j=b?8:0;return c}
function Go(a){var b;b=(new Gr(a.d)).d.$();return new Mo(b)}
function Pb(a){$wnd.setTimeout(function(){throw a},0)}
function Mn(a){Jn.call(this,a);Ic(0,a.e.length);this.d=0}
function Al(a,b,c){il();jl(this);this.j=a;this.g=b;this.d=c}
function Dt(a,b,c,d){this.f=a;this.e=b;this.g=c;this.d=d}
function Ju(a,b,c,d){this.d=a;this.f=b;this.e=d;this.g=c}
function vr(a){this.f=null;!a&&(a=(qp(),qp(),pp));this.e=a}
function Pj(b,a){return (new RegExp('^('+a+')$')).test(b)}
function fn(a,b){return b==null?Ym(Ep(a.d,null)):a.f.kb(b)}
function jn(a,b,c){return b==null?Gp(a.d,null,c):a.f.nb(b,c)}
function Xh(a,b,c,d){b==null&&(b='null');a.d+=b.substr(c,d-c)}
function Fj(a,b,c){this.d='Unknown';this.g=a;this.e=b;this.f=c}
function Ei(a,b){var c=a.d=a.d||[];return c[b]||(c[b]=a.B(b))}
function Cb(a,b){var c=Bb[a.charCodeAt(0)];return c==null?a:c}
function Nn(a){var b;b=new xn((new rn(a.d)).d);return new Tn(b)}
function Wn(a){var b;b=new xn((new rn(a.d)).d);return new ao(b)}
function sr(a,b){var c;c=1-b;a.d[c]=tr(a.d[c],c);return tr(a,b)}
function ek(a,b,c){var d;d=b+c;Vj(a.length,b,d);return Zj(a,b,d)}
function tm(a,b){nm();return b<mm.length?sm(a,mm[b]):sl(a,wm(b))}
function Qj(c,a,b){b=Yj(b);return c.replace(RegExp(a,'g'),b)}
function Sr(){Or();return Wd(Sd(jg,1),Xu,26,0,[Kr,Lr,Mr,Nr])}
function zu(){return ru(Bu(new Ap,(It(),It(),Ht),(null,Gt)))}
function he(a){return ~~Math.max(Math.min(a,Uu),-2147483648)}
function kb(a){return ee(a)?kk(a):_d(a)?a.hC():de(a)?Ob(a):Ob(a)}
function oi(a){return null!=String.fromCharCode(a).match(/\d/)}
function pi(a){return null!=String.fromCharCode(a).match(/[A-Z]/i)}
function ae(a,b){return a!=null&&(ee(a)&&!!Zd[b]||a.cM&&!!a.cM[b])}
function Lb(b){return function(){return Mb(b,this,arguments);var a}}
function Pg(a){function b(){}
;b.prototype=a||{};return new b}
function Gi(a){if(a.H()){return null}var b=a.p;var c=Jg[b];return c}
function wk(a){ai.call(this,'String index out of range: '+a)}
function Th(){var a;a=Wh();if(!Kj('safari',a)){throw new Vh(a)}}
function Mb(a,b,c){var d;d=Kb();try{return Jb(a,b,c)}finally{Nb(d)}}
function so(a,b){var c,d;c=b.X();d=a._(c);return !!d&&Qq(d.g,b.Y())}
function pb(a){var b,c;b=vi(a.cZ);c=a.r();return c!=null?b+': '+c:b}
function Nb(a){a&&hc((fc(),ec));--Fb;if(a){if(Ib!=-1){Qb(Ib);Ib=-1}}}
function ll(a){while(a.g>0&&a.d[--a.g]==0);a.d[a.g++]==0&&(a.j=0)}
function Np(a){this.k=a;this.g=Fp(this.k);this.d=Td(_f,Xu,27,0,0,1)}
function tp(a,b){if(b._gwt_modCount!=a._gwt_modCount){throw new wp}}
function td(d,a,b){if(b){var c=b.v();d.d[a]=c(b)}else{delete d.d[a]}}
function Oc(d,a,b){if(b){var c=b.v();b=c(b)}else{b=undefined}d.d[a]=b}
function ac(a,b,c,d,e,f,g){a+=e+g+(b^c^d);a=a<<f|a>>>-f;return a+b}
function bc(a,b,c,d,e,f,g){a+=e+g+(c^(b|~d));a=a<<f|a>>>-f;return a+b}
function _b(a,b,c,d,e,f,g){a+=e+g+(c^d&(b^c));a=a<<f|a>>>-f;return a+b}
function $b(a,b,c,d,e,f,g){a+=e+g+(d^b&(c^d));a=a<<f|a>>>-f;return a+b}
function Td(a,b,c,d,e,f){var g;g=Xd(e,d);Wd(Sd(a,f),b,c,e,g);return g}
function im(a,b,c,d){var e;e=Td(le,Xu,0,b,7,1);jm(e,a,b,c,d);return e}
function Vo(a,b,c){var d;d=(Fc(b,a.e.length),a.e[b]);a.e[b]=c;return d}
function ol(a,b){var c;for(c=a.g-1;c>=0&&a.d[c]==b[c];c--);return c<0}
function Tg(a){var b,c,d;b=a&Yu;c=a>>22&Yu;d=a<0?Zu:0;return Vg(b,c,d)}
function Uo(a,b){var c;c=(Fc(b,a.e.length),a.e[b]);ep(a.e,b,1);return c}
function dm(a,b,c,d){var e;e=Td(le,Xu,0,b+1,7,1);em(e,a,b,c,d);return e}
function Rt(a,b,c,d){this.n=new Ap;this.f=a;this.g=b;this.e=c;this.d=d}
function yb(a){wb();this.j=null;this.k=null;this.d='';this.e=a;this.d=''}
function gn(a,b){return b==null?!!Ep(a.d,null):!(a.f.kb(b)===undefined)}
function gb(a,b){return ee(a)?Kj(a,b):_d(a)?a.eQ(b):de(a)?a===b:a===b}
function Ic(a,b){if(a<0||a>b){throw new ai('Index: '+a+', Size: '+b)}}
function Fc(a,b){if(a<0||a>=b){throw new ai('Index: '+a+', Size: '+b)}}
function ul(a,b){if(b==0||a.j==0){return a}return b>0?Ol(a,b):Rl(a,-b)}
function wl(a,b){if(b==0||a.j==0){return a}return b>0?Rl(a,b):Ol(a,-b)}
function Ab(){if(Date.now){return Date.now()}return (new Date).getTime()}
function Zo(){Po(this);Cc(true,'Initial capacity must not be negative')}
function pr(a,b){var c;c=new Ir;c.f=true;c.g=b.Y();return qr(a,b.X(),c)}
function Or(){Or=Mg;Kr=new Pr('All',0);Lr=new Tr;Mr=new Vr;Nr=new Yr}
function Kh(){Kh=Mg;Gh=Vg(Yu,Yu,524287);Hh=Vg(0,0,$u);Ih=oh(1);oh(2);Jh=oh(0)}
function Hr(a,b){mo.call(this,a,b);this.d=Td(eg,Xu,40,2,0,1);this.e=true}
function Rk(a,b){this.j=b;this.d=Uk(a);this.d<54?(this.k=Ch(a)):(this.f=Ml(a))}
function zl(a,b){il();jl(this);this.j=a;this.g=1;this.d=Wd(Sd(le,1),Xu,0,7,[b])}
function sl(a,b){if(b.j==0){return hl}if(a.j==0){return hl}return nm(),om(a,b)}
function Iu(a,b){var c;c=Ti(sj(a.d),sj(b.d));if(c!=0)return c;return $j(a.e,b.e)}
function To(a,b,c){for(;c<a.e.length;++c){if(Qq(b,a.e[c])){return c}}return -1}
function vu(a){var b='';for(var c=0;c<a.length;c++){b+=su(a.charAt(c))}return b}
function xu(a){var b=new Ap;if(a){for(var c in a){b.Q(c,String(a[c]))}}return b}
function fr(a){var b,c;if(!a.f){return null}c=a.f;while(b=c.d[0]){c=b}return c}
function gr(a){var b,c;if(!a.f){return null}c=a.f;while(b=c.d[1]){c=b}return c}
function gc(a){var b,c;if(a.d){c=null;do{b=a.d;a.d=null;c=kc(b,c)}while(a.d);a.d=c}}
function hc(a){var b,c;if(a.e){c=null;do{b=a.e;a.e=null;c=kc(b,c)}while(a.e);a.e=c}}
function Nu(a){var b;Mu.call(this);for(b=0;b<a.length;b++){Lu(this,new jd(a[b]))}}
function Ru(a,b,c){return c==null?Pu(a,b,(dd(),dd(),cd)):Pu(a,b,new Jd(c))}
function Im(){Gm();return Wd(Sd(lf,1),Xu,24,0,[Fm,zm,ym,Am,Dm,Bm,Cm,Em])}
function Ys(a){this.d=a;if(a.g>a.f)throw new Jt('Error: minCount>maxCount')}
function El(a){Gc(a);if(!a.length){throw new Ej('Zero length BigInteger')}Jl(this,a)}
function ri(a){return String.fromCharCode(a).toLowerCase().charCodeAt(0)==a&&pi(a)}
function si(a){return String.fromCharCode(a).toUpperCase().charCodeAt(0)==a&&pi(a)}
function xn(a){this.f=a;this.e=this.f.f.db();this.d=this.e;up(this,a._gwt_modCount)}
function Ps(a,b,c,d,e){this.e=new Ap;this.f=a;this.g=b;this.n=c;this.j=d;this.d=e}
function Gg(b,c){if(b&&typeof b=='object'){try{b.__gwt$exception=c}catch(a){}}}
function Mc(d,a){var b=d.d[a];var c=(Cd(),Bd)[typeof b];return c?c(b):Id(typeof b)}
function iq(d,a){var b=d.d;for(var c in b){if(d.jb(a,b[c])){return true}}return false}
function fs(a,b){var c;if(ae(b,32)){c=b;if(Kj(a.o,c.o)&&a.d==c.d)return true}return false}
function lq(a,b){var c;c=a.d[b];if(!(c===undefined)){delete a.d[b];dn(a.e)}return c}
function tr(a,b){var c,d;c=1-b;d=a.d[c];a.d[c]=d.d[b];d.d[b]=a;a.e=true;d.e=false;return d}
function yi(a){var b;b=new wi;b.q='Class$'+(a?'S'+a:''+b.n);b.e=b.q;b.o=b.q;return b}
function mj(a){var b,c;if(a==0){return 32}else{c=0;for(b=1;(b&a)==0;b<<=1){++c}return c}}
function Mi(a,b){var c;if(!a){return}b.p=a;var d=Gi(b);if(!d){Jg[a]=[b];return}d.cZ=b}
function tu(a,b){var c;c=xu(b);c.f.nb('mf',a);return ru(Cu(c,(It(),It(),Ht),(null,Gt)))}
function Ou(a){var b;Mu.call(this);for(b=0;b<a.length;b++){Lu(this,(new Nu(a[b])).d)}}
function Mh(){Nh();var a=Lh;for(var b=0;b<arguments.length;b++){a.push(arguments[b])}}
function pd(e,a){var b=e.d;var c=0;for(var d in b){b.hasOwnProperty(d)&&(a[c++]=d)}return a}
function Ql(a,b,c){var d,e,f;d=0;for(e=0;e<c;e++){f=b[e];a[e]=f<<1|d;d=f>>>31}d!=0&&(a[c]=d)}
function op(a,b){var c,d;d=a.d.e.length;for(c=0;c<d;c++){Wq(c,a.d.e.length);Vo(a.d,c,b[c])}}
function mp(a){var b,c,d;d=0;for(c=a.I();c.R();){b=c.S();d=d+(b!=null?kb(b):0);d=~~d}return d}
function Dr(a,b){var c;this.f=a;c=new Yo;jr(a,c,b,a.f,null,false,null,false);this.d=new Mn(c)}
function Vj(a,b,c){if(b<0){throw new wk(b)}if(c<b){throw new wk(c-b)}if(c>a){throw new wk(c)}}
function bl(a){if(mh(a,{l:0,m:0,h:0})&&5<Gk.length){return Gk[5]}return new Rk(a,5)}
function Vt(a,b){if(a.g.k==0){return Wt(a,b)}else if(a.g.k==Kt){return Xt(a,b)}return Wt(a,b)}
function vn(a){if(a.d.R()){return true}if(a.d!=a.e){return false}a.d=a.f.d.db();return a.d.R()}
function Nk(a){if(a.d<54){return a.k<0?-1:a.k>0?1:0}return (!a.f&&(a.f=Ll(a.k)),a.f).j}
function gs(a){if(a.g==a.f)return a.g;throw new ub('Atoms.getCount(): undefined (min!=max)')}
function ru(a){if('error' in a.d.d){throw new yb(qd(a.d,'error').w().d)}else{return a.d.d}}
function Pt(a){if(a.j.f.g==0)throw new ub('No isotopic distribution data');return Es(a.j.f)}
function Qt(a){if(a.j.f.g==0)throw new ub('No isotopic distribution data');return Fs(a.j.f)}
function pl(a){var b;if(a.e==-2){if(a.j==0){b=-1}else{for(b=0;a.d[b]==0;b++);}a.e=b}return a.e}
function Lm(a,b){var c,d;Gc(b);for(d=b.I();d.R();){c=d.S();if(!a.J(c)){return false}}return true}
function dt(b){try{Qi(b);return true}catch(a){a=Ig(a);if(ae(a,20)){return false}else throw Hg(a)}}
function Qu(a,b){return !b?Pu(a,'unsaturation',(dd(),dd(),cd)):Pu(a,'unsaturation',new jd(b.d))}
function uu(a){return a.replace(/^H([^+])/,'H+H$1').replace(/(Arg|His|Lys)(?!\()/g,'$1(H+)')}
function mb(a){return ee(a)?a:_d(a)?a.tS():de(a)?db(a):a.toString?a.toString():'[JavaScriptObject]'}
function ls(a){this.o=a.o;this.e=a.e;this.g=a.g;this.f=a.f;this.j=a.j;this.k=a.k;this.d=a.d}
function Ap(){aq();this.d=_p.gb();this.d.e=this;this.f=_p.hb();this.f.e=this;this.e=0;vp(this)}
function Pk(a){Ik();if(Xi(a)||isNaN(a)){throw new Ej('Infinite or NaN')}Kk(this,a.toPrecision(20))}
function mt(a){var b,c,d;d=ot(a);for(c=Go(new Ho(a.n));Gn(c.d.d);){b=Lo(c);b.n=st(b.e*gs(b)*100/d)}}
function nt(a,b){var c,d;for(d=Go(new Ho(a.n));Gn(d.d.d);){c=Lo(d);if(Kj(c.o,b))return c}return null}
function vs(a,b){var c,d,e;c=(new Gr(a)).d.$();while(Gn(c.d)){d=c.e=Hn(c.d);e=d.Y().d;e<b&&Br(c)}}
function kq(a,b,c){var d;d=a.d[b];d===undefined&&cn(a.e);mq(a,b,c===undefined?null:c);return d}
function nu(a){lu();var b,c;b='61-'+a;if(gn(ku,b))return fn(ku,b);c=new ju(a);jn(ku,b,c);return c}
function nr(a,b,c){var d,e;d=new Hr(b,c);e=new Ir;a.f=lr(a,a.f,d,e);e.e||++a.g;a.f.e=false;return e.g}
function Rd(a,b){var c;c=Xd(0,b);Wd(ib(a),a.cM,a.__elementTypeId$,a.__elementTypeCategory$,c);return c}
function Wd(a,b,c,d,e){e.cZ=a;e.cM=b;e.tM=Rg;e.__elementTypeId$=c;e.__elementTypeCategory$=d;return e}
function Qh(a,b){typeof window==='object'&&typeof window['$gwt']==='object'&&(window['$gwt'][a]=b)}
function Cd(){Cd=Mg;Bd={'boolean':Dd,number:Ed,string:Gd,object:Fd,'function':Fd,undefined:Hd}}
function pc(a){var b=/function(?:\s+([\w$]+))?\s*\(/;var c=b.exec(a);return c&&c[1]||'anonymous'}
function jh(a,b){var c,d,e;c=a.l+b.l;d=a.m+b.m+(c>>22);e=a.h+b.h+(d>>22);return {l:c&Yu,m:d&Yu,h:e&Zu}}
function Bh(a,b){var c,d,e;c=a.l-b.l;d=a.m-b.m+(c>>22);e=a.h-b.h+(d>>22);return {l:c&Yu,m:d&Yu,h:e&Zu}}
function vh(a){var b,c,d;b=~a.l+1&Yu;c=~a.m+(b==0?1:0)&Yu;d=~a.h+(b==0&&c==0?1:0)&Zu;return Vg(b,c,d)}
function ah(a){var b,c;c=lj(a.h);if(c==32){b=lj(a.m);return b==32?lj(a.l)+32:b+20-10}else{return c-12}}
function cr(a){var b;b=a.d.e.length;if(b>0){return Wq(b-1,a.d.e.length),a.d.W(b-1)}else{throw new xp}}
function Ti(a,b){if(a<b){return -1}if(a>b){return 1}if(a==b){return 0}return isNaN(a)?isNaN(b)?0:1:-1}
function Ch(a){if(mh(a,(Kh(),Hh))){return bv}if(!qh(a,Jh)){return -gh(vh(a))}return a.l+a.m*_u+a.h*av}
function Hg(a){var b;if(ae(a,38)){b=a;if(fe(b.e)!==fe((wb(),vb))){return fe(b.e)===fe(vb)?null:b.e}}return a}
function Ig(a){var b;if(ae(a,9)){return a}b=a&&a.__gwt$exception;if(!b){b=new yb(a);nc(b,a);Gg(a,b)}return b}
function hp(a){var b,c,d,e;e=1;for(c=0,d=a.length;c<d;++c){b=a[c];e=31*e+(b!=null?kb(b):0);e=~~e}return e}
function Jm(a,b){var c,d,e;Gc(b);c=false;for(e=b.I();e.R();){d=e.S();c=c|nr(a.n,d,(fi(),di))==null}return c}
function Au(a,b){var c;c=xu(b);c.f.nb('monoisotopicMass',''+a);return ru(Fu(c,(It(),It(),Ht),(null,Gt)))}
function Qd(a,b){var c;c=a.slice(0,b);Wd(ib(a),a.cM,a.__elementTypeId$,a.__elementTypeCategory$,c);return c}
function Yg(a,b,c,d,e){var f;f=zh(a,b);c&&_g(f);if(e){a=$g(a,b);d?(Sg=vh(a)):(Sg=Vg(a.l,a.m,a.h))}return f}
function nl(a,b){var c;if(a===b){return true}if(ae(b,5)){c=b;return a.j==c.j&&a.g==c.g&&ol(a,c.d)}return false}
function Ll(a){il();if(a<0){if(a!=-1){return new yl(-1,-a)}return cl}else return a<=10?el[he(a)]:new yl(1,a)}
function Id(a){Cd();throw new bd("Unexpected typeof result '"+a+"'; please report this bug to the GWT team")}
function ks(a,b,c,d){if(c>d)throw new Jt('Error: minCount>maxCount');this.o=a;this.e=b;this.g=c;this.f=d}
function wi(){this.n=ti++;this.q=null;this.o=null;this.k=null;this.g=null;this.e=null;this.p=null;this.d=null}
function au(a,b,c){this.g=a;St(this);this.d=c;Ut(this,b);if(b.d!=0){ts(this.f,-b.d*tv);xs(this.f,1/tj(b.d))}}
function Xs(a,b,c,d,e,f){a.g=xj(he(vj((c-f-b-e)/a.d.j)),a.d.g);a.f=yj(he(uj((c+f-b-d)/a.d.j)),a.d.f);a.e=a.g-1}
function jp(a,b,c,d,e,f,g,h){var i;i=c;while(f<g){i>=d||b<c&&h.ab(a[b],a[i])<=0?(e[f++]=a[b++]):(e[f++]=a[i++])}}
function Zb(a,b){var c,d;for(c=0,d=0;d<16;d++){b[d]=a[c++]&255|(a[c++]&255)<<8|(a[c++]&255)<<16|(a[c++]&255)<<24}}
function _g(a){var b,c,d;b=~a.l+1&Yu;c=~a.m+(b==0?1:0)&Yu;d=~a.h+(b==0&&c==0?1:0)&Zu;eh(a,b);fh(a,c);dh(a,d)}
function vl(a){var b,c,d,e;return a.j==0?a:(b=a.g,c=b+1,d=Td(le,Xu,0,c,7,1),Ql(d,a.d,b),e=new Al(a.j,c,d),ll(e),e)}
function ql(a){var b;if(a.f!=0){return a.f}for(b=0;b<a.d.length;b++){a.f=a.f*33+(a.d[b]&-1)}a.f=a.f*a.j;return a.f}
function ni(a){if(a>=48&&a<58){return a-48}if(a>=97&&a<97){return a-97+10}if(a>=65&&a<65){return a-65+10}return -1}
function $k(a){var b=Hk;!b&&(b=Hk=/^[+-]?\d*$/i);if(b.test(a)){return parseInt(a,10)}else{return Number.NaN}}
function st(a){var b;b=isNaN(a*iv)?a*iv:Xi(a*iv)?a*iv:a*iv==0?a*iv:Ch(nh(Math.round(a*iv)));return b/iv}
function kk(a){ik();var b=':'+a;var c=hk[b];if(c!=null){return c}c=fk[b];c==null&&(c=jk(a));lk();return hk[b]=c}
function Km(a,b){var c,d;for(d=a.I();d.R();){c=d.S();if(fe(b)===fe(c)||b!=null&&gb(b,c)){return true}}return false}
function pj(a){var b,c;if(a>-129&&a<128){b=a+128;c=(rj(),qj)[b];!c&&(c=qj[b]=new gj(a));return c}return new gj(a)}
function Hl(a){var b,c,d;if(a<gl.length){return gl[a]}c=a>>5;b=a&31;d=Td(le,Xu,0,c+1,7,1);d[c]=1<<b;return new Al(1,c+1,d)}
function Mp(a){if(a.f<a.d.length){return true}if(a.e<a.g.length-1){a.d=Cp(a.k,a.g[++a.e]);a.f=0;return true}return false}
function Ms(a){if(a.g==0)throw new ub('Exact mass of '+a.n+' is unknown. Run calculateExactMass() first.');return a.g}
function mc(){mc=Mg;var a,b;b=!(!!Error.stackTraceLimit||'stack' in new Error);a=new zc;lc=b?new rc:a}
function ys(a,b){var c,d,e,f;c=(new Gr(a)).d.$();while(Gn(c.d)){d=c.e=Hn(c.d);e=d.X();f=d.Y();nr(a,e,new Si(f.d*b))}}
function Rm(a,b){var c,d,e;for(d=a.O().I();d.R();){c=d.S();e=c.X();if(fe(b)===fe(e)||b!=null&&gb(b,e)){return c}}return null}
function Bs(a){var b,c;b=new Pk(a);c=Ok(Lk(b,(Gm(),Gm(),Dm)));if(c.indexOf('.')!=-1){return Qj(c,'\\.?0+$','')}return c}
function Xo(a,b){var c,d;d=a.e.length;b.length<d&&(b=Rd(b,d));for(c=0;c<d;++c){b[c]=a.e[c]}b.length>d&&(b[d]=null);return b}
function Ol(a,b){var c,d,e,f;c=b>>5;b&=31;e=a.g+c+(b==0?0:1);d=Td(le,Xu,0,e,7,1);Pl(d,a.d,c,b);f=new Al(a.j,e,d);ll(f);return f}
function Nl(a){var b,c,d;if(a.j==0){return 0}b=a.g<<5;c=a.d[a.g-1];if(a.j<0){d=pl(a);if(d==a.g-1){--c;c=~~c}}b-=lj(c);return b}
function Ks(a){var b,c,d;if(a.e.e==0){return}d=0;for(c=Wn(new Xn(a.e));vn(c.d);){b=_n(c);d+=b.e*b.g/100}if(d==0)return;a.f=d}
function tt(a){var b,c,d;if(a.n.g==0)return '';d=new ok('');for(c=Go(new Ho(a.n));Gn(c.d.d);){b=Lo(c);mk(d,is(b))}return d.d}
function pm(a,b,c,d,e){if(b==0||d==0){return}b==1?(e[d]=rm(e,c,d,a[0])):d==1?(e[b]=rm(e,a,b,c[0])):qm(a,c,e,b,d)}
function ob(a){var b,c,d,e,f;for(e=a;e;e=e.j){for(b=(e.n==null&&(e.n=(mc(),f=lc.t(e),oc(f))),e.n),c=0,d=b.length;c<d;++c);}}
function ip(a,b,c,d){var e,f,g;for(e=b+1;e<c;++e){for(f=e;f>b&&d.ab(a[f-1],a[f])>0;--f){g=a[f];a[f]=a[f-1];a[f-1]=g}}}
function ir(a,b){var c,d,e;d=null;e=a.f;while(e){c=a.e.ab(b,e.f);if(c==0){return e}if(c<=0){e=e.d[0]}else{d=e;e=e.d[1]}}return d}
function hr(a,b){var c,d,e;d=null;e=a.f;while(e){c=a.e.ab(b,e.f);if(c==0){return e}if(c>=0){e=e.d[1]}else{d=e;e=e.d[0]}}return d}
function oc(a){var b,c,d;b='nc';d=yj(a.length,5);for(c=0;c<d;c++){if(Kj(a[c].g,b)){return a.length>=c+1&&a.splice(0,c+1),a}}return a}
function np(a){var b,c,d;d=1;for(c=a.I();c.d<c.f.K();){b=(Ec(c.d<c.f.K()),c.f.V(c.e=c.d++));d=31*d+(b!=null?kb(b):0);d=~~d}return d}
function Ep(a,b){var c,d,e,f;for(d=Dp(a,b==null?'0':''+zp(b)),e=0,f=d.length;e<f;++e){c=d[e];if(yp(b,c.X())){return c}}return null}
function Li(a,b){var c=0;while(!b[c]||b[c]==''){c++}var d=b[c++];for(;c<b.length;c++){if(!b[c]||b[c]==''){continue}d+=a+b[c]}return d}
function mi(a,b,c){var d,e;d=Jj(a,b++);if(d>=55296&&d<=56319&&b<c&&qi(e=a.charCodeAt(b))){return dv+((d&1023)<<10)+(e&1023)}return d}
function Zj(a,b,c){var d='';for(var e=b;e<c;){var f=Math.min(e+10000,c);d+=String.fromCharCode.apply(null,a.slice(e,f));e=f}return d}
function Og(){!Array.isArray&&(Array.isArray=function(a){return Object.prototype.toString.call(a)==='[object Array]'})}
function Lj(b,a){if(a==null){return false}if(b==a){return true}return b.length==a.length&&b.toLowerCase()==a.toLowerCase()}
function kl(a,b){if(a.j>b.j){return 1}if(a.j<b.j){return -1}if(a.g>b.g){return a.j}if(a.g<b.g){return -b.j}return a.j*fm(a.d,b.d,a.g)}
function Xg(a,b){if(a.h==$u&&a.m==0&&a.l==0){b&&(Sg=Vg(0,0,0));return Ug((Kh(),Ih))}b&&(Sg=Vg(a.l,a.m,a.h));return Vg(0,0,0)}
function Uj(a){if(a.length==0||a[0]>' '&&a[a.length-1]>' '){return a}return a.replace(/^[\u0000-\u0020]*|[\u0000-\u0020]*$/g,'')}
function Uk(a){var b;rh(a,{l:0,m:0,h:0})&&(a={l:~a.l&Yu,m:~a.m&Yu,h:~a.h&Zu});return 64-(b=Dh(zh(a,32)),b!=0?lj(b):lj(Dh(a))+32)}
function Kb(){var a;if(Fb!=0){a=Ab();if(a-Hb>2000){Hb=a;Ib=$wnd.setTimeout(Rb,10)}}if(Fb++==0){gc((fc(),ec));return true}return false}
function oh(a){var b,c;if(a>-129&&a<128){b=a+128;ih==null&&(ih=Td(Ge,Xu,141,256,0,1));c=ih[b];!c&&(c=ih[b]=Tg(a));return c}return Tg(a)}
function Nt(a){var b,c,d;b=sv;for(d=new Jn(a.g.g);d.d<d.f.K();){c=(Ec(d.d<d.f.K()),d.f.V(d.e=d.d++));c.k>b&&(b=c.k)}Yt(a.j,b,a.e,a.d)}
function ws(a){var b,c,d,e,f,g;b=sv;f=0;c=(new Gr(a)).d.$();while(Gn(c.d)){d=c.e=Hn(c.d);e=d.X();g=d.Y().d;if(g>b){b=g;f=e.d}}return f}
function ts(a,b){var c,d,e,f,g;d=new Gs;c=(new Gr(a)).d.$();while(Gn(c.d)){e=c.e=Hn(c.d);f=e.X();g=e.Y();nr(d,new Si(f.d+b),g);Br(c)}ss(a,d)}
function xs(a,b){var c,d,e,f,g;d=new Gs;c=(new Gr(a)).d.$();while(Gn(c.d)){e=c.e=Hn(c.d);f=e.X();g=e.Y();nr(d,new Si(f.d*b),g);Br(c)}ss(a,d)}
function ss(a,b){var c,d,e,f,g;e=(new Gr(b)).d.$();while(Gn(e.d)){c=e.e=Hn(e.d);f=c.X();g=c.Y();d=uo(a,f);!!d&&(g=new Si(d.d+g.d));nr(a,f,g)}}
function Lt(a,b,c){var d,e,f;f=mu(Qt(a),b,c);e=new Gs;for(d=0;d<f.length;d++){nr(e,new Si(f[d][0]),new Si(f[d][1]))}a.j.f=e;a.j.f.d=iv}
function rd(f,a){var b=f.d;var c;a=String(a);b.hasOwnProperty(a)&&(c=b[a]);var d=(Cd(),Bd)[typeof c];var e=d?d(c):Id(typeof c);return e}
function rl(a){var b;b=a.g>1?xh(yh(oh(a.d[1]),32),kh(oh(a.d[0]),{l:Yu,m:1023,h:0})):kh(oh(a.d[0]),{l:Yu,m:1023,h:0});return uh(oh(a.j),b)}
function fm(a,b,c){var d;for(d=c-1;d>=0&&a[d]==b[d];d--);return d<0?0:rh(kh(oh(a[d]),{l:Yu,m:1023,h:0}),kh(oh(b[d]),{l:Yu,m:1023,h:0}))?-1:1}
function hu(a){fu();var b,c,d,e;e=2;for(c=Go(new Ho(a.n));Gn(c.d.d);){b=Lo(c);d=gu(b.o);if(!d)return null;e+=d.d*gs(b)}return new Si(e/2)}
function yl(a,b){this.j=a;if(b<lv){this.g=1;this.d=Wd(Sd(le,1),Xu,0,7,[~~b])}else{this.g=2;this.d=Wd(Sd(le,1),Xu,0,7,[~~(b%lv),~~(b/lv)])}}
function Cl(a){il();jl(this);if(a.length==0){this.j=0;this.g=1;this.d=Wd(Sd(le,1),Xu,0,7,[0])}else{this.j=1;this.g=a.length;this.d=a;ll(this)}}
function ns(a,b,c){if(b>c)throw new Jt('Error: minCount>maxCount');this.g=b;this.f=c;this.j=pt(a.d);this.k=qt(a.d);this.d=0;this.o=a.e;this.e=ot(a.d)}
function _s(a){var b,c,d,e;c='';b=new Yb;d=Sb(b,ck(a));for(e=0;e<5;e++){e==0?(c+=$d(tj(d[0]%26)+65&fv)):(c+=$d(tj(d[e]%26)+97&fv))}return c}
function cc(a,b){var c,d;for(c=0,d=0;c<4;c++){b[d++]=ge(a[c]&255);b[d++]=ge(a[c]>>>8&255);b[d++]=ge(a[c]>>>16&255);b[d++]=ge(a[c]>>>24&255)}}
function bk(a){var b,c;if(a>=dv){b=55296+(a-dv>>10&1023)&fv;c=56320+(a-dv&1023)&fv;return dk(b)+dk(c)}else{return String.fromCharCode(a&fv)}}
function it(a,b,c,d){this.d=b;this.e=c;this.g=new Zo;et(this,a,d);if(this.g.e.length==0)throw new Jt('Cannot parse: empty formula: ->'+a+'<-')}
function jr(a,b,c,d,e,f,g,h){var i,j;if(!d){return}i=d.d[0];!!i&&jr(a,b,c,i,e,f,g,h);kr(a,c,d.f,e,f,g,h)&&b.U(d);j=d.d[1];!!j&&jr(a,b,c,j,e,f,g,h)}
function Yj(a){var b;b=0;while(0<=(b=a.indexOf('\\',b))){a.charCodeAt(b+1)==36?(a=a.substr(0,b)+'$'+Sj(a,++b)):(a=a.substr(0,b)+Sj(a,++b))}return a}
function Qm(a,b){var c,d,e;c=b.X();e=b.Y();d=a.P(c);if(!(fe(e)===fe(d)||e!=null&&gb(e,d))){return false}if(d==null&&!a.N(c)){return false}return true}
function kr(a,b,c,d,e,f,g){var h,i;if(b.pb()&&(h=a.e.ab(c,d),h<0||!e&&h==0)){return false}if(b.qb()&&(i=a.e.ab(c,f),i>0||!g&&i==0)){return false}return true}
function $g(a,b){var c,d,e;if(b<=22){c=a.l&(1<<b)-1;d=e=0}else if(b<=44){c=a.l;d=a.m&(1<<b-22)-1;e=0}else{c=a.l;d=a.m;e=a.h&(1<<b-44)-1}return Vg(c,d,e)}
function Eu(a){var b,c,d;d=Ml({l:1,m:0,h:0});for(c=new Jn(a.d);c.d<c.f.K();){b=(Ec(c.d<c.f.K()),c.f.V(c.e=c.d++));d=sl(d,Ml(oh(b.d.f-b.d.g+1)))}return d}
function As(a){var b,c,d,e,f;e=~~(a.d/2);if(a.g<e)return;f=new as(new Is);Jm(f,new Gr(a));c=0;for(d=Go(new Ho(f.n));Gn(d.d.d);){b=Lo(d);c++>e&&or(a,b.X())}}
function ot(a){var b,c,d;if(a.j)throw new Jt('Cannot calculate mass of a range formula');d=0;for(c=Go(new Ho(a.n));Gn(c.d.d);){b=Lo(c);d+=b.e*gs(b)}return st(d)}
function qt(a){var b,c,d;if(a.j)throw new Jt('Cannot calculate exact mass of a range formula');d=0;for(c=Go(new Ho(a.n));Gn(c.d.d);){b=Lo(c);d+=b.k*gs(b)}return d}
function Mm(a){var b,c,d,e;e=new vk('[');b=false;for(d=a.I();d.R();){c=d.S();b?(e.d+=', ',e):(b=true);e.d+=c===a?'(this Collection)':''+c}e.d+=']';return e.d}
function Xk(a,b,c){var d,e,f,g,h;e=(h=a/b,h>0?vj(h):uj(h));f=a%b;g=Ti(a*b,0);if(f!=0){d=Ti((f<=0?0-f:f)*2,b<=0?0-b:b);e+=_k(he(e)&1,g*(5+d),c)}return new Qk(e)}
function Ml(a){il();if(rh(a,{l:0,m:0,h:0})){if(wh(a,{l:Yu,m:Yu,h:Zu})){return new Bl(-1,vh(a))}return cl}else return sh(a,{l:10,m:0,h:0})?el[Dh(a)]:new Bl(1,a)}
function bu(a,b,c){var d,e;d=b.d!=0?gs(b):zj(fn(a.d.d,b.o).e.e-1,gs(b));e=c.d!=0?gs(c):zj(fn(a.d.d,c.o).e.e-1,gs(c));if(d==e)return Ti(b.e,c.e);return -Ti(d,e)}
function hh(a,b){var c,d,e;e=a.h-b.h;if(e<0){return false}c=a.l-b.l;d=a.m-b.m+(c>>22);e+=d>>22;if(e<0){return false}eh(a,c&Yu);fh(a,d&Yu);dh(a,e&Zu);return true}
function Sb(a,b){var c,d;Wb(a,b,0,b.length);return c=dc(yh(a.e,3)),d=Td(ie,Xu,0,16,7,1),a.f>8?Wb(a,Tb,0,a.f-8):Wb(a,Tb,0,64+(a.f-8)),Wb(a,c,0,8),cc(a.g,d),Vb(a),d}
function _t(a,b,c){var d,e,f;this.g=a;St(this);this.d=c;d=b.e.e;Zt(this,a.e/(d*4));for(f=Wn(new Xn(b.e));vn(f.d);){e=_n(f);nr(this.f,new Si(e.e),new Si(e.g/100))}}
function Vd(a,b,c,d,e,f,g){var h,i,j,k,l;k=e[f];j=f==g-1;h=j?d:0;l=Xd(h,k);Wd(Sd(a,g-f),b[f],c[f],h,l);if(!j){++f;for(i=0;i<k;++i){l[i]=Vd(a,b,c,d,e,f,g)}}return l}
function iu(a){fu();var b,c,d,e;e=2;for(c=new Jn(a.d);c.d<c.f.K();){b=(Ec(c.d<c.f.K()),c.f.V(c.e=c.d++));d=gu(b.d.o);if(!d)return null;e+=d.d*b.e}return new Si(e/2)}
function Oh(b,c,d,e){Nh();var f=Lh;$moduleName=c;$moduleBase=d;Fg=e;function g(){for(var a=0;a<f.length;a++){f[a]()}}
if(b){try{Tu(g)()}catch(a){b(c,a)}}else{Tu(g)()}}
function rt(a){var b,c,d;if(a.j)throw new Jt('Cannot get the number of atoms: this is a range formula');d=0;for(c=Go(new Ho(a.n));Gn(c.d.d);){b=Lo(c);d+=gs(b)}return d}
function gm(a,b,c){var d,e;d=kh(oh(c),{l:Yu,m:1023,h:0});for(e=0;wh(d,{l:0,m:0,h:0})&&e<b;e++){d=jh(d,kh(oh(a[e]),{l:Yu,m:1023,h:0}));a[e]=Dh(d);d=zh(d,32)}return Dh(d)}
function vm(a,b){nm();var c,d;d=(il(),dl);c=a;for(;b>1;b>>=1){(b&1)!=0&&(d=sl(d,c));c.g==1?(c=sl(c,c)):(c=new Cl(xm(c.d,c.g,Td(le,Xu,0,c.g<<1,7,1))))}d=sl(d,c);return d}
function Gp(a,b,c){var d,e,f,g;d=Bp(a,b==null?'0':''+zp(b));for(f=0,g=d.length;f<g;++f){e=d[f];if(yp(b,e.X())){return e.Z(c)}}d[d.length]=new mo(b,c);cn(a.e);return null}
function kp(a,b,c,d){var e,f,g,h;!d&&(d=(qp(),qp(),pp));e=(f=(g=c-b,Dc(g>=0,Wd(Sd(_e,1),Xu,1,3,[pj(b),pj(c)])),g),h=Rd(a,f),xk(a,b,h,0,yj(a.length-b,f)),h);lp(e,a,b,c,-b,d)}
function Xd(a,b){var c=new Array(b);var d;switch(a){case 6:d={l:0,m:0,h:0};break;case 7:d=0;break;case 8:d=false;break;default:return c;}for(var e=0;e<b;++e){c[e]=d}return c}
function is(a){var b;a.d!=0?(b='<sup>'+a.d+'<\/sup>'+a.o):(b=a.o);if(a.f==1&&a.g==1)return b;if(a.f==a.g)return b+'<sub>'+a.f+'<\/sub>';return b+'<sub>'+a.g+'-'+a.f+'<\/sub>'}
function Ub(){Ub=Mg;Tb=Wd(Sd(ie,1),Xu,0,7,[-128,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0])}
function ju(a){var b,c,d;this.e=61;this.d=a;c=a/(2*Bj(2*wj(2)));this.f=Td(ke,gv,0,61,7,1);for(b=0;b<61;b++){d=b-30;this.f[b]=1/(c*Bj(6.283185307179586))*Math.exp(-d*d/(2*c*c))}}
function Du(a,b,c){var d,e;for(d=0;d<a.d.e.length;d++){for(e=d+1;e<a.d.e.length;e++){b[d]=b[d]+Ws((Wq(e,a.d.e.length),So(a.d,e)));c[d]=c[d]+Vs((Wq(e,a.d.e.length),So(a.d,e)))}}}
function Vb(a){a.d=Td(ie,Xu,0,64,7,1);a.g=Td(le,Xu,0,4,7,1);a.j=Td(le,Xu,0,16,7,1);a.g[0]=1732584193;a.g[1]=-271733879;a.g[2]=-1732584194;a.g[3]=271733878;a.e={l:0,m:0,h:0};a.f=64}
function Pl(a,b,c,d){var e,f,g;if(d==0){xk(b,0,a,c,a.length-c)}else{g=32-d;a[a.length-1]=0;for(f=a.length-1;f>c;f--){a[f]|=b[f-c-1]>>>g;a[f-1]=b[f-c-1]<<d}}for(e=0;e<c;e++){a[e]=0}}
function Tk(a){var b,c;if(a>-140737488355328&&a<140737488355328){if(a==0){return 0}b=a<0;b&&(a=-a);c=he(vj(wj(a)/0.6931471805599453));(!b||a!=zj(2,c))&&++c;return c}return Uk(nh(a))}
function ut(a){var b,c,d;if(a.n.g==0)return '';d=new ok('');for(c=Go(new Ho(a.n));Gn(c.d.d);){b=Lo(c);mk(d,js(b,a.f))}a.d!=0&&(a.d>0?mk(d,'(+'+a.d+')'):mk(d,'('+a.d+')'));return d.d}
function Yd(a,b,c,d,e,f){if(a===c){a=a.slice(b,b+e);b=0}for(var g=b,h=b+e;g<h;){var i=Math.min(g+10000,h);e=i-g;Array.prototype.splice.apply(c,[d,f?e:0].concat(a.slice(g,i)));g=i;d+=e}}
function ph(a,b){var c,d;c=a.h>>19;d=b.h>>19;return c==0?d!=0||a.h>b.h||a.h==b.h&&a.m>b.m||a.h==b.h&&a.m==b.m&&a.l>b.l:!(d==0||a.h<b.h||a.h==b.h&&a.m<b.m||a.h==b.h&&a.m==b.m&&a.l<=b.l)}
function qh(a,b){var c,d;c=a.h>>19;d=b.h>>19;return c==0?d!=0||a.h>b.h||a.h==b.h&&a.m>b.m||a.h==b.h&&a.m==b.m&&a.l>=b.l:!(d==0||a.h<b.h||a.h==b.h&&a.m<b.m||a.h==b.h&&a.m==b.m&&a.l<b.l)}
function Bt(b){var c,d;d=new Su;Ru(d,'name',b.f);Ru(d,'symbol',b.e);Ru(d,'mf',ut(b.d));try{Pu(d,'mass',new jd(ot(b.d)))}catch(a){a=Ig(a);if(ae(a,4)){c=a;ob(c)}else throw Hg(a)}return d}
function rr(a,b,c,d){var e,f;f=b;e=f.f==null||a.e.ab(c.f,f.f)>0?1:0;while(f.d[e]!=c){f=f.d[e];e=a.e.ab(c.f,f.f)>0?1:0}f.d[e]=d;d.e=c.e;d.d[0]=c.d[0];d.d[1]=c.d[1];c.d[0]=null;c.d[1]=null}
function cq(){var a;if(Object.create&&Object.getOwnPropertyNames&&bq()){return (a=Object.create(null),a['__proto__']=42,Object.getOwnPropertyNames(a).length==0)?new dq:new Yp}return new fq}
function lt(a,b){var c;if(b.f<b.g)throw new Jt('Syntax error: maxCount<minCount');c=nt(a,b.o);if(c)if(c.d==b.d){c.g+=b.g;c.f+=b.f;return}b.f==0&&b.g==0&&(a.j=true);nr(a.n,b,(fi(),di))==null}
function Pi(a){var b;if(!(b=Oi,!b&&(b=Oi=/^\s*[+-]?(NaN|Infinity|((\d+\.?\d*)|(\.\d+))([eE][+-]?\d+)?[dDfF]?)\s*$/),b.test(a))){throw new Ej('For input string: "'+a+'"')}return parseFloat(a)}
function Bl(a,b){jl(this);this.j=a;if(mh(kh(b,{l:0,m:4193280,h:Zu}),{l:0,m:0,h:0})){this.g=1;this.d=Wd(Sd(le,1),Xu,0,7,[Dh(b)])}else{this.g=2;this.d=Wd(Sd(le,1),Xu,0,7,[Dh(b),Dh(zh(b,32))])}}
function Sl(a,b,c,d,e){var f,g,h;f=true;for(g=0;g<d;g++){f=f&c[g]==0}if(e==0){xk(c,d,a,0,b)}else{h=32-e;f=f&c[g]<<h==0;for(g=0;g<b-1;g++){a[g]=c[g+d]>>>e|c[g+d+1]<<h}a[g]=c[g+d]>>>e;++g}return f}
function Ds(a){var b,c,d,e,f,g,h;e=a.g;e>~~(a.d/2)&&(e=~~(a.d/2));f='';d=(new Gr(a)).d.$();b=0;while(Gn(d.d)&&b<e){++b;c=d.e=Hn(d.d);g=c.X().d;h=c.Y().d;h>-1.0E100&&(f+=g+', '+h+'\r\n')}return f}
function Es(a){var b,c,d,e,f,g,h;e=a.g;e>~~(a.d/2)&&(e=~~(a.d/2));f=new nk;d=(new Gr(a)).d.$();b=0;while(Gn(d.d)&&b<e){++b;c=d.e=Hn(d.d);g=c.X().d;h=c.Y().d;mk(f,Bs(g)+', '+Bs(h*100)+'\r\n')}return f}
function yh(a,b){var c,d,e;b&=63;if(b<22){c=a.l<<b;d=a.m<<b|a.l>>22-b;e=a.h<<b|a.m>>22-b}else if(b<44){c=0;d=a.l<<b-22;e=a.m<<b-22|a.l>>44-b}else{c=0;d=0;e=a.l<<b-44}return {l:c&Yu,m:d&Yu,h:e&Zu}}
function Ah(a,b){var c,d,e,f;b&=63;c=a.h&Zu;if(b<22){f=c>>>b;e=a.m>>b|c<<22-b;d=a.l>>b|a.m<<22-b}else if(b<44){f=0;e=c>>>b-22;d=a.m>>b-22|a.h<<44-b}else{f=0;e=0;d=c>>>b-44}return {l:d&Yu,m:e&Yu,h:f&Zu}}
function Fs(a){var b,c,d,e,f;c=a.g;c>~~(a.d/2)&&(c=~~(a.d/2));d=Ud(ke,[Xu,gv],[28,0],7,[c,2],2);b=0;for(f=Go(new Ho(a));Gn(f.d.d);){e=Lo(f);d[b][0]=e.d;d[b][1]=uo(a,e).d;++b;if(b==c)break}return d}
function Gm(){Gm=Mg;Fm=new Hm('UP',0);zm=new Hm('DOWN',1);ym=new Hm('CEILING',2);Am=new Hm('FLOOR',3);Dm=new Hm('HALF_UP',4);Bm=new Hm('HALF_DOWN',5);Cm=new Hm('HALF_EVEN',6);Em=new Hm('UNNECESSARY',7)}
function zs(a,b){var c,d,e,f,g;c=sv;d=(new Gr(a)).d.$();while(Gn(d.d)){e=d.e=Hn(d.d);e.X();g=e.Y().d;g>c&&(c=g)}d=(new Gr(a)).d.$();while(Gn(d.d)){e=d.e=Hn(d.d);f=e.X();g=e.Y();nr(a,f,new Si(g.d/c*b))}}
function rm(a,b,c,d){nm();var e,f;e={l:0,m:0,h:0};for(f=0;f<c;f++){e=jh(uh(kh(oh(b[f]),{l:Yu,m:1023,h:0}),kh(oh(d),{l:Yu,m:1023,h:0})),kh(oh(Dh(e)),{l:Yu,m:1023,h:0}));a[f]=Dh(e);e=Ah(e,32)}return Dh(e)}
function Tt(a,b){var c;if(b<=0)throw new ub('Error: power='+b);if(b==1)return a;if(b==2){a.f=Vt(a,a);return a}--b;c=new $t(a.g,a.f);while(b!=0){(b&1)!=0&&(a.f=Vt(a,c));b>>=1;b!=0&&(c.f=Vt(c,c))}return a}
function xb(a){var b;if(a.f==null){b=fe(a.e)===fe(vb)?null:a.e;a.g=b==null?'null':be(b)?b==null?null:b.name:ee(b)?'String':vi(ib(b));a.d=a.d+': '+(be(b)?b==null?null:b.message:b+'');a.f='('+a.g+') '+a.d}}
function bq(){var a='__proto__';var b=Object.create(null);if(b[a]!==undefined){return false}var c=Object.getOwnPropertyNames(b);if(c.length!=0){return false}b[a]=42;if(b[a]!==42){return false}return true}
function lp(a,b,c,d,e,f){var g,h,i,j;g=d-c;if(g<7){ip(b,c,d,f);return}i=c+e;h=d+e;j=i+(h-i>>1);lp(b,a,i,j,-e,f);lp(b,a,j,h,-e,f);if(f.ab(a[j-1],a[j])<=0){while(c<d){b[c++]=a[i++]}return}jp(a,i,j,h,b,c,d,f)}
function kc(b,c){var d,e,f,g;for(e=0,f=b.length;e<f;e++){g=b[e];try{g[1]?g[0].sb()&&(c=jc(c,g)):g[0].sb()}catch(a){a=Ig(a);if(ae(a,9)){d=a;Pb(ae(d,38)?fe(d.e)===fe(vb)?null:d.e:d)}else throw Hg(a)}}return c}
function Hp(a,b){var c,d,e,f;e=b==null?'0':''+zp(b);c=Dp(a,e);for(f=0;f<c.length;f++){d=c[f];if(yp(b,d.X())){c.length==1?(delete a.d[e],undefined):(c.splice(f,1),undefined);dn(a.e);return d.Y()}}return null}
function jk(a){var b,c,d,e;b=0;d=a.length;e=d-4;c=0;while(c<e){b=a.charCodeAt(c+3)+31*(a.charCodeAt(c+2)+31*(a.charCodeAt(c+1)+31*(a.charCodeAt(c)+31*b)));b=~~b;c+=4}while(c<d){b=b*31+Jj(a,c++)}b=~~b;return b}
function tl(a,b){var c;if(b<0){throw new $h('Negative exponent')}if(b==0){return dl}else if(b==1||nl(a,dl)||nl(a,hl)){return a}if(!xl(a,0)){c=1;while(!xl(a,c)){++c}return sl(Hl(c*b),tl(wl(a,c),b))}return vm(a,b)}
function Ls(a){var b,c,d,e,f;if(a.e.e==0){a.g=a.f;a.k=Dh(nh(Aj(a.f)));return}b=1.7976931348623157E308;f=sv;c=true;for(e=Wn(new Xn(a.e));vn(e.d);){d=_n(e);if(d.g>f||c){c=false;b=d.e;f=d.g}}a.g=b;a.k=Dh(nh(Aj(b)))}
function Lg(a,b,c){var d=Jg;var e=Kg;var f=Ng;var g=d[a];var h=f(g);if(g&&!h){_=g}else{_=d[a]=!b?{}:e(b);_.cM=c;_.constructor=_;!b&&(_.tM=Rg)}for(var i=3;i<arguments.length;++i){arguments[i].prototype=_}h&&(_.cZ=h)}
function js(a,b){var c,d;c=a.o;!!b&&gn(b,a.o)&&Pj(fn(b,a.o).j,'^[A-Z][a-z]?\\{.*\\}$')&&(c=fn(b,a.o).j);d='';a.d!=0?(d+='['+a.d+c+']'):(d+=c);if(a.f==1&&a.g==1)return d;if(a.f==a.g)return d+a.f;return d+a.g+'-'+a.f}
function Fd(a){if(!a){return dd(),cd}var b=a.valueOf?a.valueOf():a;if(b!==a){var c=Bd[typeof b];return c?c(b):Id(typeof b)}else if(a instanceof Array||a instanceof $wnd.Array){return new Qc(a)}else{return new vd(a)}}
function Wb(a,b,c,d){while(true){if(d>=a.f){xk(b,c,a.d,Dh(kh(a.e,{l:63,m:0,h:0})),a.f);Xb(a,a.d);a.e=jh(a.e,oh(a.f));c+=a.f;d-=a.f;a.f=64}else{xk(b,c,a.d,Dh(kh(a.e,{l:63,m:0,h:0})),d);a.e=jh(a.e,oh(d));a.f-=d;break}}}
function lj(a){var b,c,d;if(a<0){return 0}else if(a==0){return 32}else{d=-(a>>16);b=d>>16&16;c=16-b;a=a>>b;d=a-256;b=d>>16&8;c+=b;a<<=b;d=a-4096;b=d>>16&4;c+=b;a<<=b;d=a-16384;b=d>>16&2;c+=b;a<<=b;d=a>>14;b=d&~(d>>1);return c+2-b}}
function Db(b){var c=(!Bb&&(Bb=Eb()),Bb);var d=b.replace(/[\x00-\x1f\xad\u0600-\u0603\u06dd\u070f\u17b4\u17b5\u200b-\u200f\u2028-\u202e\u2060-\u2064\u206a-\u206f\ufeff\ufff9-\ufffb"\\]/g,function(a){return Cb(a,c)});return '"'+d+'"'}
function xl(a,b){var c,d,e;if(b==0){return (a.d[0]&1)!=0}if(b<0){throw new $h('Negative bit address')}e=b>>5;if(e>=a.g){return a.j<0}c=a.d[e];b=1<<(b&31);if(a.j<0){d=pl(a);if(e<d){return false}else d==e?(c=-c):(c=~c)}return (c&b)!=0}
function Hu(b,c){var d,e,f,g;f=new Tq;try{for(e=Go(new Ho(b.n));Gn(e.d.d);){d=Lo(e);d.f=yj(d.f,he(c/d.j));if(d.g>d.f)return null;Sq(f,new Ys(d))}g=Wo(f.d);kp(g,0,g.length,null);op(f,g)}catch(a){a=Ig(a);if(!ae(a,4))throw Hg(a)}return f}
function jm(a,b,c,d,e){var f,g;f={l:0,m:0,h:0};for(g=0;g<e;g++){f=jh(f,Bh(kh(oh(b[g]),{l:Yu,m:1023,h:0}),kh(oh(d[g]),{l:Yu,m:1023,h:0})));a[g]=Dh(f);f=zh(f,32)}for(;g<c;g++){f=jh(f,kh(oh(b[g]),{l:Yu,m:1023,h:0}));a[g]=Dh(f);f=zh(f,32)}}
function pt(a){var b,c,d,e;if(a.j)throw new Jt('Cannot calculate exact mass of a range formula');d=0;for(c=Go(new Ho(a.n));Gn(c.d.d);){b=Lo(c);d+=b.j*gs(b)}return e=isNaN(d*jv)?d*jv:Xi(d*jv)?d*jv:d*jv==0?d*jv:Ch(nh(Math.round(d*jv))),e/jv}
function dc(a){var b;b=Td(ie,Xu,0,8,7,1);b[0]=ge(Dh(a));a=Ah(a,8);b[1]=ge(Dh(a));a=Ah(a,8);b[2]=ge(Dh(a));a=Ah(a,8);b[3]=ge(Dh(a));a=Ah(a,8);b[4]=ge(Dh(a));a=Ah(a,8);b[5]=ge(Dh(a));a=Ah(a,8);b[6]=ge(Dh(a));a=Ah(a,8);b[7]=ge(Dh(a));return b}
function zh(a,b){var c,d,e,f,g;b&=63;c=a.h;d=(c&$u)!=0;d&&(c|=-1048576);if(b<22){g=c>>b;f=a.m>>b|c<<22-b;e=a.l>>b|a.m<<22-b}else if(b<44){g=d?Zu:0;f=c>>b-22;e=a.m>>b-22|c<<44-b}else{g=d?Zu:0;f=d?Yu:0;e=c>>b-44}return {l:e&Yu,m:f&Yu,h:g&Zu}}
function Ii(a){if(a.G()){var b=a.f;b.H()?(a.q='['+b.p):!b.G()?(a.q='[L'+b.D()+';'):(a.q='['+b.D());a.e=b.C()+'[]';a.o=b.F()+'[]';return}var c=a.k;var d=a.g;d=d.split('/');a.q=Li('.',[c,Li('$',d)]);a.e=Li('.',[c,Li('.',d)]);a.o=d[d.length-1]}
function ct(a){var b,c,d;if(a.f)throw new Jt('Cannot calculate mass: this is a range formula');if(a.j)throw new Jt('The mass is not clearly defined');d=0;for(c=new Jn(a.g);c.d<c.f.K();){b=(Ec(c.d<c.f.K()),c.f.V(c.e=c.d++));d=he(d+qt(b)*b.k)}return d}
function gt(a){var b,c,d;c=new Jn(a.g);d=new ok('');c.d<c.f.K()&&(d=new ok((Ec(c.d<c.f.K()),mb(c.f.V(c.e=c.d++)))));while(c.d<c.f.K()){b=(Ec(c.d<c.f.K()),c.f.V(c.e=c.d++));b.k==1?mk(d,'.'+ut(b)):b.k==0?mk(d,'.n'+ut(b)):mk(d,'.'+b.k+ut(b))}return d.d}
function us(a,b){var c,d,e,f,g,h;e=new Gs;d=(new Gr(a)).d.$();while(Gn(d.d)){f=d.e=Hn(d.d);g=f.X().d;h=f.Y().d;Br(d);g=(isNaN(g/b)?g/b:Xi(g/b)?g/b:g/b==0?g/b:Ch(nh(Math.round(g/b))))*b;c=uo(e,new Si(g));!!c&&(h+=c.d);nr(e,new Si(g),new Si(h))}ss(a,e)}
function nh(a){var b,c,d,e,f;if(isNaN(a)){return Kh(),Jh}if(a<bv){return Kh(),Hh}if(a>=9223372036854775807){return Kh(),Gh}e=false;if(a<0){e=true;a=-a}d=0;if(a>=av){d=he(a/av);a-=d*av}c=0;if(a>=_u){c=he(a/_u);a-=c*_u}b=he(a);f=Vg(b,c,d);e&&_g(f);return f}
function ck(a){var b,c,d,e,f,g,h;g=a.length;b=0;for(f=0;f<g;){d=mi(a,f,a.length);f+=d>=dv?2:1;d<128?++b:d<2048?(b+=2):d<dv?(b+=3):d<2097152?(b+=4):d<67108864&&(b+=5)}c=Td(ie,Xu,0,b,7,1);h=0;for(e=0;e<g;){d=mi(a,e,a.length);e+=d>=dv?2:1;h+=ak(c,h,d)}return c}
function Rs(a,b,c){var d,e,f,g,h,i,j;this.j=c;this.n=b;this.d=a.d;this.e=new Ap;g=Qj(c,'[^0-9,\\.]','');i=Rj(g,',',0);d=0;for(f=Wn(new Xn(a.e));vn(f.d);){e=_n(f);j=0;i.length>d&&(j=Pi(i[d]));h=new Dt(e.f,e.e,j,e.d);hn(this.e,pj(e.f),h);++d}Ks(this);Ls(this)}
function Ct(b,c,d,e,f){var g;this.e=b;this.f=c;try{this.d=new vt(d,e,f)}catch(a){a=Ig(a);if(ae(a,7)){g=a;"Group creation error: '"+b+"'='"+d+"': "+pb(g);this.d=new vt('',e,f)}else throw Hg(a)}if(this.d.j)throw new Jt('Range formulas not allowed for groups')}
function Wl(a){var b,c,d;if(qh(a,{l:0,m:0,h:0})){c=lh(a,{l:1755648,m:238,h:0});d=th(a,{l:1755648,m:238,h:0})}else{b=Ah(a,1);c=lh(b,{l:877824,m:119,h:0});d=th(b,{l:877824,m:119,h:0});d=jh(yh(d,1),kh(a,{l:1,m:0,h:0}))}return xh(yh(d,32),kh(c,{l:Yu,m:1023,h:0}))}
function es(a,b){if(fs(a,b))return 0;if(Kj(a.o,'C')){if(Kj(b.o,'C'))return a.d-b.d;return -1}if(Kj(a.o,'H')){if(Kj(b.o,'C'))return 1;if(Kj(b.o,'H'))return a.d-b.d;return -1}if(Kj(b.o,'H')||Kj(b.o,'C')){return 1}if(Kj(a.o,b.o))return a.d-b.d;return $j(a.o,b.o)}
function om(a,b){nm();var c,d,e,f,g,h,i,j,k;if(b.g>a.g){h=a;a=b;b=h}if(b.g<63){return um(a,b)}g=(a.g&-2)<<4;j=wl(a,g);k=wl(b,g);d=hm(a,ul(j,g));e=hm(b,ul(k,g));i=om(j,k);c=om(d,e);f=om(hm(j,d),hm(e,k));f=cm(cm(f,i),c);f=ul(f,g);i=ul(i,g<<1);return cm(cm(i,f),c)}
function bh(a){var b,c,d;c=a.l;if((c&c-1)!=0){return -1}d=a.m;if((d&d-1)!=0){return -1}b=a.h;if((b&b-1)!=0){return -1}if(b==0&&d==0&&c==0){return -1}if(b==0&&d==0&&c!=0){return mj(c)}if(b==0&&d!=0&&c==0){return mj(d)+22}if(b!=0&&d==0&&c==0){return mj(b)+44}return -1}
function Qg(a){var b=this;if(a=='$wnd'){return $wnd}else if(a===''){return b}if(a.substring(0,5)=='$wnd.'){b=$wnd;a=a.substring(5)}var c=a.split('.');!(c[0] in b)&&b.execScript&&b.execScript('var '+c[0]);for(var d;c.length&&(d=c.shift());){b[d]?(b=b[d]):(b=b[d]={})}return b}
function Lk(a,b){var c;Gc(b);c=5-a.j;if(c==0){return a}if(c>0){if(c<Ek.length&&a.d+Fk[he(c)]<54){return new Qk(a.k*Ek[he(c)])}return new Sk(tm((!a.f&&(a.f=Ll(a.k)),a.f),he(c)))}if(a.d<54&&-c<Ek.length){return Xk(a.k,Ek[he(-c)],b)}return Wk((!a.f&&(a.f=Ll(a.k)),a.f),wm(-c),b)}
function Os(a){var b,c,d;d='Element: '+a.d+' - symbol: '+a.n+' - exact mass: '+a.g+' - mass: '+a.f+' - name: '+a.j+' - nb isotope: '+a.e.e+'\r\n';for(c=Wn(new Xn(a.e));vn(c.d);){b=_n(c);d+='Number: '+b.f+' - mass: '+b.e+' - percentage: '+b.g+' - symbol: '+b.d+'\r\n'}return d}
function ms(a,b,c,d){var e;if(c>d)throw new Jt('Error: minCount>maxCount');if(b==0){this.g=c;this.f=d;this.j=Ms(a);this.k=a.k;this.d=0;this.o=a.n;this.e=a.f;return}e=en(a.e,new gj(b));if(!e)throw new Jt('Isotope not found');this.d=b;this.o=a.n;this.e=e.e;this.j=e.e;this.g=c;this.f=d}
function Rl(a,b){var c,d,e,f,g;d=b>>5;b&=31;if(d>=a.g){return a.j<0?(il(),cl):(il(),hl)}f=a.g-d;e=Td(le,Xu,0,f+1,7,1);Sl(e,f,a.d,d,b);if(a.j<0){for(c=0;c<d&&a.d[c]==0;c++);if(c<d||b>0&&a.d[c]<<32-b!=0){for(c=0;c<f&&e[c]==-1;c++){e[c]=0}c==f&&++f;++e[c]}}g=new Al(a.j,f,e);ll(g);return g}
function lr(a,b,c,d){var e,f;if(!b){return c}else{e=a.e.ab(c.f,b.f);if(e==0){d.g=eo(b,c.g);d.e=true;return b}f=e<0?0:1;b.d[f]=lr(a,b.d[f],c,d);if(mr(b.d[f])){if(mr(b.d[1-f])){b.e=true;b.d[0].e=false;b.d[1].e=false}else{mr(b.d[f].d[f])?(b=tr(b,1-f)):mr(b.d[f].d[1-f])&&(b=sr(b,1-f))}}}return b}
function Kc(a,b){var c,d,e,f;a=''+a;c=new uk(a.length+16*b.length);f=0;d=0;while(d<b.length){e=a.indexOf('%s',f);if(e==-1){break}rk(c,a.substr(f,e-f));qk(c,b[d++]);f=e+2}rk(c,Xj(a,f,a.length-f));if(d<b.length){c.d+=' [';qk(c,b[d++]);while(d<b.length){c.d+=', ';qk(c,b[d++])}c.d+=']'}return c.d}
function il(){il=Mg;var a;dl=new zl(1,1);fl=new zl(1,10);hl=new zl(0,0);cl=new zl(-1,1);el=Wd(Sd(kf,1),Xu,5,0,[hl,dl,new zl(1,2),new zl(1,3),new zl(1,4),new zl(1,5),new zl(1,6),new zl(1,7),new zl(1,8),new zl(1,9),fl]);gl=Td(kf,Xu,5,32,0,1);for(a=0;a<gl.length;a++){gl[a]=Ml(yh({l:1,m:0,h:0},a))}}
function fu(){fu=Mg;eu=new Ap;jn(eu,'O',pj(0));jn(eu,'N',pj(1));jn(eu,'H',pj(-1));jn(eu,'C',pj(2));jn(eu,'F',pj(-1));jn(eu,'Cl',pj(-1));jn(eu,'Br',pj(-1));jn(eu,'I',pj(-1));jn(eu,'S',pj(0));jn(eu,'P',pj(1));jn(eu,'Li',pj(-1));jn(eu,'Na',pj(-1));jn(eu,'K',pj(-1));jn(eu,'Ca',pj(0));jn(eu,'Mg',pj(0))}
function Bu(a,b,c){var d,e,f,g,h,i,j,k;h=new Su;k=a.f.kb('referenceVersion');k!=null&&!Kj(k,'')&&(c=(It(),It(),Gt));if(c){i=new Mu;Pu(h,'elements',i.d);for(e=Wn(new Xn(c));vn(e.d);){d=_n(e);Lu(i,Ns(d).d)}}if(b){j=new Mu;Pu(h,'groups',j.d);for(g=Wn(new Xn(b));vn(g.d);){f=_n(g);Lu(j,Bt(f).d)}}return h}
function ft(b){var c,d,e;e=Rj(b,'/',0);if(e.length!=2)throw new Jt('Syntax error: bad fraction syntax: '+b);try{c=Qi(e[1]);if(c==0)throw new Jt('Syntax error: divide by zero: '+b);d=Qi(e[0]);return d/c}catch(a){a=Ig(a);if(ae(a,20)){throw new Jt('Syntax error: bad fraction syntax: '+b)}else throw Hg(a)}}
function nm(){nm=Mg;var a,b;km=Td(kf,Xu,5,32,0,1);lm=Td(kf,Xu,5,32,0,1);mm=Wd(Sd(le,1),Xu,0,7,[1,10,100,1000,10000,hv,iv,10000000,100000000,cv]);a={l:1,m:0,h:0};for(b=0;b<=18;b++){km[b]=Ml(a);lm[b]=Ml(yh(a,b));a=uh(a,{l:5,m:0,h:0})}for(;b<lm.length;b++){km[b]=sl(km[b-1],km[1]);lm[b]=sl(lm[b-1],(il(),fl))}}
function qm(a,b,c,d,e){var f,g,h,i;if(fe(a)===fe(b)&&d==e){xm(a,d,c);return}for(h=0;h<d;h++){g={l:0,m:0,h:0};f=a[h];for(i=0;i<e;i++){g=jh(jh(uh(kh(oh(f),{l:Yu,m:1023,h:0}),kh(oh(b[i]),{l:Yu,m:1023,h:0})),kh(oh(c[h+i]),{l:Yu,m:1023,h:0})),kh(oh(Dh(g)),{l:Yu,m:1023,h:0}));c[h+i]=Dh(g);g=Ah(g,32)}c[h+e]=Dh(g)}}
function at(a){var b,c,d,e;if(a.f)throw new Jt('Cannot calculate mass: this is a range formula');if(a.j)throw new Jt('The mass is not defined');d=0;for(c=new Jn(a.g);c.d<c.f.K();){b=(Ec(c.d<c.f.K()),c.f.V(c.e=c.d++));d+=ot(b)*b.k}return e=isNaN(d*iv)?d*iv:Xi(d*iv)?d*iv:d*iv==0?d*iv:Ch(nh(Math.round(d*iv))),e/iv}
function bt(a){var b,c,d,e;if(a.f)throw new Jt('Cannot calculate mass: this is a range formula');if(a.j)throw new Jt('The mass is not clearly defined');b=0;for(d=new Jn(a.g);d.d<d.f.K();){c=(Ec(d.d<d.f.K()),d.f.V(d.e=d.d++));b+=pt(c)*c.k}return e=isNaN(b*jv)?b*jv:Xi(b*jv)?b*jv:b*jv==0?b*jv:Ch(nh(Math.round(b*jv))),e/jv}
function sm(a,b){var c,d,e,f,g,h,i,j,k;j=a.j;if(j==0){return il(),hl}d=a.g;c=a.d;if(d==1){e=uh(kh(oh(c[0]),{l:Yu,m:1023,h:0}),kh(oh(b),{l:Yu,m:1023,h:0}));i=Dh(e);g=Dh(Ah(e,32));return g==0?new zl(j,i):new Al(j,2,Wd(Sd(le,1),Xu,0,7,[i,g]))}h=d+1;f=Td(le,Xu,0,h,7,1);f[d]=rm(f,c,d,b);k=new Al(j,h,f);ll(k);return k}
function um(a,b){var c,d,e,f,g,h,i,j,k,l,m;d=a.g;f=b.g;h=d+f;i=a.j!=b.j?-1:1;if(h==2){k=uh(kh(oh(a.d[0]),{l:Yu,m:1023,h:0}),kh(oh(b.d[0]),{l:Yu,m:1023,h:0}));m=Dh(k);l=Dh(Ah(k,32));return l==0?new zl(i,m):new Al(i,2,Wd(Sd(le,1),Xu,0,7,[m,l]))}c=a.d;e=b.d;g=Td(le,Xu,0,h,7,1);pm(c,d,e,f,g);j=new Al(i,h,g);ll(j);return j}
function Jl(a,b){var c,d,e,f,g,h,i,j,k,l,m,n,o,p;m=b.length;i=m;if(b.charCodeAt(0)==45){k=-1;l=1;--m}else{k=1;l=0}f=(Vl(),Ul)[10];e=~~(m/f);p=m%f;p!=0&&++e;h=Td(le,Xu,0,e,7,1);c=Tl[8];g=0;n=l+(p==0?f:p);for(o=l;o<i;o=n,n=n+f){d=Qi(b.substr(o,n-o));j=(nm(),rm(h,h,g,c));j+=gm(h,g,d);h[g++]=j}a.j=k;a.g=g;a.d=h;ll(a)}
function Eh(a){var b,c,d,e,f;if(a.l==0&&a.m==0&&a.h==0){return '0'}if(a.h==$u&&a.m==0&&a.l==0){return '-9223372036854775808'}if(a.h>>19!=0){return '-'+Eh(vh(a))}c=a;d='';while(!(c.l==0&&c.m==0&&c.h==0)){e=oh(cv);c=Wg(c,e,true);b=''+Dh(Sg);if(!(c.l==0&&c.m==0&&c.h==0)){f=9-b.length;for(;f>0;f--){b='0'+b}}d=b+d}return d}
function Ns(a){var b,c,d,e,f,g;d=new Su;Ru(d,'symbol',a.n);Pu(d,'monoisotopicMass',new jd(a.g));Pu(d,'mass',new jd(a.f));Ru(d,'name',a.j);Pu(d,'atomicNumber',new jd(a.d));f=new Mu;Pu(d,'isotopes',f.d);for(c=Wn(new Xn(a.e));vn(c.d);){b=_n(c);e=(g=new Su,Pu(g,'mass',new jd(b.e)),Pu(g,'percentage',new jd(b.g)),g);Lu(f,e.d)}return d}
function Gu(a,b){var c,d,e,f;f='';for(d=new Jn(a.d);d.d<d.f.K();){c=(Ec(d.d<d.f.K()),d.f.V(d.e=d.d++));e=hs(c.d);(e==null?!!Ep(b.d,null):!(b.f.kb(e)===undefined))&&(Kj((e==null?Ym(Ep(b.d,null)):b.f.kb(e)).f.substr(0,1),'{')?(e=(e==null?Ym(Ep(b.d,null)):b.f.kb(e)).f):(e=(e==null?Ym(Ep(b.d,null)):b.f.kb(e)).e));c.e>1?(f+=e+c.e):c.e>0&&(f+=e)}return f}
function Mt(a){var b,c,d,e,f;c=true;for(e=new Jn(a.g.g);e.d<e.f.K();){d=(Ec(e.d<e.f.K()),e.f.V(e.e=e.d++));if(c){a.j=new au(a,d,a.f);ys(a.j.f,d.k);b=a.j;c=false}else{b=new au(a,d,a.f);ys(b.f,d.k);ss(a.j.f,b.f)}if(d.e!=''){f=new Si(ws(b.f));an(a.n,f)?hn(a.n,f,en(a.n,f)+','+d.e):hn(a.n,f,d.e)}}if(a.j.f.g==0)throw new Jt('Isotopic distribution: empty table')}
function Qi(a){var b,c,d,e,f;if(a==null){throw new Ej('null')}d=a.length;e=d>0&&(a.charCodeAt(0)==45||a.charCodeAt(0)==43)?1:0;for(b=e;b<d;b++){if(ni(a.charCodeAt(b))==-1){throw new Ej('For input string: "'+a+'"')}}f=parseInt(a,10);c=f<ev;if(isNaN(f)){throw new Ej('For input string: "'+a+'"')}else if(c||f>Uu){throw new Ej('For input string: "'+a+'"')}return f}
function ml(a,b){var c,d,e,f,g,h,i,j,k,l,m,n,o;f=b.j;if(f==0){throw new $h('BigInteger divide by zero')}e=b.g;d=b.d;if(e==1){return $l(a,d[0],f)}m=a.d;n=a.g;c=n!=e?n>e?1:-1:fm(m,d,n);if(c<0){return Wd(Sd(kf,1),Xu,5,0,[hl,a])}o=a.j;h=n-e+1;i=o==f?1:-1;g=Td(le,Xu,0,h,7,1);j=Zl(g,h,m,n,d,e);k=new Al(i,h,g);l=new Al(o,e,j);ll(k);ll(l);return Wd(Sd(kf,1),Xu,5,0,[k,l])}
function Jk(a,b){var c,d,e,f,g,h;e=Nk(a);h=Nk(b);if(e==h){if(a.j==b.j&&a.d<54&&b.d<54){return a.k<b.k?-1:a.k>b.k?1:0}d=a.j-b.j;c=(a.g>0?a.g:vj((a.d-1)*kv)+1)-(b.g>0?b.g:vj((b.d-1)*kv)+1);if(c>d+1){return e}else if(c<d-1){return -e}else{f=(!a.f&&(a.f=Ll(a.k)),a.f);g=(!b.f&&(b.f=Ll(b.k)),b.f);d<0?(f=sl(f,wm(-d))):d>0&&(g=sl(g,wm(d)));return kl(f,g)}}else return e<h?-1:1}
function $l(a,b,c){var d,e,f,g,h,i,j,k,l,m,n,o;m=a.d;n=a.g;o=a.j;if(n==1){d=kh(oh(m[0]),{l:Yu,m:1023,h:0});e=kh(oh(b),{l:Yu,m:1023,h:0});f=lh(d,e);i=th(d,e);o!=c&&(f=vh(f));o<0&&(i=vh(i));return Wd(Sd(kf,1),Xu,5,0,[Ml(f),Ml(i)])}h=o==c?1:-1;g=Td(le,Xu,0,n,7,1);j=Wd(Sd(le,1),Xu,0,7,[_l(g,m,n,b)]);k=new Al(h,n,g);l=new Al(o,1,j);ll(k);ll(l);return Wd(Sd(kf,1),Xu,5,0,[k,l])}
function bm(a,b,c,d,e){var f,g,h;f={l:0,m:0,h:0};g={l:0,m:0,h:0};for(h=0;h<d;h++){f=(nm(),jh(uh(kh(oh(c[h]),{l:Yu,m:1023,h:0}),kh(oh(e),{l:Yu,m:1023,h:0})),kh(oh(Dh(f)),{l:Yu,m:1023,h:0})));g=jh(Bh(kh(oh(a[b+h]),{l:Yu,m:1023,h:0}),kh(f,{l:Yu,m:1023,h:0})),g);a[b+h]=Dh(g);g=zh(g,32);f=Ah(f,32)}g=jh(Bh(kh(oh(a[b+d]),{l:Yu,m:1023,h:0}),f),g);a[b+d]=Dh(g);return Dh(zh(g,32))}
function am(a,b){var c,d,e,f,g;d=kh(oh(b),{l:Yu,m:1023,h:0});if(qh(a,{l:0,m:0,h:0})){f=lh(a,d);g=th(a,d)}else{c=Ah(a,1);e=oh(b>>>1);f=lh(c,e);g=th(c,e);g=jh(yh(g,1),kh(a,{l:1,m:0,h:0}));if((b&1)!=0){if(sh(f,g)){g=Bh(g,f)}else{if(sh(Bh(f,g),d)){g=jh(g,Bh(d,f));f=Bh(f,{l:1,m:0,h:0})}else{g=jh(g,Bh(yh(d,1),f));f=Bh(f,{l:2,m:0,h:0})}}}}return xh(yh(g,32),kh(f,{l:Yu,m:1023,h:0}))}
function mu(a,b,c){lu();var d,e,f,g,h,i,j,k,l,m,n,o;i=~~(~~((b.e-1)/b.d)/2);h=a[0][0];g=a[a.length-1][0];k=Dh(nh(Aj((g-h)/c*b.d)))+2*b.d*i+1;o=Td(ke,gv,0,k,7,1);for(m=0,n=a.length;m<n;++m){l=a[m];d=Dh(nh(Aj((l[0]-h)/c*b.d+b.d*i)));for(f=0;f<b.f.length;f++){o[d+f-b.d*i]+=b.f[f]*l[1]}}j=Ud(ke,[Xu,gv],[28,0],7,[k,2],2);for(e=0;e<k;e++){j[e][0]=(e/b.d-i)*c+h;j[e][1]=o[e]}return j}
function _k(a,b,c){var d;d=0;switch(c.e){case 7:if(b!=0){throw new $h('Rounding necessary')}break;case 0:d=b==0?0:b<0?-1:1;break;case 2:d=(b==0?0:b<0?-1:1)>0?b==0?0:b<0?-1:1:0;break;case 3:d=(b==0?0:b<0?-1:1)<0?b==0?0:b<0?-1:1:0;break;case 4:(b<0?-b:b)>=5&&(d=b==0?0:b<0?-1:1);break;case 5:(b<0?-b:b)>5&&(d=b==0?0:b<0?-1:1);break;case 6:(b<0?-b:b)+a>5&&(d=b==0?0:b<0?-1:1);}return d}
function At(a,b,c,d){var e,f,g,h,i,j,k,l,m;if(b.indexOf(',')==-1)throw new Jt('Syntax error: combinatorial');if(c!=d)throw new Jt('Combinatorial range formulae are not allowed');j=Rj(b,',',0);i=0;h=j.length;m=new ok('{');for(g=0;g<h-1;g++){l=Uj(j[g]);f=new vt(l,a.f,a.g);mk(m,tt(f)+',');i+=ot(f)}k=Uj(j[h-1]);e=new vt(k,a.f,a.g);mk(m,tt(e)+'}');i+=ot(e);i/=h;lt(a,new ks(m.d,i,c,d))}
function wu(a){var b=a;if(a.search(/[A-Z]{3} [A-Z]{3} [A-Z]{3}/)>-1){var c=a.replace(/[\r\n]+/g,' ');c=c.replace(/(SEQRES|[0-9]+| [A-Z] | [0-9A-Z]{4-50})/g,'');var d=c.split(' ');b='H';for(var e=0;e<d.length;e++){b+=d[e].substr(0,1)+d[e].substr(1).toLowerCase()}b+='OH'}else a.search(/[A-Z]{3}/)>-1&&a.search(/[a-zA-Z][a-z0-9]/)==-1&&(b='H'+vu(b.replace(/[^A-Z]/g,''))+'OH');return b}
function Zg(a,b,c,d,e,f){var g,h,i,j,k,l,m;j=ah(b)-ah(a);g=yh(b,j);i=Vg(0,0,0);while(j>=0){h=hh(a,g);if(h){j<22?(i.l|=1<<j,undefined):j<44?(i.m|=1<<j-22,undefined):(i.h|=1<<j-44,undefined);if(a.l==0&&a.m==0&&a.h==0){break}}k=g.m;l=g.h;m=g.l;dh(g,l>>>1);g.m=k>>>1|(l&1)<<21;g.l=m>>>1|(k&1)<<21;--j}c&&_g(i);if(f){if(d){Sg=vh(a);e&&(Sg=Bh(Sg,(Kh(),Ih)))}else{Sg=Vg(a.l,a.m,a.h)}}return i}
function Wh(){var a=navigator.userAgent.toLowerCase();var b=$doc.documentMode;if(function(){return a.indexOf('webkit')!=-1}())return 'safari';if(function(){return a.indexOf('msie')!=-1&&b>=10&&b<11}())return 'ie10';if(function(){return a.indexOf('msie')!=-1&&b>=9&&b<11}())return 'ie9';if(function(){return a.indexOf('msie')!=-1&&b>=8&&b<11}())return 'ie8';if(function(){return a.indexOf('gecko')!=-1||b>=11}())return 'gecko1_8';return 'unknown'}
function wm(a){nm();var b,c,d,e;b=he(a);if(a<lm.length){return lm[b]}else if(a<=50){return tl((il(),fl),b)}else if(a<=1000){return ul(tl(km[1],b),b)}if(a>iv){throw new $h('power of ten too big')}if(a<=Uu){return ul(tl(km[1],b),b)}d=tl(km[1],Uu);e=d;c=nh(a-Uu);b=he(a%Uu);while(ph(c,{l:Yu,m:511,h:0})){e=sl(e,d);c=Bh(c,{l:Yu,m:511,h:0})}e=sl(e,tl(km[1],b));e=ul(e,Uu);c=nh(a-Uu);while(ph(c,{l:Yu,m:511,h:0})){e=ul(e,Uu);c=Bh(c,{l:Yu,m:511,h:0})}e=ul(e,b);return e}
function Rj(l,a,b){var c=new RegExp(a,'g');var d=[];var e=0;var f=l;var g=null;while(true){var h=c.exec(f);if(h==null||f==''||e==b-1&&b>0){d[e]=f;break}else{d[e]=f.substring(0,h.index);f=f.substring(h.index+h[0].length,f.length);c.lastIndex=0;if(g==f){d[e]=f.substring(0,1);f=f.substring(1)}g=f;e++}}if(b==0&&l.length>0){var i=d.length;while(i>0&&d[i-1]==''){--i}i<d.length&&d.splice(i,d.length-i)}var j=Wj(d.length);for(var k=0;k<d.length;++k){j[k]=d[k]}return j}
function hm(a,b){var c,d,e,f,g,h,i,j,k,l;g=a.j;i=b.j;if(i==0){return a}if(g==0){return b.j==0?b:new Al(-b.j,b.g,b.d)}f=a.g;h=b.g;if(f+h==2){c=kh(oh(a.d[0]),{l:Yu,m:1023,h:0});d=kh(oh(b.d[0]),{l:Yu,m:1023,h:0});g<0&&(c=vh(c));i<0&&(d=vh(d));return Ml(Bh(c,d))}e=f!=h?f>h?1:-1:fm(a.d,b.d,f);if(e==-1){l=-i;k=g==i?im(b.d,h,a.d,f):dm(b.d,h,a.d,f)}else{l=g;if(g==i){if(e==0){return il(),hl}k=im(a.d,f,b.d,h)}else{k=dm(a.d,f,b.d,h)}}j=new Al(l,k.length,k);ll(j);return j}
function _l(a,b,c,d){var e,f,g,h,i,j,k;j={l:0,m:0,h:0};f=kh(oh(d),{l:Yu,m:1023,h:0});for(h=c-1;h>=0;h--){k=xh(yh(j,32),kh(oh(b[h]),{l:Yu,m:1023,h:0}));if(qh(k,{l:0,m:0,h:0})){i=lh(k,f);j=th(k,f)}else{e=Ah(k,1);g=oh(d>>>1);i=lh(e,g);j=th(e,g);j=jh(yh(j,1),kh(k,{l:1,m:0,h:0}));if((d&1)!=0){if(sh(i,j)){j=Bh(j,i)}else{if(sh(Bh(i,j),f)){j=jh(j,Bh(f,i));i=Bh(i,{l:1,m:0,h:0})}else{j=jh(j,Bh(yh(f,1),i));i=Bh(i,{l:2,m:0,h:0})}}}}a[h]=Dh(kh(i,{l:Yu,m:1023,h:0}))}return Dh(j)}
function xk(a,b,c,d,e){var f,g,h,i,j,k,l,m,n;Hc(a,'src');Hc(c,'dest');m=ib(a);i=ib(c);Bc((m.j&4)!=0,'srcType is not an array');Bc((i.j&4)!=0,'destType is not an array');l=m.f;g=i.f;Bc((l.j&1)!=0?l==g:(g.j&1)==0,"Array types don't match");n=a.length;j=c.length;if(b<0||d<0||e<0||b+e>n||d+e>j){throw new _h}if(((l.j&1)==0||(l.j&4)!=0)&&m!=i){k=a;f=c;if(fe(a)===fe(c)&&b<d){b+=e;for(h=d+e;h-->d;){f[h]=k[--b]}}else{for(h=d+e;d<h;){f[d++]=k[b++]}}}else e>0&&Yd(a,b,c,d,e,true)}
function Vl(){Vl=Mg;Tl=Wd(Sd(le,1),Xu,0,7,[ev,1162261467,mv,1220703125,362797056,1977326743,mv,387420489,cv,214358881,429981696,815730721,1475789056,170859375,268435456,410338673,612220032,893871739,1280000000,1801088541,113379904,148035889,191102976,244140625,308915776,387420489,481890304,594823321,729000000,887503681,mv,1291467969,1544804416,1838265625,60466176]);Ul=Wd(Sd(le,1),Xu,0,7,[-1,-1,31,19,15,13,11,11,10,9,9,8,8,8,8,7,7,7,7,7,7,7,6,6,6,6,6,6,6,6,6,6,6,6,6,6,5])}
function Ok(a){var b,c,d,e,f;if(a.n!=null){return a.n}if(a.d<32){a.n=Xl(nh(a.k),he(a.j));return a.n}e=Yl((!a.f&&(a.f=Ll(a.k)),a.f),0);if(a.j==0){return e}b=(!a.f&&(a.f=Ll(a.k)),a.f).j<0?2:1;c=e.length;d=-a.j+c-b;f=new tk;f.d+=e;if(a.j>0&&d>=-6){if(d>=0){sk(f,c-he(a.j),'.')}else{f.d=Tj(f.d,0,b-1)+'0.'+Sj(f.d,b-1);sk(f,b+1,ek(Bk,0,-he(d)-1))}}else{if(c-b>=1){f.d=Tj(f.d,0,b)+'.'+Sj(f.d,b);++c}f.d=Tj(f.d,0,c)+'E'+Sj(f.d,c);d>0&&sk(f,++c,'+');sk(f,++c,''+Eh(nh(d)))}a.n=f.d;return a.n}
function Ot(b){var c,d,e;if(b.j.f.g==0)throw new ub('No isotopic distribution data');nr(b.j.f,new Si(Bo(fr(b.j.f)).d-2),new Si(0));nr(b.j.f,new Si(Bo(gr(b.j.f)).d+2),new Si(0));d=new Ap;jn(d,'Resolution',b.e+'');jn(d,'Threshold',b.d+'');try{if(b.g.g.e.length==1){e=So(b.g.g,0);jn(d,'Monoisotopic mass',pt(e)+'');jn(d,'Molecular weight',ot(e)+'');!!hu(e)&&jn(d,'Unsaturation',hu(e)+'')}}catch(a){a=Ig(a);if(ae(a,7)){c=a;ob(c)}else throw Hg(a)}return Cs(b.j.f,b.g+' - resolution: '+b.e,b.n,d)}
function Wk(a,b,c){var d,e,f,g,h,i,j;f=ml(a,b);g=f[0];i=f[1];if(i.j==0){return new Sk(g)}j=a.j*b.j;if(Nl(b)<54){h=rl(i);e=rl(b);d=rh(yh(rh(h,{l:0,m:0,h:0})?vh(h):h,1),rh(e,{l:0,m:0,h:0})?vh(e):e)?-1:ph(yh(rh(h,{l:0,m:0,h:0})?vh(h):h,1),rh(e,{l:0,m:0,h:0})?vh(e):e)?1:0;d=_k(xl(g,0)?1:0,j*(5+d),c)}else{d=kl(vl(i.j<0?new Al(1,i.g,i.d):i),b.j<0?new Al(1,b.g,b.d):b);d=_k(xl(g,0)?1:0,j*(5+d),c)}if(d!=0){if(Nl(g)<54){return bl(jh(rl(g),oh(d)))}g=cm(g,Ml(oh(d)));return new Sk(g)}return new Sk(g)}
function ak(a,b,c){if(c<128){a[b]=ge(c&127);return 1}else if(c<2048){a[b++]=ge(c>>6&31|192);a[b]=ge(c&63|128);return 2}else if(c<dv){a[b++]=ge(c>>12&15|224);a[b++]=ge(c>>6&63|128);a[b]=ge(c&63|128);return 3}else if(c<2097152){a[b++]=ge(c>>18&7|240);a[b++]=ge(c>>12&63|128);a[b++]=ge(c>>6&63|128);a[b]=ge(c&63|128);return 4}else if(c<67108864){a[b++]=ge(c>>24&3|248);a[b++]=ge(c>>18&63|128);a[b++]=ge(c>>12&63|128);a[b++]=ge(c>>6&63|128);a[b]=ge(c&63|128);return 5}throw new dj('Character out of range: '+c)}
function kt(b,c,d,e,f,g){var h,i,j,k,l,m;if(c.charCodeAt(0)==91){h=1;while(oi(c.charCodeAt(h)))++h;if(f==0){try{f=Qi(c.substr(1,h-1))}catch(a){a=Ig(a);if(ae(a,7)){throw new Jt('Bad isotope syntax')}else throw Hg(a)}}c=Tj(c,h,c.length-1)}i=fn(b.f,c);if(!i){l=fn(b.g,c);if(!l)throw new Jt('Unrecognized symbol: '+c);if(f!=0)throw new Jt('Syntax error: cannot specify isotopes for groups');if(g){k=Go(new Ho(l.d.n));while(Gn(k.d.d)){j=Lo(k);m=new ls(j);m.g*=d;m.f*=e;lt(b,m)}}else{lt(b,new ns(l,d,e))}}else{lt(b,new ms(i,f,d,e))}}
function cm(a,b){var c,d,e,f,g,h,i,j,k,l,m,n,o;g=a.j;i=b.j;if(g==0){return b}if(i==0){return a}f=a.g;h=b.g;if(f+h==2){c=kh(oh(a.d[0]),{l:Yu,m:1023,h:0});d=kh(oh(b.d[0]),{l:Yu,m:1023,h:0});if(g==i){k=jh(c,d);o=Dh(k);n=Dh(Ah(k,32));return n==0?new zl(g,o):new Al(g,2,Wd(Sd(le,1),Xu,0,7,[o,n]))}return Ml(g<0?Bh(d,c):Bh(c,d))}else if(g==i){m=g;l=f>=h?dm(a.d,f,b.d,h):dm(b.d,h,a.d,f)}else{e=f!=h?f>h?1:-1:fm(a.d,b.d,f);if(e==0){return il(),hl}if(e==1){m=g;l=im(a.d,f,b.d,h)}else{m=i;l=im(b.d,h,a.d,f)}}j=new Al(m,l.length,l);ll(j);return j}
function em(a,b,c,d,e){var f,g;f=jh(kh(oh(b[0]),{l:Yu,m:1023,h:0}),kh(oh(d[0]),{l:Yu,m:1023,h:0}));a[0]=Dh(f);f=zh(f,32);if(c>=e){for(g=1;g<e;g++){f=jh(f,jh(kh(oh(b[g]),{l:Yu,m:1023,h:0}),kh(oh(d[g]),{l:Yu,m:1023,h:0})));a[g]=Dh(f);f=zh(f,32)}for(;g<c;g++){f=jh(f,kh(oh(b[g]),{l:Yu,m:1023,h:0}));a[g]=Dh(f);f=zh(f,32)}}else{for(g=1;g<c;g++){f=jh(f,jh(kh(oh(b[g]),{l:Yu,m:1023,h:0}),kh(oh(d[g]),{l:Yu,m:1023,h:0})));a[g]=Dh(f);f=zh(f,32)}for(;g<e;g++){f=jh(f,kh(oh(d[g]),{l:Yu,m:1023,h:0}));a[g]=Dh(f);f=zh(f,32)}}wh(f,{l:0,m:0,h:0})&&(a[g]=Dh(f))}
function xm(a,b,c){var d,e,f,g,h;for(f=0;f<b;f++){d={l:0,m:0,h:0};for(h=f+1;h<b;h++){d=jh(jh(uh(kh(oh(a[f]),{l:Yu,m:1023,h:0}),kh(oh(a[h]),{l:Yu,m:1023,h:0})),kh(oh(c[f+h]),{l:Yu,m:1023,h:0})),kh(oh(Dh(d)),{l:Yu,m:1023,h:0}));c[f+h]=Dh(d);d=Ah(d,32)}c[f+b]=Dh(d)}Ql(c,c,b<<1);d={l:0,m:0,h:0};for(e=0,g=0;e<b;++e,g++){d=jh(jh(uh(kh(oh(a[e]),{l:Yu,m:1023,h:0}),kh(oh(a[e]),{l:Yu,m:1023,h:0})),kh(oh(c[g]),{l:Yu,m:1023,h:0})),kh(oh(Dh(d)),{l:Yu,m:1023,h:0}));c[g]=Dh(d);d=Ah(d,32);++g;d=jh(d,kh(oh(c[g]),{l:Yu,m:1023,h:0}));c[g]=Dh(d);d=Ah(d,32)}return c}
function uh(a,b){var c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,A,B,C,D,F,G;c=a.l&8191;d=a.l>>13|(a.m&15)<<9;e=a.m>>4&8191;f=a.m>>17|(a.h&255)<<5;g=(a.h&1048320)>>8;h=b.l&8191;i=b.l>>13|(b.m&15)<<9;j=b.m>>4&8191;k=b.m>>17|(b.h&255)<<5;l=(b.h&1048320)>>8;B=c*h;C=d*h;D=e*h;F=f*h;G=g*h;if(i!=0){C+=c*i;D+=d*i;F+=e*i;G+=f*i}if(j!=0){D+=c*j;F+=d*j;G+=e*j}if(k!=0){F+=c*k;G+=d*k}l!=0&&(G+=c*l);n=B&Yu;o=(C&511)<<13;m=n+o;q=B>>22;r=C>>9;s=(D&262143)<<4;t=(F&31)<<17;p=q+r+s+t;v=D>>18;w=F>>5;A=(G&4095)<<8;u=v+w+A;p+=m>>22;m&=Yu;u+=p>>22;p&=Yu;u&=Zu;return Vg(m,p,u)}
function Vh(a){Uh.call(this,''+('Possible problem with your *.gwt.xml module file.\nThe compile time user.agent value (safari) does not match the runtime user.agent value ('+a+').\n'+'Expect more errors.'),ae('Possible problem with your *.gwt.xml module file.\nThe compile time user.agent value (safari) does not match the runtime user.agent value ('+a+').\n'+'Expect more errors.',9)?'Possible problem with your *.gwt.xml module file.\nThe compile time user.agent value (safari) does not match the runtime user.agent value ('+a+').\n'+'Expect more errors.':null)}
function Ut(a,b){var c,d,e,f,g,h,i,j,k,l,m;m=new xt(new cu(a));Jm(m,b);j=1;for(e=Go(new Ho(m.n));Gn(e.d.d);){c=Lo(e);h=fn(a.d,c.o);h.e.e>j&&(j=h.e.e)}k=2*j*wj(rt(m)+1)/wj(2);l=a.g.e/(k*4);Zt(a,l);nr(a.f,new Si(0),new Si(1));for(d=Go(new Ho(m.n));Gn(d.d.d);){c=Lo(d);h=fn(a.d,c.o);if(c.d!=0){f=new Ps(c.e,c.e,h.n,h.j,h.d);h=f}if(h.e.e==0){i=new Dt(he(h.f+0.5),h.f,1,h.n);hn(h.e,new gj(i.f),i)}if(gs(c)<0){throw new Jt('Number of element under 0')}else if(gs(c)==0);else if(gs(c)==1){a.f=Vt(a,new _t(a.g,h,a.d))}else{g=new _t(a.g,h,a.d);Zt(g,a.e);a.f=Vt(a,Tt(g,gs(c)))}}}
function Wg(a,b,c){var d,e,f,g,h,i;if(b.l==0&&b.m==0&&b.h==0){throw new $h('divide by zero')}if(a.l==0&&a.m==0&&a.h==0){c&&(Sg=Vg(0,0,0));return Vg(0,0,0)}if(b.h==$u&&b.m==0&&b.l==0){return Xg(a,c)}i=false;if(b.h>>19!=0){b=vh(b);i=true}g=bh(b);f=false;e=false;d=false;if(a.h==$u&&a.m==0&&a.l==0){e=true;f=true;if(g==-1){a=Ug((Kh(),Gh));d=true;i=!i}else{h=zh(a,g);i&&_g(h);c&&(Sg=Vg(0,0,0));return h}}else if(a.h>>19!=0){f=true;a=vh(a);d=true;i=!i}if(g!=-1){return Yg(a,g,i,f,c)}if(!qh(a,b)){c&&(f?(Sg=vh(a)):(Sg=Vg(a.l,a.m,a.h)));return Vg(0,0,0)}return Zg(d?a:Vg(a.l,a.m,a.h),b,i,f,e,c)}
function vc(a,b){var c,d,e,f,g,h,i,j,k;if(!b.length){return a.u('Unknown','anonymous',-1,-1)}k=Uj(b);Kj(k.substr(0,3),'at ')&&(k=Xj(k,3,k.length-3));k=k.replace(/\[.*?\]/g,'');g=k.indexOf('(');if(g==-1){g=k.indexOf('@');if(g==-1){j=k;k=''}else{j=Uj(Xj(k,g+1,k.length-(g+1)));k=Uj(k.substr(0,g))}}else{c=k.indexOf(')',g);j=k.substr(g+1,c-(g+1));k=Uj(k.substr(0,g))}g=Mj(k,bk(46));g!=-1&&(k=Xj(k,g+1,k.length-(g+1)));(!k.length||Kj(k,'Anonymous function'))&&(k='anonymous');h=Nj(j,bk(58));e=Oj(j,bk(58),h-1);i=-1;d=-1;f='Unknown';if(h!=-1&&e!=-1){f=j.substr(0,e);i=qc(j.substr(e+1,h-(e+1)));d=qc(Xj(j,h+1,j.length-(h+1)))}return a.u(f,k,i,d)}
function qr(a,b,c){var d,e,f,g,h,i,j,k,l,m,n;if(!a.f){return false}g=null;m=null;i=new Hr(null,null);e=1;i.d[1]=a.f;l=i;while(l.d[e]){j=e;h=m;m=l;l=l.d[e];d=a.e.ab(b,l.f);e=d<0?0:1;d==0&&(!c.f||Qq(l.g,c.g))&&(g=l);if(!(!!l&&l.e)&&!mr(l.d[e])){if(mr(l.d[1-e])){m=m.d[j]=tr(l,e)}else if(!mr(l.d[1-e])){n=m.d[1-j];if(n){if(!mr(n.d[1-j])&&!mr(n.d[j])){m.e=false;n.e=true;l.e=true}else{f=h.d[1]==m?1:0;mr(n.d[j])?(h.d[f]=sr(m,j)):mr(n.d[1-j])&&(h.d[f]=tr(m,j));l.e=h.d[f].e=true;h.d[f].d[0].e=false;h.d[f].d[1].e=false}}}}}if(g){c.e=true;c.g=g.g;if(l!=g){k=new Hr(l.f,l.g);rr(a,i,g,k);m==g&&(m=k)}m.d[m.d[1]==l?1:0]=l.d[!l.d[0]?1:0];--a.g}a.f=i.d[1];!!a.f&&(a.f.e=false);return c.e}
function Wt(a,b){var c,d,e,f,g,h,i,j,k,l,m,n,o,p,q;f=b.f.d;a.f.g>f&&As(a.f);b.f.g>f&&As(b.f);k=new Gs;j=(new Gr(b.f)).d.$();e=0;while(Gn(j.d)){i=j.e=Hn(j.d);h=i.X();g=i.Y();q=(new Gr(a.f)).d.$();while(Gn(q.d)){p=q.e=Hn(q.d);o=p.X();n=p.Y();m=o.d+h.d;l=n.d*g.d;d=Xm(ir(k,new Si(m)));c=Xm(hr(k,new Si(m)));if(!!d&&Ri(d,new Si(m))){l+=uo(k,c).d}else{!!d&&sj(d.d-m)>a.e&&(d=null);!!c&&sj(c.d-m)>a.e&&(c=null);!!c&&!!d&&(sj(c.d-m)<sj(d.d-m)?(d=null):(c=null));if(c){if(uo(k,c).d>l){l+=uo(k,c).d;m=c.d}else{l+=uo(k,c).d;or(k,c)}}else if(d){if(uo(k,d).d>l){l+=uo(k,d).d;m=d.d}else{l+=uo(k,d).d;or(k,d)}}}l>a.g.d/hv&&nr(k,new Si(m),new Si(l));l>e&&(e=l)}k.g>f&&As(k)}ys(k,1/e);return k}
function Xt(a,b){var c,d,e,f,g,h,i,j,k,l,m,n,o,p,q;f=b.f.d;a.f.g>f&&As(a.f);b.f.g>f&&As(b.f);k=new Gs;j=(new Gr(b.f)).d.$();e=0;while(Gn(j.d)){i=j.e=Hn(j.d);h=i.X();g=i.Y();q=(new Gr(a.f)).d.$();while(Gn(q.d)){p=q.e=Hn(q.d);o=p.X();n=p.Y();m=o.d+h.d;l=n.d*g.d;d=Xm(ir(k,new Si(m)));c=Xm(hr(k,new Si(m)));if(!!d&&Ri(d,new Si(m))){l+=uo(k,c).d}else{!!d&&sj(d.d-m)>a.e&&(d=null);!!c&&sj(c.d-m)>a.e&&(c=null);if(!!c&&!!d){m=(m*l+c.d*uo(k,c).d+d.d*uo(k,d).d)/(l+uo(k,c).d+uo(k,d).d);l+=uo(k,c).d+uo(k,d).d;or(k,c);or(k,d)}else if(c){m=(m*l+c.d*uo(k,c).d)/(l+uo(k,c).d);l+=uo(k,c).d;or(k,c)}else if(d){m=(m*l+d.d*uo(k,d).d)/(l+uo(k,d).d);l+=uo(k,d).d;or(k,d)}}l>a.g.d/hv&&nr(k,new Si(m),new Si(l));l>e&&(e=l)}k.g>f&&As(k)}ys(k,1/e);return k}
function Ik(){Ik=Mg;var a,b,c;new Rk({l:1,m:0,h:0},0);new Rk({l:10,m:0,h:0},0);new Rk({l:0,m:0,h:0},0);Ak=Td(jf,Xu,14,11,0,1);Bk=Td(je,Xu,0,100,7,1);Ck=Wd(Sd(ke,1),gv,0,7,[1,5,25,125,625,3125,15625,78125,390625,1953125,9765625,48828125,244140625,1220703125,6103515625,30517578125,152587890625,762939453125,3814697265625,19073486328125,95367431640625,476837158203125,2384185791015625]);Dk=Td(le,Xu,0,Ck.length,7,1);Ek=Wd(Sd(ke,1),gv,0,7,[1,10,100,1000,10000,hv,iv,10000000,100000000,cv,jv,100000000000,1000000000000,10000000000000,100000000000000,1000000000000000,10000000000000000]);Fk=Td(le,Xu,0,Ek.length,7,1);Gk=Td(jf,Xu,14,11,0,1);a=0;for(;a<Gk.length;a++){Ak[a]=new Rk(oh(a),0);Gk[a]=new Rk({l:0,m:0,h:0},a);Bk[a]=48}for(;a<Bk.length;a++){Bk[a]=48}for(c=0;c<Dk.length;c++){Dk[c]=Tk(Ck[c])}for(b=0;b<Fk.length;b++){Fk[b]=Tk(Ek[b])}nm()}
function Kk(a,b){var c,d,e,f,g,h,i,j;c=0;g=0;f=b.length;j=new uk(b.length);if(0<f&&b.charCodeAt(0)==43){++g;++c;if(g<f&&(b.charCodeAt(g)==43||b.charCodeAt(g)==45)){throw new Ej('For input string: "'+b+'"')}}while(g<f&&b.charCodeAt(g)!=46&&b.charCodeAt(g)!=101&&b.charCodeAt(g)!=69){++g}Xh(j,b,c,g);if(g<f&&b.charCodeAt(g)==46){++g;c=g;while(g<f&&b.charCodeAt(g)!=101&&b.charCodeAt(g)!=69){++g}a.j=g-c;Xh(j,b,c,g)}else{a.j=0}if(g<f&&(b.charCodeAt(g)==101||b.charCodeAt(g)==69)){++g;c=g;if(g<f&&b.charCodeAt(g)==43){++g;g<f&&b.charCodeAt(g)!=45&&++c}h=b.substr(c,f-c);a.j=a.j-Qi(h);if(a.j!=he(a.j)){throw new Ej('Scale out of range.')}}i=j.d;if(i.length<16){a.k=$k(i);if(Yi(a.k)){throw new Ej('For input string: "'+b+'"')}a.d=Tk(a.k)}else{Mk(a,new Dl(i))}a.g=j.d.length;for(e=0;e<j.d.length;++e){d=Jj(j.d,e);if(d!=45&&d!=48){break}--a.g}a.g==0&&(a.g=1)}
function wt(a,b,c,d,e){var f,g,h,i,j,k,l;_r.call(this);this.f=b;this.g=c;this.k=d;h=a.indexOf('$');if(h>-1){this.e=Xj(a,h+1,a.length-(h+1));a=a.substr(0,h)}g=new RegExp('([A-Z][a-z]?\\{[0-9.,]*\\})');for(j=g.exec(a);j;j=g.exec(a)){f=j[0];this.d+=Qi(Qj(Qj(Qj(Qj(f,'[^0-9+-]',''),'-$','-1'),'[+]$','1'),'^[+]',''));a=a.replace(g,'')}g=new RegExp('(\\([0-9]+[+-]\\))');for(k=g.exec(a);k;k=g.exec(a)){f=k[0];this.d+=Qi(Qj(Qj(Qj(f,'[^0-9+-]',''),'^([0-9])([+-])$','$2$1'),'^[+]',''));a=a.replace(g,'')}g=new RegExp('(\\([+-][0-9]+\\))');for(l=g.exec(a);l;l=g.exec(a)){f=l[0];this.d+=Qi(Qj(Qj(Qj(f,'[^0-9+-]',''),'^([0-9])([+-])$','$1$2'),'^[+]',''));a=a.replace(g,'')}g=new RegExp('([+-])(?![0-9])');for(i=g.exec(a);i;i=g.exec(a)){f=i[0];Kj(f,'+')?++this.d:--this.d;a=a.replace(g,'')}Pj(a,'[a-zA-Z][0-9]+-[0-9]')&&(this.j=true);a.indexOf('}')!=-1;zt(this,a,e)}
function yu(a,b){!b&&(b={a:false,b:true,c:false,x:false,y:true,z:false});var c=[];var d=a.replace(/([a-z\)])([A-Z])/g,'$1 $2').split(/ /);if(b.a){var e='';for(var f=0;f<d.length-1;f++){e+=d[f];c.push(e+'C-1O-1(+1)$a'+(f+1))}}if(b.b){var g='';for(var f=0;f<d.length-1;f++){g+=d[f];c.push(g+'(+1)$b'+(f+1))}}if(b.c){var h='';for(var f=0;f<d.length-1;f++){h+=d[f];c.push(h+'NH3(+1)$c'+(f+1))}}if(b.x){var i='';for(var f=d.length-1;f>=0;f--){i=d[f]+i;f<d.length-1&&c.push('CO(+1)'+i+'$x'+(d.length-f-1))}}if(b.y){var j='';for(var f=d.length-1;f>=0;f--){j=d[f]+j;f<d.length-1&&c.push('H2(+1)'+j+'$y'+(d.length-f-1))}}if(b.z){var k='';for(var f=d.length-1;f>=0;f--){k=d[f]+k;f<d.length-1&&c.push('N-1H-1(+1)'+k+'$z'+(d.length-f-1))}}if(b.i){for(var f=d.length-1;f>0;f--){d[f].match(/^[A-Z][a-z][a-z].*$/)&&c.push(d[f]+'HC-1O-1(+1)$i:'+d[f])}}c.length==0&&(c=c.concat([a]));return c}
function Zl(a,b,c,d,e,f){var g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w;q=Td(le,Xu,0,d+1,7,1);r=Td(le,Xu,0,f+1,7,1);i=lj(e[f-1]);if(i!=0){Pl(r,e,0,i);Pl(q,c,0,i)}else{xk(c,0,q,0,d);xk(e,0,r,0,f)}j=r[f-1];l=b-1;m=d;while(l>=0){if(q[m]==j){k=-1}else{s=jh(yh(kh(oh(q[m]),{l:Yu,m:1023,h:0}),32),kh(oh(q[m-1]),{l:Yu,m:1023,h:0}));v=am(s,j);k=Dh(v);u=Dh(zh(v,32));if(k!=0){t=false;++k;do{--k;if(t){break}o=uh(kh(oh(k),{l:Yu,m:1023,h:0}),kh(oh(r[f-2]),{l:Yu,m:1023,h:0}));w=jh(yh(oh(u),32),kh(oh(q[m-2]),{l:Yu,m:1023,h:0}));p=jh(kh(oh(u),{l:Yu,m:1023,h:0}),kh(oh(j),{l:Yu,m:1023,h:0}));lj(Dh(Ah(p,32)))<32?(t=true):(u=Dh(p))}while(ph(Fh(o,{l:0,m:0,h:$u}),Fh(w,{l:0,m:0,h:$u})))}}if(k!=0){g=bm(q,m-f,r,f,k);if(g!=0){--k;h={l:0,m:0,h:0};for(n=0;n<f;n++){h=jh(h,jh(kh(oh(q[m-f+n]),{l:Yu,m:1023,h:0}),kh(oh(r[n]),{l:Yu,m:1023,h:0})));q[m-f+n]=Dh(h);h=Ah(h,32)}}}a[l]=k;--m;--l}if(i!=0){Sl(r,f,q,0,i);return r}xk(q,0,r,0,f);return q}
function Eb(){var a=['\\u0000','\\u0001','\\u0002','\\u0003','\\u0004','\\u0005','\\u0006','\\u0007','\\b','\\t','\\n','\\u000B','\\f','\\r','\\u000E','\\u000F','\\u0010','\\u0011','\\u0012','\\u0013','\\u0014','\\u0015','\\u0016','\\u0017','\\u0018','\\u0019','\\u001A','\\u001B','\\u001C','\\u001D','\\u001E','\\u001F'];a[34]='\\"';a[92]='\\\\';a[173]='\\u00ad';a[1536]='\\u0600';a[1537]='\\u0601';a[1538]='\\u0602';a[1539]='\\u0603';a[1757]='\\u06dd';a[1807]='\\u070f';a[6068]='\\u17b4';a[6069]='\\u17b5';a[8203]='\\u200b';a[8204]='\\u200c';a[8205]='\\u200d';a[8206]='\\u200e';a[8207]='\\u200f';a[8232]='\\u2028';a[8233]='\\u2029';a[8234]='\\u202a';a[8235]='\\u202b';a[8236]='\\u202c';a[8237]='\\u202d';a[8238]='\\u202e';a[8288]='\\u2060';a[8289]='\\u2061';a[8290]='\\u2062';a[8291]='\\u2063';a[8292]='\\u2064';a[8298]='\\u206a';a[8299]='\\u206b';a[8300]='\\u206c';a[8301]='\\u206d';a[8302]='\\u206e';a[8303]='\\u206f';a[65279]='\\ufeff';a[65529]='\\ufff9';a[65530]='\\ufffa';a[65531]='\\ufffb';return a}
function Xl(a,b){Vl();var c,d,e,f,g,h,i,j,k,l,m,n;h=rh(a,{l:0,m:0,h:0});h&&(a=vh(a));if(mh(a,{l:0,m:0,h:0})){switch(b){case 0:return '0';case 1:return '0.0';case 2:return '0.00';case 3:return '0.000';case 4:return '0.0000';case 5:return '0.00000';case 6:return '0.000000';default:l=new tk;b<0?(l.d+='0E+',l):(l.d+='0E',l);l.d+=b==ev?'2147483648':''+-b;return l.d;}}j=Td(je,Xu,0,19,7,1);c=18;n=a;do{i=n;n=lh(n,{l:10,m:0,h:0});j[--c]=Dh(jh({l:48,m:0,h:0},Bh(i,uh(n,{l:10,m:0,h:0}))))&fv}while(wh(n,{l:0,m:0,h:0}));d=Bh(Bh(Bh({l:18,m:0,h:0},oh(c)),oh(b)),{l:1,m:0,h:0});if(b==0){h&&(j[--c]=45);return ek(j,c,18-c)}if(b>0&&qh(d,{l:4194298,m:Yu,h:Zu})){if(qh(d,{l:0,m:0,h:0})){e=c+Dh(d);for(g=17;g>=e;g--){j[g+1]=j[g]}j[++e]=46;h&&(j[--c]=45);return ek(j,c,18-c+1)}for(f=2;rh(oh(f),jh(vh(d),{l:1,m:0,h:0}));f++){j[--c]=48}j[--c]=46;j[--c]=48;h&&(j[--c]=45);return ek(j,c,18-c)}m=c+1;k=new uk;h&&(k.d+='-',k);if(18-m>=1){pk(k,j[c]);k.d+='.';k.d+=ek(j,c+1,18-c-1)}else{k.d+=ek(j,c,18-c)}k.d+='E';ph(d,{l:0,m:0,h:0})&&(k.d+='+',k);k.d+=''+Eh(d);return k.d}
function su(a){var b=(ou==null&&(ou=[{id:1,name:'alanine',aa3:'Ala',aa1:'A'},{id:2,name:'arginine',aa3:'Arg',aa1:'R'},{id:3,name:'asparagine',aa3:'Asn',aa1:'N'},{id:4,name:'aspartic acid',aa3:'Asp',aa1:'D'},{id:5,name:'asparagine or aspartic acid',aa3:'Asx',aa1:'B'},{id:6,name:'cysteine',aa3:'Cys',aa1:'C'},{id:7,name:'glutamic acid',aa3:'Glu',aa1:'E'},{id:8,name:'glutamine',aa3:'Gln',aa1:'Q'},{id:9,name:'glutamine or glutamic acid',aa3:'Glx',aa1:'Z'},{id:10,name:'glycine',aa3:'Gly',aa1:'G'},{id:11,name:'histidine',aa3:'His',aa1:'H'},{id:12,name:'isoleucine',aa3:'Ile',aa1:'I'},{id:13,name:'leucine',aa3:'Leu',aa1:'L'},{id:14,name:'lysine',aa3:'Lys',aa1:'K'},{id:15,name:'methionine',aa3:'Met',aa1:'M'},{id:16,name:'phenylalanine',aa3:'Phe',aa1:'F'},{id:17,name:'proline',aa3:'Pro',aa1:'P'},{id:18,name:'serine',aa3:'Ser',aa1:'S'},{id:19,name:'threonine',aa3:'Thr',aa1:'T'},{id:20,name:'tryptophan',aa3:'Trp',aa1:'W'},{id:21,name:'tyrosine',aa3:'Tyr',aa1:'Y'},{id:22,name:'valine',aa3:'Val',aa1:'V'}]),ou);for(var c=0;c<b.length;c++){if(b[c].aa1==a){return b[c].aa3}}return a}
function et(a,b,c){var d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,A,B;b=Qj(b,' ','');b=Qj(b,'^([0-9]+[A-Z][a-z]?)$','[$1]');Pj(b,'.*[a-zA-Z][0-9]+-[0-9].*')&&(a.f=true);r=new RegExp('([A-Z][a-z]?\\{[0-9.,]*\\})');for(t=r.exec(b);t;t=r.exec(b)){h=t[1];p=(v=_s(h),w=Qj(h,'\\{.*',''),bn(a.d,v)||jn(a.d,v,new Rs(fn(a.d,w),v,h)),v);b=b.replace(r,p)}r=new RegExp('(\\{[A-Za-z0-9]*\\})');for(s=r.exec(b);s;s=r.exec(b)){h=s[1];q=(A=_s(h),B=Qj(h,'[\\{\\}]',''),bn(a.e,A)||jn(a.e,A,new Ct(A,h,B,a.d,a.e)),A);b=b.replace(r,q)}b.indexOf('}')!=-1;g=Rj(b,'\\.',0);n=1;o=false;for(e=0,f=g.length;e<f;++e){d=g[e];if(dt(d)){if(o)throw new Jt("Syntax error: 'number.number.'");n=Pi(d);o=true;continue}u=d.indexOf('/');if(u!=-1){if(o)throw new Jt("Syntax error: 'number.number/number'");k=u+1;l=d.length;while(oi(Jj(d,k++))){if(k>=l)break}k<l&&--k;n=ft(d.substr(0,k));o=true;if(k>=l)continue;else d=Xj(d,k,d.length-k)}j=0;for(;j<d.length;j++){if(!oi(d.charCodeAt(j)))break}if(j>0){m=Pi(d.substr(0,j));d=Xj(d,j,d.length-j);o?(n+=m/zj(10,j)):(n=m)}i=new wt(d,a.d,a.e,n,c);i.k==0&&(a.j=true);i.j&&(a.f=true);Ro(a.g,i);n=1;o=false}}
function Cs(a,b,c,d){var e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w;t=new nk;s=a.g;s>~~(a.d/2)&&(s=~~(a.d/2));t.d+='##TITLE= '+b+'\r\n'+'##JCAMP-DX= 5.00\r\n'+'##DATA TYPE= MASS SPECTRUM\r\n'+'##DATA CLASS= PEAK TABLE\r\n'+'##ORIGIN= Generated spectrum based on ChemCalc www.chemcalc.org\r\n'+'##SPECTROMETER/DATA SYSTEM= Based on ChemCalc isotopic distribution calculator\r\n'+'##XUNITS= M/Z\r\n'+'##YUNITS= RELATIVE ABUNDANCE\r\n'+'##NPOINTS=         \r\n';e=t.d.length;t.d+='##MAXY= 100\r\n##MINY= 0\r\n';for(n=Nn(new On(d));vn(n.d);){m=Sn(n);mk(t,'##$'+m+'='+(m==null?Ym(Ep(d.d,null)):d.f.kb(m))+'\r\n')}t.d+='##PEAK TABLE= (XY..XY)\r\n';p=0;l=(new Gr(a)).d.$();o=(new On(c)).L(Td(Qe,Xu,6,(new On(c)).d.e,0,1));kp(o,0,o.length,(qp(),qp(),pp));g=0;q=sv;j=true;f=0;r=false;w='';while(Gn(l.d)&&f<s){++f;h=l.e=Hn(l.d);u=h.X().d;v=h.Y().d;v<1.0E-9&&(v=0);if(v!=0&&w.length>0){t.d+=w;++p;w=''}i=true;for(k=g;k<o.length;k++){if(!Gn(l.d)||sj(o[k].d-q)<sj(o[k].d-u)){if(i){t.d+='  $$ ';i=false}else{t.d+=','}mk(t,en(c,o[k]));++g}else{break}}q=u;if(j){j=false;mk(t,Bs(u)+', '+Bs(v*100));++p}else{if(!r||v!=0){t.d+='\r\n';mk(t,Bs(u)+', '+Bs(v*100));++p}else{w='\r\n'+Bs(u)+', '+Bs(0)}v==0?(r=true):(r=false)}}t.d+='\r\n##END=\r\n';t.d=Tj(t.d,0,e-10)+(p+'')+Sj(t.d,e-2);return t}
function Yl(a,b){Vl();var c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,A,B,C,D,F,G;A=a.j;n=a.g;e=a.d;if(A==0){switch(b){case 0:return '0';case 1:return '0.0';case 2:return '0.00';case 3:return '0.000';case 4:return '0.0000';case 5:return '0.00000';case 6:return '0.000000';default:v=new tk;b<0?(v.d+='0E+',v):(v.d+='0E',v);v.d+=-b;return v.d;}}s=n*10+1+7;t=Td(je,Xu,0,s+1,7,1);c=s;if(n==1){g=e[0];if(g<0){G=kh(oh(g),{l:Yu,m:1023,h:0});do{o=G;G=lh(G,{l:10,m:0,h:0});t[--c]=48+Dh(Bh(o,uh(G,{l:10,m:0,h:0})))&fv}while(wh(G,{l:0,m:0,h:0}))}else{G=g;do{o=G;G=~~(G/10);t[--c]=48+(o-G*10)&fv}while(G!=0)}}else{C=Td(le,Xu,0,n,7,1);F=n;xk(e,0,C,0,n);H:while(true){w={l:0,m:0,h:0};for(i=F-1;i>=0;i--){D=jh(yh(w,32),kh(oh(C[i]),{l:Yu,m:1023,h:0}));q=Wl(D);C[i]=Dh(q);w=oh(Dh(zh(q,32)))}r=Dh(w);p=c;do{t[--c]=48+r%10&fv}while((r=~~(r/10))!=0&&c!=0);d=9-p+c;for(h=0;h<d&&c>0;h++){t[--c]=48}k=F-1;for(;C[k]==0;k--){if(k==0){break H}}F=k+1}while(t[c]==48){++c}}m=A<0;f=s-c-b-1;if(b==0){m&&(t[--c]=45);return ek(t,c,s-c)}if(b>0&&f>=-6){if(f>=0){j=c+f;for(l=s-1;l>=j;l--){t[l+1]=t[l]}t[++j]=46;m&&(t[--c]=45);return ek(t,c,s-c+1)}for(k=2;k<-f+1;k++){t[--c]=48}t[--c]=46;t[--c]=48;m&&(t[--c]=45);return ek(t,c,s-c)}B=c+1;u=new uk;m&&(u.d+='-',u);if(s-B>=1){pk(u,t[c]);u.d+='.';u.d+=ek(t,c+1,s-c-1)}else{u.d+=ek(t,c,s-c)}u.d+='E';f>0&&(u.d+='+',u);u.d+=''+f;return u.d}
function Xb(a,b){var c,d,e,f;Zb(b,a.j);c=a.g[0];d=a.g[1];e=a.g[2];f=a.g[3];c=$b(c,d,e,f,a.j[0],7,-680876936);f=$b(f,c,d,e,a.j[1],12,-389564586);e=$b(e,f,c,d,a.j[2],17,606105819);d=$b(d,e,f,c,a.j[3],22,-1044525330);c=$b(c,d,e,f,a.j[4],7,-176418897);f=$b(f,c,d,e,a.j[5],12,1200080426);e=$b(e,f,c,d,a.j[6],17,-1473231341);d=$b(d,e,f,c,a.j[7],22,-45705983);c=$b(c,d,e,f,a.j[8],7,1770035416);f=$b(f,c,d,e,a.j[9],12,-1958414417);e=$b(e,f,c,d,a.j[10],17,-42063);d=$b(d,e,f,c,a.j[11],22,-1990404162);c=$b(c,d,e,f,a.j[12],7,1804603682);f=$b(f,c,d,e,a.j[13],12,-40341101);e=$b(e,f,c,d,a.j[14],17,-1502002290);d=$b(d,e,f,c,a.j[15],22,1236535329);c=_b(c,d,e,f,a.j[1],5,-165796510);f=_b(f,c,d,e,a.j[6],9,-1069501632);e=_b(e,f,c,d,a.j[11],14,643717713);d=_b(d,e,f,c,a.j[0],20,-373897302);c=_b(c,d,e,f,a.j[5],5,-701558691);f=_b(f,c,d,e,a.j[10],9,38016083);e=_b(e,f,c,d,a.j[15],14,-660478335);d=_b(d,e,f,c,a.j[4],20,-405537848);c=_b(c,d,e,f,a.j[9],5,568446438);f=_b(f,c,d,e,a.j[14],9,-1019803690);e=_b(e,f,c,d,a.j[3],14,-187363961);d=_b(d,e,f,c,a.j[8],20,1163531501);c=_b(c,d,e,f,a.j[13],5,-1444681467);f=_b(f,c,d,e,a.j[2],9,-51403784);e=_b(e,f,c,d,a.j[7],14,1735328473);d=_b(d,e,f,c,a.j[12],20,-1926607734);c=ac(c,d,e,f,a.j[5],4,-378558);f=ac(f,c,d,e,a.j[8],11,-2022574463);e=ac(e,f,c,d,a.j[11],16,1839030562);d=ac(d,e,f,c,a.j[14],23,-35309556);c=ac(c,d,e,f,a.j[1],4,-1530992060);f=ac(f,c,d,e,a.j[4],11,1272893353);e=ac(e,f,c,d,a.j[7],16,-155497632);d=ac(d,e,f,c,a.j[10],23,-1094730640);c=ac(c,d,e,f,a.j[13],4,681279174);f=ac(f,c,d,e,a.j[0],11,-358537222);e=ac(e,f,c,d,a.j[3],16,-722521979);d=ac(d,e,f,c,a.j[6],23,76029189);c=ac(c,d,e,f,a.j[9],4,-640364487);f=ac(f,c,d,e,a.j[12],11,-421815835);e=ac(e,f,c,d,a.j[15],16,530742520);d=ac(d,e,f,c,a.j[2],23,-995338651);c=bc(c,d,e,f,a.j[0],6,-198630844);f=bc(f,c,d,e,a.j[7],10,1126891415);e=bc(e,f,c,d,a.j[14],15,-1416354905);d=bc(d,e,f,c,a.j[5],21,-57434055);c=bc(c,d,e,f,a.j[12],6,1700485571);f=bc(f,c,d,e,a.j[3],10,-1894986606);e=bc(e,f,c,d,a.j[10],15,-1051523);d=bc(d,e,f,c,a.j[1],21,-2054922799);c=bc(c,d,e,f,a.j[8],6,1873313359);f=bc(f,c,d,e,a.j[15],10,-30611744);e=bc(e,f,c,d,a.j[6],15,-1560198380);d=bc(d,e,f,c,a.j[13],21,1309151649);c=bc(c,d,e,f,a.j[4],6,-145523070);f=bc(f,c,d,e,a.j[11],10,-1120210379);e=bc(e,f,c,d,a.j[2],15,718787259);d=bc(d,e,f,c,a.j[9],21,-343485551);a.g[0]=~~(a.g[0]+c);a.g[1]=~~(a.g[1]+d);a.g[2]=~~(a.g[2]+e);a.g[3]=~~(a.g[3]+f)}
function zt(b,c,d){var e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w;c=Uj(c);c=Qj(c,'[=]','');if(c.indexOf('.')!=-1)throw new ub('Error: the formula "'+c+'"contains dots (error in parsing)');if(Kj(c,'')){return}if(oi(c.charCodeAt(0))){throw new ub('Error: the formula starts with a number')}c.charCodeAt(0)==120&&(c='X'+Tj(c,1,c.length));g=new er;k=1;j=1;m=1;l=1;r=1;q=1;w=c.length-1;while(w>=0){if(oi(c.charCodeAt(w))){f=w;while(w>0&&oi(c.charCodeAt(w)))--w;e=c.substr(w+1,f+1-(w+1));u=Qi(e);if(c.charCodeAt(w)==45){--w;if(w<0)throw new Jt("Syntax error: the formula starts with '-': "+c);f=w;while(w>0&&oi(c.charCodeAt(w)))--w;w==0&&oi(c.charCodeAt(0))&&--w;o=c.substr(w+1,f+1-(w+1));if(o.length==0){u=Qi('-'+e);v=u}else{v=Qi(o)}}else v=u;if(c.charCodeAt(w)==41){--w;if(w<0)throw new Jt("Syntax error: the formula starts with ')': "+c);dr(g,new gj(r));dr(g,new gj(q));r=m;q=l;l*=u;m*=v}else{k=v;j=u}}else{if(c.charCodeAt(w)==93){s=w;--w;if(w<=1)throw new Jt('Syntax error: bad isotope syntax');if(!pi(c.charCodeAt(w)))throw new Jt('Syntax error: bad isotope syntax');while(w>0&&ri(c.charCodeAt(w)))--w;if(!si(c.charCodeAt(w)))throw new Jt('Syntax error: bad symbol (must start with uppercase)');t=c.substr(w,s-w);--w;if(w<0)throw new Jt('Syntax error: bad isotope syntax');if(!oi(c.charCodeAt(w)))throw new Jt('Syntax error: bad isotope syntax');f=w;while(w>0&&c.charCodeAt(w)!=91)--w;p=c.substr(w+1,f+1-(w+1));try{n=Qi(p)}catch(a){a=Ig(a);if(ae(a,20)){throw new Jt('Syntax error: bad isotope number '+p)}else throw Hg(a)}if(c.charCodeAt(w)!=91)throw new Jt("Isotope syntax error: no opening '['");kt(b,t,k*m,j*l,n,d);j=1;k=1;if(w>0)--w;else return}else{if(pi(c.charCodeAt(w))){s=w;while(w>0&&ri(c.charCodeAt(w)))--w;if(s==0&&w==0&&c.charCodeAt(0)==110){b.k=0;return}if(!si(c.charCodeAt(w)))throw new Jt('Syntax error: the symbol must start with uppercase');t=c.substr(w,s+1-w);if(Kj(t,'X')&&w==0){b.k=0;return}--w;kt(b,t,k*m,j*l,0,d);j=1;k=1}else{while(c.charCodeAt(w)==41){--w;if(w<0)throw new Jt("Syntax error: the formula starts with ')': "+c);dr(g,new gj(r));dr(g,new gj(q));r=m;q=l}if(w<0)break;while(c.charCodeAt(w)==40){l=q;m=r;if(g.d.e.length==0){q=1;r=1}else{q=cr(g).d;r=cr(g).d}--w;if(w<0)break}if(w<0)break;if(c.charCodeAt(w)==125){i=w;while(w>0&&c.charCodeAt(w)!=123)--w;if(c.charCodeAt(w)!=123)throw new Jt('Syntax error (combinatorial): no opening brace');At(b,c.substr(w+1,i-(w+1)),k*m,j*l);--w}}}}if(w<0)break;h=c.charCodeAt(w);if(h==123)throw new Jt('Syntax error (combinatorial): no closing brace');if(h==91)throw new Jt('Syntax error (isotope): no closing bracket');if(!(null!=String.fromCharCode(h).match(/[A-Z\d]/i))&&h!=40&&h!=91&&h!=123&&h!=93&&h!=41&&h!=125)throw new Jt("Syntax error: unrecognized character: '"+$d(h)+"'")}}
function Cu(b,c,d){var e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,A,B,C,D,F,G,H,I,J,K,L,M,N,O;u=new Su;if(!b){Pu(u,'error',new Jd('options is null'));return u}J=b.f.kb('referenceVersion');J!=null&&!Kj(J,'')&&(d=(It(),It(),Gt));C=b.f.kb('mf');r=b.f.kb('isotopomers');N=b.f.kb('typedResult')!=null&&(fi(),Lj('true',b.f.kb('typedResult'))?ei:di).d;K=new Si(0.001);try{K=new Si(Pi(b.f.kb('resolution')))}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}M=new Si(1.0E-5);try{M=new Si(Pi(b.f.kb('threshold')))}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}e=false;p=10;try{p=he(Pi(b.f.kb('gaussianWidth')));e=true}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}o=new Si(K.d*p);try{o=new Si(Pi(b.f.kb('gaussianResolution')));e=true}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}t=0;!(b.f.kb('joiningAlgorithm')===undefined)&&Kj(b.f.kb('joiningAlgorithm').toLowerCase(),'center')&&(t=Kt);w=new Su;C==null?Pu(w,'mf',(dd(),dd(),cd)):Pu(w,'mf',new Jd(C));Pu(w,'threshold',new jd(M.d));Pu(w,'resolution',new jd(K.d));Pu(w,'typedResult',(Yc(),N?Xc:Wc));r==null?Pu(w,'isotopomers',(dd(),dd(),cd)):Pu(w,'isotopomers',new Jd(r));if(e){Pu(w,'gaussianWidth',new jd(p));Pu(w,'gaussianResolution',new jd(o.d))}J==null?Pu(w,'referenceVersion',(dd(),dd(),cd)):Pu(w,'referenceVersion',new Jd(J));Pu(u,'options',w.d);if(C!=null){C=Uj(C);Kj(C,'')&&(C=null)}if(C!=null){try{k=new ht(C,d,c);if(k.g.e.length>0){if(k.j){Pu(u,'error',new Jd('mass not defined'))}else{if(N){D=new Su;Pu(D,'type',new Jd('mf'));Ru(D,'value',gt(k));Pu(u,'mf',D.d)}else{Ru(u,'mf',gt(k))}Pu(u,'mw',new jd(at(k)));Pu(u,'em',new jd(bt(k)));Pu(u,'nominalMass',new jd(ct(k)));if(r!=null&&!Kj(r,'')){L=new Rt(d,k,K.d,M.d);L.k=t;Mt(L);Nt(L);if(e){n=nu(p);Lt(L,n,o.d)}Pu(w,'numberLines',new jd(L.j.f.g));if(r.indexOf('jcamp')>-1){if(N){s=new Su;Pu(s,'type',new Jd('jcamp'));Ru(s,'value',Ot(L).d);Pu(u,'jcamp',s.d)}else{Ru(u,'jcamp',Ot(L).d)}}if(r.indexOf('xy')>-1){if(N){O=new Su;Pu(O,'type',new Jd('xy'));Ru(O,'value',Pt(L).d);Pu(u,'xy',O.d)}else{Ru(u,'xy',Pt(L).d)}}if(r.indexOf('array')>-1&&r.indexOf('arrayX')==-1){f=Qt(L);v=new Mu;A=new Mu;B=new Mu;for(q=0;q<f.length;q++){Lu(A,new jd(f[q][0]));Lu(B,new jd(f[q][1]))}Lu(v,A.d);Lu(v,B.d);Pu(u,'spectrum',v.d)}if(r.indexOf('arrayXXYY')>-1){f=Qt(L);v=new Mu;A=new Mu;B=new Mu;for(q=0;q<f.length;q++){Lu(A,new jd(f[q][0]));Lu(B,new jd(f[q][1]))}Lu(v,A.d);Lu(v,B.d);Pu(u,'arrayXXYY',v.d)}if(r.indexOf('arrayXYXY')>-1){f=Qt(L);Pu(u,'arrayXYXY',(new Ou(f)).d)}}I=new Mu;Pu(u,'parts',I.d);for(m=new Jn(k.g);m.d<m.f.K();){l=(Ec(m.d<m.f.K()),m.f.V(m.e=m.d++));H=new Su;Lu(I,H.d);if(N){D=new Su;Pu(D,'type',new Jd('mf'));Ru(D,'value',ut(l));Pu(H,'mf',D.d)}else{Ru(H,'mf',ut(l))}Pu(H,'mw',new jd(ot(l)));Pu(H,'em',new jd(pt(l)));l.e.length>0&&Ru(H,'comment',l.e);Qu(H,hu(l));G=pt(l)-l.d*tv;if(l.d!=0){Pu(H,'charge',new jd(l.d));G=G/tj(l.d)}Pu(H,'msem',new jd(G));mt(l);i=new Mu;for(h=Go(new Ho(l.n));Gn(h.d.d);){g=Lo(h);j=new Su;Ru(j,'element',g.o);Pu(j,'number',new jd(gs(g)));Pu(j,'percentage',new jd(g.n));Lu(i,j.d)}Pu(H,'ea',i.d)}}}else{Pu(u,'error',new Jd('there is no part in the molecule'))}}catch(a){a=Ig(a);if(ae(a,4)){F=a;Ru(u,'error',F.k)}else throw Hg(a)}}else{Pu(u,'error',new Jd('parameter mf not specified'))}return u}
function Fu(b,c,d){var e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,A,B,C,D,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,$,ab,bb,cb;F=0.5;Q=0;K=50;I=1000;s=true;cb=true;R=false;v=b.f.kb('jcampLink')!=null&&(fi(),Lj('true',b.f.kb('jcampLink'))?ei:di).d;u=b.f.kb('jcampBaseURL')==null?'http://www.chemcalc.org/service/jcamp/':b.f.kb('jcampBaseURL');N='C0-100H0-202N0-10O0-10F0-3Cl0-3Br0-1';Z=sv;Y=new _r;ab=b.f.kb('typedResult')!=null&&(fi(),Lj('true',b.f.kb('typedResult'))?ei:di).d;V=new Si(0.001);try{V=new Si(Pi(b.f.kb('resolution')))}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}f=false;r=10;try{r=he(Pi(b.f.kb('gaussianWidth')));f=true}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}q=new Si(V.d*r);try{q=new Si(Pi(b.f.kb('gaussianResolution')));f=true}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}A=new Su;if(!b){Pu(A,'error',new Jd('options is null'));return A}U=b.f.kb('referenceVersion');U!=null&&!Kj(U,'')&&(d=(It(),It(),Gt));try{Q=Pi(b.f.kb('minUnsaturation'))}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}try{K=Pi(b.f.kb('maxUnsaturation'))}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}if(!(b.f.kb('integerUnsaturation')===undefined)){try{s=(fi(),Lj('true',b.f.kb('integerUnsaturation')))}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}}if(!(b.f.kb('useUnsaturation')===undefined)){try{cb=(fi(),Lj('true',b.f.kb('useUnsaturation')))}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}}if(!(b.f.kb('numberOfResultsOnly')===undefined)){try{R=(fi(),Lj('true',b.f.kb('numberOfResultsOnly')))}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}}try{I=Pi(b.f.kb('maxNumberRows'))}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}try{Z=Pi(b.f.kb('monoisotopicMass'))}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}try{F=Pi(b.f.kb('massRange'))}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}P=Z-F;H=Z+F;try{H=Pi(b.f.kb('maxMass'))}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}!(b.f.kb('mfRange')===undefined)&&b.f.kb('mfRange')!=null&&b.f.kb('mfRange').length>0&&(N=b.f.kb('mfRange'));if(Z<0){Pu(A,'error',new Jd('monoisotopicMass must be specified and larger than 0'));return A}B=new Su;Pu(B,'minUnsaturation',new jd(Q));Pu(B,'maxUnsaturation',new jd(K));Pu(B,'integerUnsaturation',(Yc(),s?Xc:Wc));Pu(B,'useUnsaturation',cb?Xc:Wc);Pu(B,'numberOfResultsOnly',R?Xc:Wc);Pu(B,'minMass',new jd(Ch(nh(Math.round(P*jv)))/jv));Pu(B,'maxMass',new jd(Ch(nh(Math.round(H*jv)))/jv));Pu(B,'massRange',new jd(Ch(nh(Math.round(F*jv)))/jv));N==null?Pu(B,'mfRange',(dd(),dd(),cd)):Pu(B,'mfRange',new Jd(N));Pu(B,'monoisotopicMass',new jd(Ch(nh(Math.round(Z*jv)))/jv));U==null?Pu(B,'referenceVersion',(dd(),dd(),cd)):Pu(B,'referenceVersion',new Jd(U));Pu(B,'jcampLink',v?Xc:Wc);u==null?Pu(B,'jcampBaseURL',(dd(),dd(),cd)):Pu(B,'jcampBaseURL',new Jd(u));Pu(B,'typedResult',ab?Xc:Wc);Pu(A,'options',B.d);t={l:0,m:0,h:0};S={l:0,m:0,h:0};g=0;h=0;try{e=new it(N,d,c,false);if(e.g.e.length!=1){Pu(A,'error',new Jd('Number of parts not equal to 1'));return A}g=So(e.g,0).d;h=g<0?-g:g;if(g!=0){Z=Z*h+g*tv;P=P*h+g*tv;H=H*h+g*tv;F=F*h}T=Hu(So(e.g,0),Z+F);if(T){k=Td(ke,gv,0,T.d.e.length,7,1);O=Td(ke,gv,0,T.d.e.length,7,1);G=Td(ke,gv,0,T.d.e.length,7,1);Du(T,O,G);Pu(A,'bruteForceIteration',new jd(Pi(Yl(Eu(T),0))));$=false;l=0;J=T.d.e.length;Xs((Wq(0,T.d.e.length),So(T.d,0)),0,Z,O[0],G[0],F);while(!$){if(ph(t,{l:3511296,m:476,h:0})){throw new Jt('Iteration number is over the current maximum of: 2000000000')}if(k[l]>=P&&k[l]<=H){bb=iu(T);if(!cb||!bb||bb.d>=Q&&bb.d<=K&&(!s||bb.d==he(bb.d))){S=jh(S,{l:1,m:0,h:0});if(!R){if(Y.n.g>=I){if(sj(Bo(gr(Y.n)).d)>sj(k[l]-Z)){Xm(wo(Y.n));$r(Y,new Ju(k[l]-Z,k[l],bb,Gu(T,c)))}}else{$r(Y,new Ju(k[l]-Z,k[l],bb,Gu(T,c)))}}}}while(l<J&&l>=0){t=jh(t,{l:1,m:0,h:0});j=(Wq(l,T.d.e.length),So(T.d,l));if(j.e<j.f){++j.e;l==0?(k[0]=j.d.j*j.e):(k[l]=k[l-1]+j.d.j*j.e);if(l<J-1){++l;Xs((Wq(l,T.d.e.length),So(T.d,l)),k[l-1],Z,O[l],G[l],F)}else{break}}else{--l}}l<0&&($=true)}}Pu(A,'realIteration',new jd(Ch(Bh(t,{l:1,m:0,h:0}))));Pu(A,'numberResults',new jd(Ch(S)));Pu(A,'charge',new jd(g))}catch(a){a=Ig(a);if(ae(a,4)){m=a;Ru(A,'error',pb(m)+'\r'+(ui(Eg),Eg.q+'@'+oj(Ob(B),16)))}else throw Hg(a)}D=new Mu;i='';g!=0&&(g>0?(i='(+'+g+')'):(i='('+g+')'));for(X=Go(new Ho(Y.n));Gn(X.d.d);){W=Lo(X);C=new Su;if(g==0){p=Ch(nh(Aj(W.d*jv)))/jv;o=Ch(nh(Aj(W.f*jv)))/jv}else{p=Ch(nh(Aj(W.d/h*jv)))/jv;o=Ch(nh(Aj((W.f-g*tv)/h*jv)))/jv}Pu(C,'error',new jd(p));Pu(C,'em',new jd(o));Pu(C,'ppm',new jd(Ch(nh(Math.round(p/o*jv)))/jv*iv));Ru(C,'info',W.e+i);try{w=u+W.e+'&resolution='+V;if(f){w+='&gaussianWidth='+r;w+='&gaussianResolution='+q}if(ab){L=new Su;Pu(L,'type',new Jd('mf'));Ru(L,'value',gt(new ht(W.e+i,d,c)));Pu(C,'mf',L.d);if(v){M=new Su;Pu(M,'type',new Jd('jcamp'));w==null?Pu(M,'url',(dd(),dd(),cd)):Pu(M,'url',new Jd(w));Pu(C,'jcamp',M.d)}}else{Ru(C,'mf',gt(new ht(W.e+i,d,c)));v&&(w==null?Pu(C,'jcampURL',(dd(),dd(),cd)):Pu(C,'jcampURL',new Jd(w)))}}catch(a){a=Ig(a);if(ae(a,4)){n=a;Ru(C,'mf',pb(n))}else throw Hg(a)}try{Pu(C,'unsat',new jd(Ch(nh(Aj(W.g.d*jv)))/jv))}catch(a){a=Ig(a);if(!ae(a,7))throw Hg(a)}Lu(D,C.d)}Pu(A,'results',D.d);return A}
function It(){It=Mg;var b,c,d,e,f,g,h,i,j,k,l,m;Gt=new Ap;e=new Ap;k=Rj('1\tH\tHydrogen\t1.0079407538967635\n2\tHe\tHelium\t4.002601932146926\n3\tLi\tLithium\t6.940037632200444\n4\tBe\tBeryllium\t9.01218224\n5\tB\tBoron\t10.8110281284\n6\tC\tCarbon\t12.010735896764565\n7\tN\tNitrogen\t14.006703211872013\n8\tO\tOxygen\t15.99940492727602\n9\tF\tFluorine\t18.998403227\n10\tNe\tNeon\t20.180046379828486\n11\tNa\tSodium\t22.989769280929\n12\tMg\tMagnesium\t24.305051612756515\n13\tAl\tAluminium\t26.9815386312\n14\tSi\tSilicon\t28.085498706539465\n15\tP\tPhosphorus\t30.973761632000002\n16\tS\tSulfur\t32.0647872364133\n17\tCl\tChlorine\t35.4529375824264\n18\tAr\tArgon\t39.947676713373\n19\tK\tPotassium\t39.0983011264695\n20\tCa\tCalcium\t40.078022655762524\n21\tSc\tScandium\t44.95591199\n22\tTi\tTitanium\t47.86674933516\n23\tV\tVanadium\t50.9414675085\n24\tCr\tChromium\t51.99613314762095\n25\tMn\tManganese\t54.93804517\n26\tFe\tIron\t55.8451456935552\n27\tCo\tCobalt\t58.93319506999999\n28\tNi\tNickel\t58.69335163208455\n29\tCu\tCopper\t63.546039795084994\n30\tZn\tZinc\t65.40872812701322\n31\tGa\tGallium\t69.72306563428617\n32\tGe\tGermanium\t72.63984326005341\n33\tAs\tArsenic\t74.92159652\n34\tSe\tSelenium\t78.9593882599375\n35\tBr\tBromine\t79.9035279923569\n36\tKr\tKrypton\t83.7980066431168\n37\tRb\tRubidium\t85.46766359470149\n38\tSr\tStrontium\t87.6166441185128\n39\tY\tYttrium\t88.905848327\n40\tZr\tZirconium\t91.22364763203382\n41\tNb\tNiobium\t92.90637812599999\n42\tMo\tMolybdenum\t95.93759212713759\n43\tTc\tTechnetium\t98.0\n44\tRu\tRuthenium\t101.0649455723334\n45\tRh\tRhodium\t102.90550430000002\n46\tPd\tPalladium\t106.41532914746399\n47\tAg\tSilver\t107.868151248228\n48\tCd\tCadmium\t112.41155226203729\n49\tIn\tIndium\t114.81808621342\n50\tSn\tTin\t118.71010849931781\n51\tSb\tAntimony\t121.75978615571421\n52\tTe\tTellurium\t127.60312786587177\n53\tI\tIodine\t126.9044734\n54\tXe\tXenon\t131.29276070673757\n55\tCs\tCaesium\t132.90545193324\n56\tBa\tBarium\t137.3268918829641\n57\tLa\tLanthanum\t138.90545400916656\n58\tCe\tCerium\t140.11572627079408\n59\tPr\tPraseodymium\t140.907652826\n60\tNd\tNeodymium\t144.236131428275\n61\tPm\tPromethium\t145.0\n62\tSm\tSamarium\t150.3663485610868\n63\tEu\tEuropium\t151.96437050019\n64\tGd\tGadolinium\t157.25212224243995\n65\tTb\tTerbium\t158.925346827\n66\tDy\tDysprosium\t162.49946572489424\n67\tHo\tHolmium\t164.930322127\n68\tEr\tErbium\t167.25907628559352\n69\tTm\tThulium\t168.934213327\n70\tYb\tYtterbium\t173.0376956147714\n71\tLu\tLutetium\t174.96672140854997\n72\tHf\tHafnium\t178.4849721651158\n73\tTa\tTantalum\t180.9478757552806\n74\tW\tTungsten\t183.8417781725967\n75\tRe\tRhenium\t186.206706624852\n76\tOs\tOsmium\t190.2248630659075\n77\tIr\tIridium\t192.2160564328\n78\tPt\tPlatinum\t195.077807984934\n79\tAu\tGold\t196.96656876\n80\tHg\tMercury\t200.599166666798\n81\tTl\tThallium\t204.38341252384\n82\tPb\tLead\t207.21690767600003\n83\tBi\tBismuth\t208.98039871599997\n84\tPo\tPolonium\t209.0\n85\tAt\tAstatine\t210.0\n86\tRn\tRadon\t222.0\n87\tFr\tFrancium\t223.0\n88\tRa\tRadium\t226.0\n89\tAc\tActinium\t227.0\n90\tTh\tThorium\t232.038055321\n91\tPa\tProtactinium\t231.035884024\n92\tU\tUranium\t238.02891028165737\n93\tNp\tNeptunium\t237.0\n94\tPu\tPlutonium\t244.0\n95\tAm\tAmericium\t0.0\n96\tCm\tCurium\t0.0\n97\tBk\tBerkelium\t0.0\n98\tCf\tCalifornium\t0.0\n99\tEs\tEinsteinium\t0.0\n100\tFm\tFermium\t0.0\n101\tMd\tMendelevium\t0.0\n102\tNo\tNobelium\t0.0\n103\tLr\tLawrencium\t0.0\n104\tRf\tRutherfordium\t0.0\n105\tDb\tDubnium\t0.0\n106\tSg\tSeaborgium\t0.0\n107\tBh\tBohrium\t0.0\n108\tHs\tHassium\t0.0\n109\tMt\tMeitnerium\t0.0\n110\tDs\tDarmstadtium\t0.0\n111\tRg\tRoentgenium\t0.0\n112\tCn\tCopernicium\t0.0\n113\tUut\tUnuntrium\t0.0\n114\tUuq\t\t0.0\n115\tUup\tUnunpentium\t0.0\n116\tUuh\t\t0.0\n117\tUus\tUnunseptium\t0.0','[\r\n]+',0);for(g=0;g<k.length;g++){m=Rj(k[g],'\t',0);c=new Qs(Pi(m[3]),Uj(m[1]),m[2],Qi(m[0]));jn(Gt,c.n,c);jn(e,m[0],c)}k=Rj('1\t1.007825032071\t99.9885\t1\n2\t2.01410177784\t0.0115\t1\n3\t3.016049277725\t0\t1\n4\t3.016029319126\t0.00013\t2\n5\t4.002603254156\t99.99987\t2\n6\t6.01512279516\t7.59\t3\n7\t7.016004558\t92.41\t3\n8\t9.01218224\t100\t4\n9\t10.01293704\t19.9\t5\n10\t11.00930544\t80.1\t5\n11\t12.0\t98.93\t6\n12\t13.00335483781\t1.07\t6\n13\t14.0032419894\t0\t6\n14\t14.00307400486\t99.636\t7\n15\t15.00010889827\t0.364\t7\n17\t16.9991317012\t0.038\t8\n16\t15.9949146195616\t99.757\t8\n18\t17.99916107\t0.205\t8\n19\t18.998403227\t100\t9\n21\t20.993846684\t0.27\t10\n20\t19.992440175419\t90.48\t10\n22\t21.99138511419\t9.25\t10\n23\t22.989769280929\t100\t11\n25\t24.985836923\t10\t12\n24\t23.98504170014\t78.99\t12\n26\t25.9825929293\t11.01\t12\n27\t26.9815386312\t100\t13\n29\t28.97649470022\t4.685\t14\n28\t27.976926532519\t92.223\t14\n30\t29.973770173\t3.092\t14\n31\t30.973761632\t100\t15\n34\t33.9678669012\t4.25\t16\n35\t35.967080762\t0.01\t16\n32\t31.9720710015\t94.99\t16\n33\t32.9714587615\t0.75\t16\n36\t34.968852684\t75.76\t17\n37\t36.965902595\t24.24\t17\n38\t35.96754510629\t0.3365\t18\n39\t37.96273244\t0.0632\t18\n40\t39.962383122529\t99.6003\t18\n42\t39.9639984821\t0.0117\t19\n43\t40.9618257621\t6.7302\t19\n41\t38.963706682\t93.2581\t19\n49\t47.9525344\t0.187\t20\n48\t45.953692624\t0.004\t20\n46\t42.95876663\t0.135\t20\n47\t43.95548184\t2.086\t20\n44\t39.9625909822\t96.941\t20\n45\t41.9586180127\t0.647\t20\n50\t44.95591199\t100\t21\n51\t45.95263169\t8.25\t22\n55\t49.94479129\t5.18\t22\n54\t48.94787009\t5.41\t22\n53\t47.94794639\t73.72\t22\n52\t46.95176319\t7.44\t22\n57\t50.943959511\t99.75\t23\n56\t49.947158511\t0.25\t23\n59\t51.94050758\t83.789\t24\n58\t49.946044211\t4.345\t24\n61\t53.93888048\t2.365\t24\n60\t52.94064948\t9.501\t24\n62\t54.93804517\t100\t25\n64\t55.93493757\t91.754\t26\n65\t56.93539407\t2.119\t26\n66\t57.93327568\t0.282\t26\n63\t53.93961057\t5.845\t26\n67\t58.93319507\t100\t27\n68\t57.93534297\t68.0769\t28\n69\t59.93078647\t26.2231\t28\n70\t60.93105607\t1.1399\t28\n71\t61.92834516\t3.6345\t28\n72\t63.92796607\t0.9256\t28\n73\t62.92959756\t69.15\t29\n74\t64.92778957\t30.85\t29\n76\t65.92603341\t27.975\t30\n77\t66.92712731\t4.102\t30\n78\t67.92484421\t19.024\t30\n79\t69.925319321\t0.631\t30\n75\t63.92914227\t48.268\t30\n81\t70.924701311\t39.892\t31\n80\t68.925573613\t60.108\t31\n85\t73.921177818\t36.72\t32\n84\t72.923458918\t7.76\t32\n86\t75.921402618\t7.83\t32\n83\t71.922075818\t27.31\t32\n82\t69.924247411\t20.38\t32\n87\t74.92159652\t100\t33\n93\t81.916699422\t8.73\t34\n92\t79.916521321\t49.61\t34\n89\t75.919213618\t9.37\t34\n88\t73.922476418\t0.89\t34\n91\t77.917309118\t23.77\t34\n90\t76.919914018\t7.63\t34\n95\t80.916290621\t49.31\t35\n94\t78.918337122\t50.69\t35\n100\t83.9115073\t56.987\t36\n101\t85.9106107311\t17.279\t36\n98\t81.913483619\t11.593\t36\n99\t82.9141363\t11.5\t36\n96\t77.920364812\t0.355\t36\n97\t79.916379016\t2.286\t36\n102\t84.91178973812\t72.17\t37\n103\t86.90918052713\t27.83\t37\n106\t86.908877112\t7\t38\n107\t87.905612112\t82.58\t38\n104\t83.9134253\t0.56\t38\n105\t85.909260212\t9.86\t38\n108\t88.905848327\t100\t39\n113\t95.90827343\t2.8\t40\n112\t93.906315226\t17.38\t40\n110\t90.905645825\t11.22\t40\n111\t91.905040825\t17.15\t40\n109\t89.904704425\t51.45\t40\n114\t92.906378126\t100\t41\n119\t96.906021521\t9.56\t42\n118\t95.904679521\t16.68\t42\n117\t94.905842121\t15.9\t42\n116\t93.905088321\t9.23\t42\n115\t91.9068114\t14.77\t42\n121\t99.9074776\t9.67\t42\n120\t97.905408221\t24.19\t42\n124\t98.906254721\t0\t43\n123\t97.9072164\t0\t43\n122\t96.9063655\t0\t43\n129\t100.905582122\t17.06\t44\n127\t98.905939322\t12.76\t44\n128\t99.904219522\t12.6\t44\n126\t97.9052877\t1.87\t44\n131\t103.9054333\t18.62\t44\n125\t95.9075988\t5.54\t44\n130\t101.904349322\t31.55\t44\n132\t102.9055043\t100\t45\n137\t107.9038924\t26.46\t46\n136\t105.9034864\t27.33\t46\n138\t109.90515312\t11.72\t46\n133\t101.9056093\t1.02\t46\n135\t104.9050854\t22.33\t46\n134\t103.9040364\t11.14\t46\n139\t106.9050975\t51.839\t47\n140\t108.9047523\t48.161\t47\n141\t105.9064596\t1.25\t48\n143\t109.903002129\t12.49\t48\n142\t107.9041846\t0.89\t48\n144\t110.904178129\t12.8\t48\n145\t111.902757829\t24.13\t48\n146\t112.904401729\t12.22\t48\n147\t113.903358529\t28.73\t48\n148\t115.9047563\t7.49\t48\n149\t112.9040583\t4.29\t49\n150\t114.9038785\t95.71\t49\n152\t113.9027793\t0.66\t50\n153\t114.9033423\t0.34\t50\n154\t115.9017413\t14.54\t50\n155\t116.9029523\t7.68\t50\n156\t117.9016033\t24.22\t50\n157\t118.9033083\t8.59\t50\n158\t119.902194727\t32.58\t50\n159\t121.903439029\t4.63\t50\n160\t123.905273915\t5.79\t50\n151\t111.9048185\t0.97\t50\n162\t122.904214022\t42.79\t51\n161\t120.903815724\t57.21\t51\n170\t129.906224421\t34.08\t52\n169\t127.904463119\t31.74\t52\n168\t125.903311716\t18.84\t52\n163\t119.9040201\t0.09\t52\n167\t124.904430716\t7.07\t52\n166\t123.902817916\t4.74\t52\n165\t122.904270016\t0.89\t52\n164\t121.903043916\t2.55\t52\n171\t126.9044734\t100\t53\n175\t128.90477948\t26.4006\t54\n174\t127.903531315\t1.9102\t54\n173\t125.9042747\t0.089\t54\n172\t123.90589302\t0.0952\t54\n178\t131.90415351\t26.9086\t54\n179\t133.90539459\t10.4357\t54\n176\t129.90350808\t4.071\t54\n177\t130.90508241\t21.2324\t54\n180\t135.9072198\t8.8573\t54\n181\t132.90545193324\t100\t55\n186\t135.90457594\t7.854\t56\n187\t136.90582745\t11.232\t56\n184\t133.90450844\t2.417\t56\n185\t134.90568864\t6.592\t56\n188\t137.90524725\t71.698\t56\n182\t129.90632083\t0.106\t56\n183\t131.905061311\t0.101\t56\n190\t138.906353326\t99.91\t57\n189\t137.9071124\t0.09\t57\n191\t135.90717214\t0.185\t58\n193\t139.905438726\t88.45\t58\n192\t137.90599111\t0.251\t58\n194\t141.9092443\t11.114\t58\n195\t140.907652826\t100\t59\n201\t147.9168933\t5.7\t60\n200\t145.913116925\t17.2\t60\n202\t149.9208913\t5.6\t60\n197\t142.909814325\t12.2\t60\n196\t141.907723325\t27.2\t60\n199\t144.912573625\t8.3\t60\n198\t143.910087325\t23.8\t60\n204\t146.915138526\t0\t61\n203\t144.9127493\t0\t61\n205\t143.9119993\t3.07\t62\n207\t147.914822726\t11.24\t62\n206\t146.914897926\t14.99\t62\n208\t148.917184726\t13.82\t62\n209\t149.917275526\t7.38\t62\n210\t151.919732427\t26.75\t62\n211\t153.922209327\t22.75\t62\n212\t150.919850226\t47.81\t63\n213\t152.921230326\t52.19\t63\n220\t159.927054127\t21.86\t64\n216\t154.922622027\t14.8\t64\n217\t155.922122727\t20.47\t64\n218\t156.923960127\t15.65\t64\n219\t157.924103927\t24.84\t64\n214\t151.919791027\t0.2\t64\n215\t153.920865627\t2.18\t64\n221\t158.925346827\t100\t65\n222\t155.9242837\t0.056\t66\n223\t157.9244094\t0.095\t66\n228\t163.929174827\t28.26\t66\n227\t162.928731227\t24.896\t66\n226\t161.926798427\t25.475\t66\n225\t160.926933427\t18.889\t66\n224\t159.925197527\t2.329\t66\n229\t164.930322127\t100\t67\n235\t169.93546433\t14.91\t68\n234\t167.932370227\t26.978\t68\n233\t166.932048227\t22.869\t68\n232\t165.930293127\t33.503\t68\n231\t163.9292003\t1.601\t68\n230\t161.9287784\t0.139\t68\n236\t168.934213327\t100\t69\n239\t170.936325826\t14.28\t70\n238\t169.934761826\t3.04\t70\n237\t167.9338975\t0.13\t70\n242\t173.938862126\t31.83\t70\n243\t175.942571728\t12.76\t70\n240\t171.936381526\t21.83\t70\n241\t172.938210826\t16.13\t70\n244\t174.940771823\t97.41\t71\n245\t175.942686323\t2.59\t71\n250\t178.945816123\t13.62\t72\n251\t179.946550023\t35.08\t72\n248\t176.943220723\t18.6\t72\n249\t177.943698823\t27.28\t72\n246\t173.9400463\t0.16\t72\n247\t175.941408624\t5.26\t72\n252\t179.947464824\t0.012\t73\n253\t180.947995819\t99.988\t73\n258\t185.954364119\t28.43\t74\n254\t179.9467044\t0.12\t74\n255\t181.94820429\t26.5\t74\n256\t182.95022309\t14.31\t74\n257\t183.95093129\t30.64\t74\n259\t184.952955013\t37.4\t75\n260\t186.955753115\t62.6\t75\n262\t185.953838215\t1.59\t76\n263\t186.955750515\t1.96\t76\n261\t183.952489114\t0.02\t76\n266\t189.958447016\t26.26\t76\n267\t191.961480727\t40.78\t76\n264\t187.955838215\t13.24\t76\n265\t188.958147516\t16.15\t76\n268\t190.960594018\t37.3\t77\n269\t192.962926418\t62.7\t77\n275\t197.9678933\t7.163\t78\n274\t195.96495159\t25.242\t78\n273\t194.96479119\t33.832\t78\n272\t193.96268039\t32.967\t78\n270\t189.9599326\t0.014\t78\n271\t191.961038027\t0.782\t78\n276\t196.96656876\t100\t79\n279\t198.96827994\t16.87\t80\n278\t197.96676904\t9.97\t80\n277\t195.9658333\t0.15\t80\n283\t203.97349394\t6.87\t80\n282\t201.97064306\t29.86\t80\n281\t200.97030236\t13.18\t80\n280\t199.96832604\t23.1\t80\n285\t204.974427514\t70.48\t81\n284\t202.972344214\t29.52\t81\n288\t206.975896913\t22.1\t82\n289\t207.976652113\t52.4\t82\n287\t205.974465313\t24.1\t82\n286\t203.973043613\t1.4\t82\n290\t208.980398716\t100\t83\n291\t208.98243042\t0\t84\n292\t209.982873713\t0\t84\n293\t209.9871488\t0\t85\n294\t210.98749633\t0\t85\n295\t210.9906017\t0\t86\n296\t220.011394024\t0\t86\n297\t222.017577725\t0\t86\n298\t223.019735926\t0\t87\n299\t223.018502227\t0\t88\n300\t224.020211824\t0\t88\n301\t226.025409825\t0\t88\n302\t228.031070326\t0\t88\n303\t227.027752126\t0\t89\n305\t232.038055321\t100\t90\n304\t230.033133819\t0\t90\n306\t231.035884024\t100\t91\n307\t233.039635229\t0\t92\n309\t235.04392992\t0.7204\t92\n308\t234.04095212\t0.0054\t92\n311\t238.05078822\t99.2742\t92\n310\t236.04556802\t0\t92\n313\t237.04817342\t0\t93\n312\t236.0465705\t0\t93\n315\t239.05216342\t0\t94\n314\t238.04955992\t0\t94\n317\t241.05685152\t0\t94\n316\t240.05381352\t0\t94\n319\t244.0642045\t0\t94\n318\t242.05874262\t0\t94\n320\t241.05682912\t0\t95\n321\t243.061381125\t0\t95\n326\t247.0703545\t0\t96\n327\t248.0723495\t0\t96\n324\t245.065491222\t0\t96\n325\t246.067223722\t0\t96\n322\t243.061389122\t0\t96\n323\t244.06275262\t0\t96\n328\t247.0703076\t0\t97\n329\t249.074986728\t0\t97\n332\t251.0795875\t0\t98\n333\t252.0816265\t0\t98\n330\t249.074853524\t0\t98\n331\t250.076406122\t0\t98\n334\t252.0829805\t0\t99\n335\t257.0951057\t0\t100\n337\t260.1036534\t0\t101\n336\t258.0984315\t0\t101\n338\t259.1010311\t0\t102\n339\t262.1096322\t0\t103\n340\t265.1167046\t0\t104\n341\t268.1254557\t0\t105\n342\t271.133477\t0\t106\n343\t272.1380365\t0\t107\n344\t270.1346531\t0\t108\n345\t276.1511673\t0\t109\n346\t281.1620678\t0\t110\n347\t280.164478\t0\t111\n348\t285.1741178\t0\t112\n349\t284.1780886\t0\t113\n350\t289.1872879\t0\t114\n351\t288.1924992\t0\t115\n352\t292.20755101\t0\t117','[\r\n]+',0);for(h=0;h<k.length;h++){m=Rj(k[h],'\t',0);c=fn(e,m[3]);i=Pi(m[1]);j=Pi(m[2]);b=new Dt(he(i+0.5),i,j,c.n);hn(c.e,new gj(b.f),b)}for(d=Wn(new Xn(Gt));vn(d.d);){c=_n(d);Ls(c);if(c.e.e==0){l=new Dt(he(c.f+0.5),c.f,100,c.n);hn(c.e,new gj(l.f),l)}}Ht=new Ap;k=Rj("1\tAbu\t2-Aminobutyric acid diradical\tC4H7NO\r\n2\tAcet\tAcetyl\tC2H3O\r\n3\tAcm\tAcetamidomethyl\tC3H6NO\r\n4\tAdao\tAdamantyloxy\tC10H15O\r\n5\tAib\talpha-Aminoisobutyric acid diradical\tC4H7NO\r\n6\tAla\tAlainine diradical\tC3H5NO\r\n7\tArg\tArginine diradical\tC6H12N4O\r\n8\tArgp\tArginine triradical\tC6H11N4O\r\n9\tAsn\tAsparagine diradical\tC4H6N2O2\r\n10\tAsnp\tAsparagine triradical\tC4H5N2O2\r\n11\tAsp\tAspartic acid diradical\tC4H5NO3\r\n12\tAspp\tAspartic acid triradical\tC4H4NO3\r\n13\tAsu\talpha-Aminosuberic acid diradical\tC8H13NO3\r\n14\tAsup\talpha-Aminosuberic acid triradical\tC8H12NO3\r\n15\tBoc\tt-Butoxycarbonyl\tC5H9O2\r\n16\tBom\tBenzyloxymethyl\tC8H9O\r\n17\tBrz\t2-Bromobenzyloxycarbonyl\tC8H6BrO2\r\n18\tBu\tButyl\tC4H9\r\n19\tBum\tt-Butoxymethyl\tC5H11O\r\n20\tBz\tBenzoyl\tC7H5O\r\n21\tBzl\tBenzyl\tC7H7\r\n22\tBn\tBenzyl\tC7H7\r\n23\tBzlo\tBenzyloxy\tC7H7O\r\n24\tCha\tbeta-Cyclohexylalanine diradical\tC9H15NO\r\n25\tChxo\tCyclohexyloxy\tC6H11O\r\n26\tCit\tCitrulline diradical\tC6H11N3O2\r\n27\tCitp\tCitrulline triradical\tC6H10N3O2\r\n28\tClz\t2-Chlorobenzyloxycarbonyl\tC8H6ClO2\r\n29\tCp\tCyclopentadienyl\tC5H5\r\n30\tCys\tCysteine diradical\tC3H5NOS\r\n31\tCysp\tCysteine triradical\tC3H4NOS\r\n32\tD\tDeuterium\t[2H]\r\n33\tDde\tDde\tC10H13O2\r\n34\tDnp\t2,4-Dinitrophenyl\tC6H3N2O4\r\n35\tEt\tEthyl\tC2H5\r\n36\tFmoc\tFluorenylmethoxycarbonyl\tC15H11O2\r\n37\tFor\tFormyl\tCHO\r\n38\tGln\tGlutamine diradical\tC5H8N2O2\r\n39\tGlnp\tGlutamine triradical\tC5H7N2O2\r\n40\tGlp\tPyroglutamine\tC5H5NO2\r\n41\tGlu\tGlutamic acid diradical\tC5H7NO3\r\n42\tGlup\tGlutamic acid triradical\tC5H6NO3\r\n43\tGly\tGlycine diradical\tC2H3NO\r\n44\tHci\tHomocitrulline diradical\tC7H13N3O2\r\n45\tHcip\tHomocitrulline triradical\tC7H12N3O2\r\n46\tHis\tHistidine diradical\tC6H7N3O\r\n47\tHisp\tHistidine triradical\tC6H6N3O\r\n48\tHser\tHomoserine diradical\tC4H7NO2\r\n49\tHserp\tHomoserine triradical\tC4H6NO2\r\n50\tHyp\tHydroxyproline diradical\tC5H7NO2\r\n51\tHypp\tHydroxyproline triradical\tC5H6NO2\r\n52\tIle\tIsoleucine diradical\tC6H11NO\r\n53\tIvdde\t1-[4,4-dimethyl-2,6-dioxocyclohexylidene)3-methylb\tC14H21O2\r\n54\tLeu\tLeucine diradical\tC6H11NO\r\n55\tLys\tLysine diradical\tC6H12N2O\r\n56\tLysp\tLysine triradical\tC6H11N2O\r\n57\tMbh\t4,4'-Dimethoxybenzhydryl\tC15H15O2\r\n58\tMe\tMethyl\tCH3\r\n59\tMebzl\t4-Methylbenzyl\tC8H9\r\n60\tMeobzl\t4-Methoxybenzyl1-[4,4-dimethyl-2,6-dioxocyclohexyl\tC8H9O\r\n61\tMet\tMethionine diradical\tC5H9NOS\r\n62\tMmt\t4-Methoxytrityl\tC20H17O\r\n63\tMtc\t2,2,5,7,8-pentamethylchroman-6-sulphonyl\tC14H19O3S\r\n64\tMtr\t4-Methoxy-2,3,6-trimethylbenzenesulphonyl\tC10H13O3S\r\n65\tMts\tMesitylene-2-sulphonyl\tC9H11O2S\r\n66\tMtt\t4-Methyltrityl\tC20H17\r\n67\tNle\tNorleucine diradical\tC6H11NO\r\n68\tNpys\t3-Nitro-2-pyridinesulphenyl\tC5H3N2O2S\r\n69\tNva\tNorvaline diradical\tC5H9NO\r\n70\tOdmab\tOdmab\tC20H26NO3\r\n71\tOrn\tOrnithine diradical\tC5H10N2O\r\n72\tOrnp\tOrnithine triradical\tC5H9N2O\r\n73\tPbf\t2,2,4,6,7-pentamethyldihydrobenzofurane-5-sulfonyl\tC13H17O3S\r\n74\tPen\tPenicillamine diradical\tC5H9NOS\r\n75\tPenp\tPenicillamine triradical\tC5H8NOS\r\n76\tPh\tPhenyl\tC6H5\r\n77\tPhe\tPhenylalanine diradical\tC9H9NO\r\n78\tPhepcl\t4-Chlorophenylalanine diradical\tC9H8ClNO\r\n79\tPhg\tPhenylglycine\tC8H7NO\r\n80\tPmc\t2,2,5,7,8-Pentamethylchroman-6-sulphonyl\tC14H19O3S\r\n81\tPro\tProline diradical\tC5H7NO\r\n82\tPyr\tPyroglutamine\tC5H5NO2\r\n83\tSar\tSarcosine diradical\tC3H5NO\r\n84\tSer\tSerine diradical\tC3H5NO2\r\n85\tSerp\tSerine triradical\tC3H4NO2\r\n86\tSta\tStatine diradical\tC8H15NO2\r\n87\tStap\tStatine triradical\tC8H14NO2\r\n88\tTacm\tTrimethylacetamidomethyl\tC6H12NO\r\n89\tTbdms\tt-Butyldimethylsilyl\tC6H15Si\r\n90\tTbu\tt-Butyl\tC4H9\r\n91\tTbuo\tt-Butoxy\tC4H9O\r\n92\tTbuthio\tt-Butylthio\tC4H9S\r\n93\tTfa\tTrifluoroacetyl\tC2F3O\r\n94\tThi\tbeta-(2-thenyl)alanine\tC7H7NOS\r\n95\tThr\tThreonine diradical\tC4H7NO2\r\n96\tThrp\tThreonine triradical\tC4H6NO2\r\n97\tTips\tTriisopropylsilyl\tC9H21Si\r\n98\tTms\tTrimethylsilyl\tC3H9Si\r\n99\tTos\tTosyl\tC7H7O2S\r\n100\tTrp\tTryptophan diradical\tC11H10N2O\r\n101\tTrpp\tTryptophan triradical\tC11H9N2O\r\n102\tTrt\tTrityl\tC19H15\r\n103\tTyr\tTyrosine diradical\tC9H9NO2\r\n104\tTyrp\tTyrosine triradical\tC9H8NO2\r\n105\tVal\tValine\tC5H9NO\r\n106\tValoh\tbeta-Hydroxyvaline diradical\tC5H9NO2\r\n107\tValohp\tbeta-Hydroxyvaline triradical\tC5H8NO2\r\n108\tXan\tXanthyl\tC13H9O\r\n109\tZ\tBenzyloxycarbonyl\tC8H7O2\r\n110\tT\tTritium\t[3H]",'[\r\n]+',0);for(f=0;f<k.length;f++){m=Rj(k[f],'\t',0);try{jn(Ht,m[1],new Ct(m[1],m[2],m[3],Gt,Ht))}catch(a){a=Ig(a);if(!ae(a,4))throw Hg(a)}}}
var Uu=2147483647,Vu={3:1,9:1},Wu={3:1,7:1,9:1},Xu={3:1},Yu=4194303,Zu=1048575,$u=524288,_u=4194304,av=17592186044416,bv=-9223372036854775808,cv=1000000000,dv=65536,ev=-2147483648,fv=65535,gv={28:1,3:1},hv=100000,iv=1000000,jv=10000000000,kv=0.3010299956639812,lv=4294967296,mv=1073741824,nv={35:1},ov={37:1,27:1},pv={3:1,51:1},qv={3:1,50:1},rv={3:1,18:1,29:1,26:1},sv=4.9E-324,tv=5.4857990946E-4;var _,Lh,Jg={},Fg=-1;Lg(1,null,{},eb);_.eQ=function fb(a){return this===a};_.gC=function hb(){return this.cZ};_.hC=function jb(){return Ob(this)};_.tS=function lb(){return db(this)};_.toString=function(){return this.tS()};Zd={3:1,116:1,18:1,2:1};Og();var Zd;Lg(68,1,{},wi);_.B=function xi(a){var b;b=new wi;b.j=4;a>1?(b.f=Ei(this,a-1)):(b.f=this);return b};_.C=function Di(){ui(this);return this.e};_.D=function Fi(){return vi(this)};_.F=function Hi(){ui(this);return this.o};_.G=function Ji(){return (this.j&4)!=0};_.H=function Ki(){return (this.j&1)!=0};_.tS=function Ni(){return ((this.j&2)!=0?'interface ':(this.j&1)!=0?'':'class ')+(ui(this),this.q)};_.j=0;_.n=0;var ti=1;var _e=zi(1),ne=zi(0),Pe=zi(68);Lg(9,1,Vu);_.r=function qb(){return this.k};_.tS=function rb(){return pb(this)};var gf=zi(9);Lg(7,9,Wu);var Te=zi(7);Lg(10,7,Wu,ub);var af=zi(10);Lg(83,10,Wu);var pe=zi(83);Lg(38,83,{38:1,3:1,7:1,9:1},yb);_.r=function zb(){xb(this);return this.f};var vb;var me=zi(38);var Bb;Lg(117,1,{});var oe=zi(117);var Fb=0,Gb=0,Hb=0,Ib=-1;Lg(138,1,{});var mf=zi(138);Lg(139,138,{});var nf=zi(139);Lg(112,139,{},Yb);_.e={l:0,m:0,h:0};_.f=0;var Tb;var qe=zi(112);Lg(107,117,{},ic);var ec;var re=zi(107);var lc;Lg(133,1,{});var ve=zi(133);Lg(84,133,{},rc);_.s=function sc(a,b){var c={},j;a.fnStack=[];var d=arguments.callee.caller;while(d){var e=(mc(),d.name||(d.name=pc(d.toString())));a.fnStack.push(e);var f=':'+e;var g=c[f];if(g){var h,i;for(h=0,i=g.length;h<i;h++){if(g[h]===d){return}}}(g||(c[f]=[])).push(d);d=d.caller}};_.t=function tc(a){var b,c,d,e;d=(mc(),a&&a.fnStack&&a.fnStack instanceof Array?a.fnStack:[]);c=d.length;e=Td(bf,Xu,31,c,0,1);for(b=0;b<c;b++){e[b]=new Fj(d[b],null,-1)}return e};var se=zi(84);Lg(134,133,{});_.s=function wc(c,d){function e(b){if(!('stack' in b)){try{throw b}catch(a){}}return b}
var f;typeof d=='string'?(f=e(new Error(d))):d instanceof Object&&'stack' in d?(f=d):(f=e(new Error));c.__gwt$backingJsError=f};_.u=function xc(a,b,c,d){return new Fj(b,a+'@'+d,c<0?-1:c)};_.t=function yc(a){var b,c,d,e,f,g,h;e=(mc(),h=a.__gwt$backingJsError,h&&h.stack?h.stack.split('\n'):[]);f=Td(bf,Xu,31,0,0,1);b=0;d=e.length;if(d==0){return f}g=vc(this,e[0]);Kj(g.g,'anonymous')||(f[b++]=g);for(c=1;c<d;c++){f[b++]=vc(this,e[c])}return f};var ue=zi(134);Lg(85,134,{},zc);_.u=function Ac(a,b,c,d){return new Fj(b,a,-1)};var te=zi(85);Lg(132,1,{});
_.w=function Lc(){return null};var De=zi(132);Lg(66,132,{66:1},Pc,Qc);_.eQ=function Rc(a){if(!ae(a,66)){return false}return this.d==a.d};_.v=function Sc(){return Vc};_.hC=function Tc(){return Ob(this.d)};_.tS=function Uc(){var a,b,c;c=new vk('[');for(b=0,a=this.d.length;b<a;b++){b>0&&(c.d+=',',c);qk(c,Mc(this,b))}c.d+=']';return c.d};var we=zi(66);Lg(76,132,{},Zc);_.v=function $c(){return ad};_.tS=function _c(){return fi(),''+this.d};_.d=false;var Wc,Xc;var xe=zi(76);Lg(110,10,Wu,bd);var ye=zi(110);Lg(106,132,{},ed);_.v=function fd(){return hd};_.tS=function gd(){return 'null'};var cd;var ze=zi(106);Lg(8,132,{8:1},jd);_.eQ=function kd(a){if(!ae(a,8)){return false}return this.d==a.d};_.v=function ld(){return od};_.hC=function md(){return he((new Si(this.d)).d)};_.tS=function nd(){return this.d+''};_.d=0;var Ae=zi(8);Lg(54,132,{54:1},ud,vd);_.eQ=function wd(a){if(!ae(a,54)){return false}return this.d==a.d};_.v=function xd(){return Ad};_.hC=function yd(){return Ob(this.d)};_.tS=function zd(){var a,b,c,d,e,f;f=new vk('{');a=true;e=pd(this,Td(ff,Xu,2,0,4,1));for(c=0,d=e.length;c<d;++c){b=e[c];a?(a=false):(f.d+=', ',f);rk(f,Db(b));f.d+=':';qk(f,qd(this,b))}f.d+='}';return f.d};var Be=zi(54);var Bd;Lg(11,132,{11:1},Jd);_.eQ=function Kd(a){if(!ae(a,11)){return false}return Kj(this.d,a.d)};_.v=function Ld(){return Pd};_.hC=function Md(){return kk(this.d)};_.w=function Nd(){return this};_.tS=function Od(){return Db(this.d)};var Ce=zi(11);var Sg;var ih;var Gh,Hh,Ih,Jh;Lg(60,9,Vu);var Se=zi(60);Lg(17,60,Vu);var Ne=zi(17);Lg(78,17,Vu,Vh);var Ie=zi(78);Lg(45,1,{});_.tS=function Zh(){return this.d};var Je=zi(45);Lg(41,10,Wu,$h);var Ke=zi(41);Lg(49,10,Wu,_h,ai);var We=zi(49);Lg(109,49,Wu,bi);var Le=zi(109);Lg(43,10,Wu,ci);var Me=zi(43);Lg(52,1,{3:1,52:1,18:1},gi);_.A=function ii(a){return hi(this.d,a.d)};_.eQ=function ji(a){return ae(a,52)&&a.d==this.d};_.hC=function ki(){return this.d?1231:1237};_.tS=function li(){return ''+this.d};_.d=false;var di,ei;var Oe=zi(52);Lg(44,1,{3:1,44:1});var Oi;var $e=zi(44);Lg(6,44,{3:1,18:1,6:1,44:1},Si);_.A=function Ui(a){return Ti(this.d,a.d)};_.eQ=function Vi(a){return Ri(this,a)};_.hC=function Wi(){return he(this.d)};_.tS=function Zi(){return ''+this.d};_.d=0;var Qe=zi(6);Lg(29,1,{3:1,18:1,29:1});_.A=function _i(a){return this.e-a.e};_.eQ=function aj(a){return this===a};_.hC=function bj(){return Ob(this)};_.tS=function cj(){return this.d!=null?this.d:''+this.e};_.e=0;var Re=zi(29);Lg(56,10,Wu,dj);var Ue=zi(56);Lg(111,10,Wu,ej);var Ve=zi(111);Lg(19,44,{3:1,18:1,19:1,44:1},gj);_.A=function ij(a){return fj(this,a)};_.eQ=function jj(a){return ae(a,19)&&a.d==this.d};_.hC=function kj(){return this.d};_.tS=function nj(){return ''+this.d};_.d=0;var Xe=zi(19);var qj;Lg(59,10,Wu,Cj,Dj);var Ye=zi(59);Lg(20,56,{3:1,7:1,20:1,9:1},Ej);var Ze=zi(20);Lg(31,1,{3:1,31:1},Fj);_.eQ=function Gj(a){var b;if(ae(a,31)){b=a;return this.f==b.f&&Qq(this.g,b.g)&&Qq(this.d,b.d)&&Qq(this.e,b.e)}return false};_.hC=function Hj(){return hp(Wd(Sd(_e,1),Xu,1,3,[pj(this.f),this.d,this.g,this.e]))};_.tS=function Ij(){return this.d+'.'+this.g+'('+(this.e!=null?this.e:'Unknown Source')+(this.f>=0?':'+this.f:'')+')'};_.f=0;var bf=zi(31);var ff=zi(2);var fk,gk=0,hk;Lg(34,45,{116:1},nk,ok);var cf=zi(34);Lg(23,45,{116:1},tk,uk,vk);var df=zi(23);Lg(67,49,Wu,wk);var ef=zi(67);Lg(42,10,Wu,yk,zk);var hf=zi(42);Lg(14,44,{3:1,18:1,44:1,14:1},Pk,Qk,Rk,Sk);_.A=function Vk(a){return Jk(this,a)};_.eQ=function Yk(a){var b;if(this===a){return true}if(ae(a,14)){b=a;return b.j==this.j&&(this.d<54?b.k==this.k:nl(this.f,b.f))}return false};_.hC=function Zk(){var a;if(this.e!=0){return this.e}if(this.d<54){a=nh(this.k);this.e=Dh(kh(a,{l:Yu,m:Yu,h:Zu}));this.e=33*this.e+Dh(kh(zh(a,32),{l:Yu,m:Yu,h:Zu}));this.e=17*this.e+he(this.j);return this.e}this.e=17*ql(this.f)+he(this.j);return this.e};_.tS=function al(){return Ok(this)};_.d=0;_.e=0;_.g=0;_.j=0;_.k=0;var Ak,Bk,Ck,Dk,Ek,Fk,Gk,Hk;var jf=zi(14);Lg(5,44,{3:1,18:1,44:1,5:1},yl,zl,Al,Bl,Cl,Dl);_.A=function Fl(a){return kl(this,a)};_.eQ=function Gl(a){return nl(this,a)};_.hC=function Il(){return ql(this)};_.tS=function Kl(){return Yl(this,0)};_.e=-2;_.f=0;_.g=0;_.j=0;var cl,dl,el,fl,gl,hl;var kf=zi(5);var Tl,Ul;var km,lm,mm;Lg(24,29,{3:1,18:1,29:1,24:1},Hm);var ym,zm,Am,Bm,Cm,Dm,Em,Fm;var lf=Ai(24,Im);Lg(130,1,{});_.J=function Nm(a){return Km(this,a)};_.L=function Om(a){var b,c,d;d=this.K();a.length<d&&(a=Rd(a,d));c=this.I();for(b=0;b<d;++b){a[b]=c.S()}a.length>d&&(a[d]=null);return a};_.tS=function Pm(){return Mm(this)};var of=zi(130);Lg(129,1,{50:1});_.M=function Tm(a){return Qm(this,a)};_.N=function Um(a){return !!Rm(this,a)};_.eQ=function Vm(a){var b,c,d;if(a===this){return true}if(!ae(a,50)){return false}d=a;if(this.K()!=d.K()){return false}for(c=d.O().I();c.R();){b=c.S();if(!this.M(b)){return false}}return true};_.P=function Wm(a){return Ym(Rm(this,a))};_.hC=function Zm(){return mp(this.O())};_.K=function $m(){return this.O().K()};_.tS=function _m(){var a,b,c,d;d=new vk('{');a=false;for(c=this.O().I();c.R();){b=c.S();a?(d.d+=', ',d):(a=true);rk(d,Sm(this,b.X()));d.d+='=';rk(d,Sm(this,b.Y()))}d.d+='}';return d.d};var Df=zi(129);Lg(79,129,{50:1});_.N=function kn(a){return an(this,a)};_.O=function ln(){return new rn(this)};_.P=function mn(a){return en(this,a)};_.Q=function nn(a,b){return hn(this,a,b)};_.K=function on(){return this.e};_.e=0;var rf=zi(79);Lg(131,130,nv);_.eQ=function pn(a){var b;if(a===this){return true}if(!ae(a,35)){return false}b=a;if(b.K()!=this.K()){return false}return Lm(this,b)};_.hC=function qn(){return mp(this)};var If=zi(131);Lg(61,131,nv,rn);_.J=function sn(a){if(ae(a,27)){return Qm(this.d,a)}return false};_.I=function tn(){return new xn(this.d)};_.K=function un(){return this.d.e};var qf=zi(61);Lg(62,1,{},xn);_.R=function yn(){return vn(this)};_.S=function zn(){return wn(this)};var pf=zi(62);Lg(135,130,{51:1});_.T=function An(a,b){throw new zk('Add not supported on this list')};_.U=function Bn(a){this.T(this.K(),a);return true};_.eQ=function Cn(a){var b,c,d,e,f;if(a===this){return true}if(!ae(a,51)){return false}f=a;if(this.K()!=f.K()){return false}e=f.I();for(c=this.I();c.d<c.f.K();){b=(Ec(c.d<c.f.K()),c.f.V(c.e=c.d++));d=(Ec(e.d<e.f.K()),e.f.V(e.e=e.d++));if(!(fe(b)===fe(d)||b!=null&&gb(b,d))){return false}}return true};_.hC=function Dn(){return np(this)};_.I=function En(){return new Jn(this)};_.W=function Fn(a){throw new zk('Remove not supported on this list')};var uf=zi(135);Lg(21,1,{},Jn);_.R=function Kn(){return Gn(this)};_.S=function Ln(){return Hn(this)};_.d=0;_.e=-1;var sf=zi(21);Lg(90,21,{},Mn);var tf=zi(90);Lg(63,131,nv,On);_.J=function Pn(a){return an(this.d,a)};_.I=function Qn(){return Nn(this)};_.K=function Rn(){return this.d.e};var wf=zi(63);Lg(81,1,{},Tn);_.R=function Un(){return vn(this.d)};_.S=function Vn(){return Sn(this)};var vf=zi(81);Lg(25,130,{},Xn);_.J=function Yn(a){return bn(this.d,a)};_.I=function Zn(){return Wn(this)};_.K=function $n(){return this.d.e};var yf=zi(25);Lg(82,1,{},ao);_.R=function bo(){return vn(this.d)};_.S=function co(){return _n(this)};var xf=zi(82);Lg(37,1,ov);_.eQ=function go(a){var b;if(!ae(a,27)){return false}b=a;return Qq(this.f,b.X())&&Qq(this.g,b.Y())};_.X=function ho(){return this.f};_.Y=function io(){return this.g};_.hC=function jo(){return Rq(this.f)^Rq(this.g)};_.Z=function ko(a){return eo(this,a)};_.tS=function lo(){return this.f+'='+this.g};var zf=zi(37);Lg(53,37,{37:1,53:1,27:1},mo);var Af=zi(53);Lg(80,37,ov,no);_.Z=function oo(a){throw new yk};var Bf=zi(80);Lg(136,1,{27:1});_.eQ=function po(a){var b;if(!ae(a,27)){return false}b=a;return Qq(this.X(),b.X())&&Qq(this.Y(),b.Y())};_.hC=function qo(){return Rq(this.X())^Rq(this.Y())};_.tS=function ro(){return this.X()+'='+this.Y()};var Cf=zi(136);Lg(137,129,{50:1});_.M=function xo(a){return so(this,a)};_.N=function yo(a){return to(this,a)};_.O=function zo(){return new Co(this)};_.P=function Ao(a){return uo(this,a)};var Hf=zi(137);Lg(73,131,nv,Co);_.J=function Do(a){return ae(a,27)&&so(this.d,a)};_.I=function Eo(){return this.d.$()};_.K=function Fo(){return this.d.K()};var Ef=zi(73);Lg(13,131,nv,Ho);_.J=function Io(a){return to(this.d,a)};_.I=function Jo(){return Go(this)};_.K=function Ko(){return this.d.g};var Gf=zi(13);Lg(97,1,{},Mo);_.R=function No(){return Gn(this.d.d)};_.S=function Oo(){return Lo(this)};var Ff=zi(97);Lg(46,135,pv,Yo,Zo);_.T=function $o(a,b){Qo(this,a,b)};_.U=function _o(a){return Ro(this,a)};_.J=function ap(a){return To(this,a,0)!=-1};_.V=function bp(a){return So(this,a)};_.W=function cp(a){return Uo(this,a)};_.K=function dp(){return this.e.length};_.L=function gp(a){return Xo(this,a)};var Jf=zi(46);var pp;Lg(108,1,{},rp);_.ab=function sp(a,b){Gc(a);Gc(b);return _j(a,b)};var Kf=zi(108);Lg(115,10,Wu,wp);var Lf=zi(115);Lg(114,10,Wu,xp);var Mf=zi(114);Lg(22,79,qv,Ap);var Nf=zi(22);Lg(75,1,{},Ip);_.bb=function Jp(a){var b,c,d,e,f,g,h,i;for(g=Fp(this),h=0,i=g.length;h<i;++h){f=g[h];for(c=this.d[f],d=0,e=c.length;d<e;++d){b=c[d];if(yp(a,b.Y())){return true}}}return false};_.cb=function Kp(){return Object.create(null)};_.db=function Lp(){return new Np(this)};var Rf=zi(75);Lg(102,1,{},Np);_.R=function Op(){return Mp(this)};_.S=function Pp(){return Ec(Mp(this)),this.j=this.d[this.f++],this.j};_.e=-1;_.f=0;_.j=null;var Of=zi(102);Lg(100,75,{},Qp);_.bb=function Rp(a){var b=this.d;for(var c in b){if(c==parseInt(c,10)){var d=b[c];for(var e=0,f=d.length;e<f;++e){var g=d[e];var h=g.Y();if(this.eb(a,h)){return true}}}}return false};_.cb=function Sp(){return {}};_.db=function Tp(){var a=this.fb();var b=this.d;for(var c in b){if(c==parseInt(c,10)){var d=b[c];for(var e=0,f=d.length;e<f;++e){a.U(d[e])}}}return a.I()};_.eb=function Up(a,b){return fe(a)===fe(b)||a!=null&&gb(a,b)};_.fb=function Vp(){return new Wp(this)};var Qf=zi(100);Lg(101,46,pv,Wp);_.W=function Xp(a){var b;return b=Uo(this,a),Hp(this.d,b.X()),b};var Pf=zi(101);Lg(103,1,{},Yp);_.gb=function Zp(){return new Ip};_.hb=function $p(){return new nq};var Uf=zi(103);var _p;Lg(105,103,{},dq);_.hb=function eq(){return new Mq};var Sf=zi(105);Lg(104,103,{},fq);_.gb=function gq(){return new Qp};_.hb=function hq(){return new Dq};var Tf=zi(104);Lg(64,1,{},nq);_.bb=function oq(a){return iq(this,a)};_.ib=function pq(){return Object.create(null)};_.db=function qq(){var a;a=this.lb();return new wq(this,a)};_.jb=function rq(a,b){return fe(a)===fe(b)||a!=null&&gb(a,b)};_.kb=function sq(a){return this.d[a]};_.lb=function tq(){return jq(this)};_.mb=function uq(a){return new zq(this,a)};_.nb=function vq(a,b){return kq(this,a,b)};var $f=zi(64);Lg(89,1,{},wq);_.R=function xq(){return this.d<this.f.length};_.S=function yq(){return Ec(this.d<this.f.length),new zq(this.e,this.f[this.d++])};_.d=0;var Vf=zi(89);Lg(71,136,{27:1},zq);_.X=function Aq(){return this.e};_.Y=function Bq(){return this.d.kb(this.e)};_.Z=function Cq(a){return this.d.nb(this.e,a)};var Wf=zi(71);Lg(86,64,{},Dq);_.bb=function Eq(a){var b=this.d;for(var c in b){if(c.charCodeAt(0)==58){var d=b[c];if(this.jb(a,d)){return true}}}return false};_.ib=function Fq(){return {}};_.db=function Gq(){var a=this.ob();for(var b in this.d){if(b.charCodeAt(0)==58){var c=this.mb(b.substring(1));a.U(c)}}return a.I()};_.kb=function Hq(a){return this.d[':'+a]};_.ob=function Iq(){return new Kq(this)};_.nb=function Jq(a,b){return kq(this,':'+a,b)};var Yf=zi(86);Lg(88,46,pv,Kq);_.W=function Lq(a){var b;return b=Uo(this,a),lq(this.d,':'+b.X()),b};var Xf=zi(88);Lg(87,64,{},Mq);_.bb=function Nq(a){var b;b=this.d['__proto__'];if(!(b===undefined)&&(fe(a)===fe(b)||a!=null&&gb(a,b))){return true}return iq(this,a)};_.lb=function Oq(){var a;a=jq(this);!(this.d['__proto__']===undefined)&&(a[a.length]='__proto__');return a};var Zf=zi(87);var _f=Bi();Lg(77,10,Wu,Pq);var ag=zi(77);Lg(74,135,pv,Tq);_.T=function Uq(a,b){Wq(a,this.d.e.length+1);Qo(this.d,a,b)};_.U=function Vq(a){return Sq(this,a)};_.J=function Xq(a){return To(this.d,a,0)!=-1};_.V=function Yq(a){return Wq(a,this.d.e.length),So(this.d,a)};_.I=function Zq(){return new Jn(this.d)};_.W=function $q(a){return Wq(a,this.d.e.length),this.d.W(a)};_.K=function _q(){return this.d.e.length};_.L=function ar(a){return Xo(this.d,a)};_.tS=function br(){return Mm(this.d)};var mg=zi(74);Lg(113,74,pv,er);var bg=zi(113);Lg(58,137,qv,ur,vr);_.$=function wr(){return new Cr(this)};_.O=function xr(){return new Gr(this)};_._=function yr(a){var b,c,d;d=this.f;while(d){b=this.e.ab(a,d.f);if(b==0){return d}c=b<0?0:1;d=d.d[c]}return null};_.K=function zr(){return this.g};_.g=0;var kg=zi(58);Lg(72,1,{},Cr);_.R=function Er(){return Gn(this.d)};_.S=function Fr(){return Ar(this)};var cg=zi(72);Lg(12,73,nv,Gr);var dg=zi(12);Lg(40,53,{37:1,53:1,27:1,40:1},Hr);_.e=false;var eg=zi(40);Lg(65,1,{},Ir);_.tS=function Jr(){return 'State: mv='+this.f+' value='+this.g+' done='+this.d+' found='+this.e};_.d=false;_.e=false;_.f=false;var fg=zi(65);Lg(26,29,rv,Pr);_.pb=function Qr(){return false};_.qb=function Rr(){return false};var Kr,Lr,Mr,Nr;var jg=Ai(26,Sr);Lg(94,26,rv,Tr);_.qb=function Ur(){return true};var gg=Ai(94,null);Lg(95,26,rv,Vr);_.pb=function Wr(){return true};_.qb=function Xr(){return true};var hg=Ai(95,null);Lg(96,26,rv,Yr);_.pb=function Zr(){return true};var ig=Ai(96,null);Lg(57,131,{3:1,35:1},_r,as);_.J=function bs(a){return to(this.n,a)};_.I=function cs(){return Go(new Ho(this.n))};_.K=function ds(){return this.n.g};var lg=zi(57);Lg(32,1,{18:1,32:1},ks,ls,ms,ns);_.A=function os(a){if(!ae(a,32))throw new zk('Not comparable: Atoms and '+vi(ib(a)));return es(this,a)};_.eQ=function ps(a){return fs(this,a)};_.hC=function qs(){var a;a=this.d+this.o;return kk(a)};_.tS=function rs(){return js(this,null)};_.d=0;_.e=0;_.f=0;_.g=0;_.j=0;_.k=0;_.n=0;var ng=zi(32);Lg(33,58,qv,Gs);_.tS=function Hs(){return Ds(this)};_.d=10000;var pg=zi(33);Lg(98,1,{},Is);_.ab=function Js(a,b){return -_j(a.Y(),b.Y())};var og=zi(98);Lg(55,1,{18:1},Ps,Qs,Rs);_.A=function Ss(a){this.n+'-'+a.n;return $j(this.n,a.n)};_.eQ=function Ts(a){var b;if(this===a)return true;if(qg!=ib(a))return false;b=a;if(Kj(this.n,b.n))return true;return false};_.tS=function Us(){return Os(this)};_.d=0;_.f=0;_.g=0;_.k=0;var qg=zi(55);Lg(99,1,{18:1},Ys);_.A=function Zs(a){return fj(new gj(this.d.f-this.d.g),pj(a.d.f-a.d.g))};_.tS=function $s(){return this.d.o+' - '+this.d.g+' to '+this.d.f+' - current: '+this.e};_.e=0;_.f=0;_.g=0;var rg=zi(99);Lg(47,1,{},ht,it);_.tS=function jt(){return gt(this)};_.f=false;_.j=false;var tg=zi(47);Lg(30,57,{3:1,35:1},vt,wt,xt);_.tS=function yt(){return ut(this)};_.d=0;_.e='';_.j=false;_.k=0;var sg=zi(30);Lg(70,1,{},Ct);var ug=zi(70);Lg(39,1,{18:1,39:1},Dt);_.A=function Et(a){var b;if(ae(a,39)){b=a;return this.f=b.f}else throw new zk('Cannot compare Isotope to '+a)};_.tS=function Ft(){return 'Number: '+this.f+' - mass: '+this.e+' - percentage: '+this.g+' - symbol: '+this.d};_.e=0;_.f=0;_.g=0;var vg=zi(39);var Gt,Ht;Lg(4,7,{3:1,7:1,9:1,4:1},Jt);var wg=zi(4);Lg(91,1,{},Rt);_.d=0;_.e=0;_.j=null;_.k=0;var Kt=1;var zg=zi(91);Lg(48,1,{},$t,_t,au);_.e=0;var yg=zi(48);Lg(92,1,{},cu);_.ab=function du(a,b){return bu(this,a,b)};var xg=zi(92);var eu;Lg(93,1,{},ju);_.d=0;_.e=0;_.f=null;var Ag=zi(93);var ku;Lg(128,1,{},qu);_.rb=function pu(){};var ou=null;var Bg=zi(128);Lg(69,1,{18:1},Ju);_.A=function Ku(a){return Iu(this,a)};_.d=0;_.f=0;var Cg=zi(69);Lg(16,1,{},Mu,Nu,Ou);var Dg=zi(16);Lg(15,1,{},Su);var Eg=zi(15);var le=Ci('I'),Ee=zi(119),Fe=zi(121),Ge=zi(null),He=zi(124),ie=Ci('B'),ke=Ci('D'),_f=Bi(),je=Ci('C');_=Qg('$wnd.CI.Chemcalc');_.analyseMF=tu;_.chargePeptide=uu;_.convertAASequence=wu;_.generatePeptideFragments=yu;_.getInfo=zu;_.mfFromMonoisotopicMass=Au;_.aa=ou;var Tu=Ph();var gwtOnLoad=gwtOnLoad=Oh;Mh(Sh);Qh('permProps',[[['user.agent','safari']]]);$sendStats('moduleStartup', 'moduleEvalEnd');gwtOnLoad(__gwtModuleFunction.__errFn, __gwtModuleFunction.__moduleName, __gwtModuleFunction.__moduleBase, __gwtModuleFunction.__softPermutationId,__gwtModuleFunction.__computePropValue);$sendStats('moduleStartup', 'end');$gwt && $gwt.permProps && __gwtModuleFunction.__moduleStartupDone($gwt.permProps);
//# sourceURL=chemcalc-0.js

        // End GWT code

        var toReturn = $wnd["CI"]["Chemcalc"];

        toReturn.version = '2.1.4';

        return toReturn;
    }

    var fakeWindow = {};

    if (typeof module !== 'undefined' && module.exports) { // NodeJS
        var timers = require('timers');
        fakeWindow.setTimeout = timers.setTimeout;
        fakeWindow.clearTimeout = timers.clearTimeout;
        fakeWindow.setInterval = timers.setInterval;
        fakeWindow.clearInterval = timers.clearInterval;
        fakeWindow.document = {};
        module.exports = getExports(fakeWindow);
    } else { // Browser
        if (true) {
            // Timer proxies
            fakeWindow.setTimeout = window.setTimeout.bind(window);
            fakeWindow.clearTimeout = window.clearTimeout.bind(window);
            fakeWindow.setInterval = window.setInterval.bind(window);
            fakeWindow.clearInterval = window.clearInterval.bind(window);
            fakeWindow.document = window.document;
        } else {
            fakeWindow = window;
        }

        if (typeof define === 'function' && define.amd) { // AMD
            define(function () {
                return getExports(fakeWindow);
            });
        } else { // Global
            var path = ["CI","Chemcalc"];
            var l = path.length - 1;
            var obj = window;
            for (var i = 0; i < l; i++) {
                obj = obj[path[i]] || (obj[path[i]] = {});
            }
            obj[path[l]] = getExports(fakeWindow);
        }
    }

})();

},{"timers":3}],10:[function(require,module,exports){
'use strict';

var CC = require('chemcalc');

// Chemcalc cache in order not to recalculate all the time
// Also keeps one chemical formula for every product that has the same molecular weight

var chemcalcs = {};
var cByMW = {};

module.exports = {
    reset: function() {
        chemcalcs = {};
        cByMW = {};
    },

    getCC: function(c) {
        if(!chemcalcs[c]) {
            var r = CC.analyseMF(c);
            if(r.error) {
                throw new Error('chemcalc error on' + c + ': ' + r.error);
            }
            if(!cByMW[''+r.mw]) cByMW[''+r.mw] = c;
            chemcalcs[c] = r;
        }
        return chemcalcs[c];
    },

    norm: function(c) {
        var cc = module.exports.getCC(c);
        return cByMW[''+cc.mw];
    }
};
},{"chemcalc":9}],11:[function(require,module,exports){
'use strict';

var cache = require('./cc-cache');

module.exports = {
    // For example 'OH- -> H2O - H+'
    // returns
    // {
    //   reactives: [{c: 'H+', n: 1}],
    //   products: [{c: 'H2O', n: 1}, {c: 'H+', n: -1}]
    // }


    parseReaction: function(r, options) {
        var parsed = {reactives: [], products: []};
        // TODO: add options for constraints on how should the reactions be like
        //       max number of reactives etc...
        var defaultOptions = {

        };
        // Separate reactives and products
        var rp = r.split(' -> ');
        if(rp.length !== 2) {
            throw new Error('Invalid reaction');
        }

        var reactives = rp[0];
        var products = rp[1];

        parsed.reactives = parseElements(reactives);
        parsed.products = parseElements(products);



        // Split reactives with

        //
        //// Analyse each reactive and product
        //for(var i=0; i<reactives.length; i++) {
        //    var parsedReactive = parseReactionElement(reactives[i]);
        //    // Make sure chemcalc can process this element
        //    parsedReactive.c = cache.norm(parsedReactive.c);
        //    parsed.reactives.push(parsedReactive);
        //}
        //for(i=0; i<products.length; i++) {
        //    var parsedProduct = parseReactionElement(products[i]);
        //    // Make sure chemcalc can process this element
        //    parsedProduct.c = cache.norm(parsedProduct.c);
        //    parsed.products.push(parsedProduct);
        //}
        return parsed;
    }
};

function parseElements(els) {
    els = els.split(/\s+/);
    var r = [];
    var sign = 1;
    var n = 1;
    for(var i=0; i<els.length; i++) {
        if(els[i] === '-') {
            sign = -1;
            n = 1;
            continue;
        }
        if(els[i] === '+') {
            sign = 1;
            n = 1;
            continue;
        }
        if(!isNaN(+els[i])) {
            n = +els[i];
            continue;
        }
        r.push({
            c: cache.norm(els[i]),
            n: sign * n
        });
    }
    var count = {};
    for(i=0; i< r.length; i++) {
        if(!count[r[i].c]) count[r[i].c] = r[i].n;
        else count[r[i].c] += r[i].n;
    }

    var rr = [];
    for(var key in count) {
        rr.push({
            c: key,
            n: count[key]
        });
    }
    return rr;
}

function parseReactionElement(el) {
    var parsed = {};
    var reactive;
    reactive = el.split('*');
    if(reactive.length > 2) throw new Error('Invalid reactive ' + el);
    if(reactive.length === 2) {
        parsed.n = +(reactive[0]);
        parsed.c = reactive[1].trim();
    }
    else {
        parsed.n = 1;
        parsed.c = reactive[0].trim();
    }
    return parsed;
}

},{"./cc-cache":10}]},{},[1])(1)
});